/* eslint-disable */
const i18n = {
  "zh-TW": {
    "marketing.new_pricing.full_plan": "\u5B8C\u6574\u8A08\u756B\u6BD4\u8F03",
    "one.meetingFeature": "會議功能",
    "one.phoneFeature": "電話功能",
    "phoneAdminFeatures": "Phone Admin Features",
    "common.basic": "\u514D\u8D39",
    "one.lite": "基礎版 Plus",
    "common.pro": "Pro",
    "common.business": "\u5546\u696D",
    "one.bizPlus": "商業版 Plus",
    "common.enterprise": "企業版",
    "meetings.fullPlanItem1": "\u8207\u6703\u8005\u5BB9\u91CF",
    "meetings.fullPlanItem1Tip": "\u8207\u6703\u8005\u662F\u6703\u8B70\u7684\u53D7\u9080\u4EBA\uFF0C\u8A72\u6703\u8B70\u662F\u7531\u5177\u6709\u6703\u8B70\u6388\u6B0A\u7684\u4EBA\u8CA0\u8CAC\u6392\u7A0B\u3002\u8207\u6703\u8005\u53EF\u4EE5\u5F9E\u96FB\u8A71\u3001\u684C\u4E0A\u578B\u96FB\u8166\u3001\u884C\u52D5\u548C\u5E73\u677F\u88DD\u7F6E\uFF0C\u514D\u8CBB\u52A0\u5165\u60A8\u7684\u6703\u8B70\u3002\u8207\u6703\u8005\u4E0D\u9700\u8981 Zoom \u5E33\u6236\u5373\u53EF\u53C3\u52A0\u6703\u8B70\u3002\u6BCF\u500B\u8A08\u756B\u90FD\u6709\u8207\u6703\u8005\u4EBA\u6578\u9650\u5236\uFF0C\u4F46\u4F7F\u7528\u8005\u53EF\u900F\u904E\u8CFC\u8CB7\u9644\u52A0\u8A08\u756B\u4F86\u589E\u52A0\u4ED8\u8CBB\u8A08\u756B\u7684\u4EBA\u6578\u9650\u5236\u3002",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*企業版 Plus 為 1,000 名</span>",
    "meetings.fullPlanItem2": "\u6388\u6B0A\u6578",
    "meetings.fullPlanItem2Tip": "\u60A8\u5728\u4E00\u500B\u5E33\u6236\u4E2D\u7684\u57FA\u672C\u4F7F\u7528\u8005\u7121\u9650\u5236\uFF0C\u4F46\u6BCF\u500B\u8A08\u756B\u5C0D\u65BC\u4F7F\u7528\u8005\u53EF\u6307\u6D3E\u591A\u5C11\u500B\u6703\u8B70\u6388\u6B0A\u5247\u6709\u7279\u5B9A\u9650\u5236\u3002",
    "meetings.fullPlanItem6": "\u6280\u8853\u652F\u63F4",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime.",
    "meetings.fullPlanItem6_basic": "\u50C5\u9650\u7968\u8B49",
    "meetings.fullPlanItem6_pro": "\u7968\u8B49\u548C\u7DDA\u4E0A\u804A\u5929",
    "meetings.fullPlanItem6_biz": "\u7968\u8B49\u3001\u7DDA\u4E0A\u804A\u5929\u548C\u96FB\u8A71",
    "meetings.fullPlanItem6_ent": "\u7968\u8B49\u3001\u7DDA\u4E0A\u804A\u5929\u548C\u96FB\u8A71",
    "meetings.fullPlanItem3": "\u8A08\u8CBB\u9031\u671F\u548C\u689D\u6B3E",
    "meetings.fullPlanItem3_basic": "免費",
    "meetings.fullPlanItem3_pro": "\u6309\u6708\u6216\u6309\u5E74",
    "meetings.fullPlanItem3_biz": "\u6309\u6708\u6216\u6309\u5E74<span class cell-desc>*\u591A\u5E74\u5408\u7D04\u53EF\u900F\u904E\u806F\u7D61<a tabindex=\"-1\" href=\"https://zoom.us/zh-tw/contactsales.html\">\u92B7\u552E\u4EBA\u54E1</a>\u53D6\u5F97</span>",
    "meetings.fullPlanItem3_ent": "\u5E74\u5EA6\u5408\u7D04\u50C5 <span class cell-desc>*\u53EF\u4E00\u6B21\u4ED8\u6E05\u6216\u6309\u6708\u652F\u4ED8</span>",
    "meetings.fullPlanItem4": "\u7121\u9650\u5236\u7684\u6703\u8B70",
    "meetings.fullPlanItem5": "\u6703\u8B70\u6301\u7E8C\u6642\u9593",
    "meetings.fullPlanItem5Tip": "\u6BCF\u500B\u7FA4\u7D44\u6703\u8B70\uFF08\u542B 3 \u500B\u6216\u66F4\u591A\u8207\u6703\u8005\uFF09\u5141\u8A31\u7684\u6700\u9577\u6301\u7E8C\u6642\u9593\u3002",
    "meetings.fullPlanItem5_basic": "40 \u5206\u9418",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 \u5C0F\u6642",
    "meetings.fullPlanItem5_biz": "30 \u5C0F\u6642",
    "meetings.fullPlanItem5_ent": "30 \u5C0F\u6642",
    "meetings.fullPlanItem7": "\u9304\u88FD",
    "meetings.fullPlanItem7Tip": "Zoom \u672C\u5730\u9304\u88FD\u5C07\u6703\u8B70\u5132\u5B58\u70BA MP4 (\u8996\u8A0A)\u3001M4A (\u97F3\u8A0A) \u548C txt (\u804A\u5929)\u683C\u5F0F\u3002<br>Zoom \u96F2\u7AEF\u9304\u88FD\u5C07\u6703\u8B70\u5132\u5B58\u5728 Zoom \u96F2\u7AEF\uFF0C\u53EF\u5F9E\u700F\u89BD\u5668\u4E0B\u8F09\u548C/\u6216\u4E32\u6D41\u6A94\u6848\u3002",
    "meetings.fullPlanItem7_basic": "\u672C\u5730",
    "meetings.fullPlanItem7_pro": "\u672C\u5730\u548C 5 GB \u96F2\u7AEF\uFF08\u6BCF\u500B\u6388\u6B0A\uFF09",
    "meetings.fullPlanItem7_biz": "\u672C\u5730\u548C 10 GB \u96F2\u7AEF\uFF08\u6BCF\u500B\u6388\u6B0A\uFF09",
    "meetings.fullPlanItem7_ent": "\u672C\u5730\u548C\u7121\u9650\u5236\u96F2\u7AEF",
    "meetings.fullPlanItem9": "\u96FB\u8A71\u64A5\u865F\u52A0\u5165",
    "meetings.fullPlanItem9Tip": "\u900F\u904E\u96FB\u8A71\u6703\u8B70/\u8A9E\u97F3\u6703\u8B70\uFF08\u4F7F\u7528\u50B3\u7D71\u96FB\u8A71\uFF09\u65B9\u5F0F\u52A0\u5165Zoom\u6703\u8B70\u3002\u800C\u4F7F\u7528\u8005\u9700\u6839\u64DA\u6240\u7528\u7684\u96FB\u8A71\u65B9\u6848\u652F\u4ED8\u76F8\u61C9\u8CBB\u7528\u3002\u8ACB\u8A66\u7528\u6211\u5011\u7684\u8A9E\u97F3\u6703\u8B70\u9644\u52A0\u65B9\u6848\uFF0C\u7372\u5F97\u53D7\u8A71\u65B9\u4ED8\u8CBB\u64A5\u5165\u865F\u78BC\u3002",
    "meetings.fullPlanItem9_pro": "\u4ED8\u8CBB",
    "meetings.fullPlanItem9_biz": "\u4ED8\u8CBB",
    "meetings.fullPlanItem9_ent": "\u4ED8\u8CBB",
    "meetings.fullPlanItem_EssentialApp": "必要的應用程式",
    "common.learnMore": "\u77AD\u89E3\u66F4\u591A\u8CC7\u8A0A",
    "meetings.fullPlanItem_EssentialAppText": "1 年內免費使用付費應用程式 (適用條款)",
    "meetings.fullPlanItem11": "\u756B\u9762\u5206\u4EAB",
    "meetings.fullPlanItem11Tip": "\u684C\u9762\u548C\u61C9\u7528\u7A0B\u5F0F\u5206\u4EAB\u3002\u5DF2\u6388\u6B0A\u6703\u8B70\u4F7F\u7528\u8005\u5728\u4ED6\u5011\u6240\u4E3B\u6301\u7684\u6703\u8B70\u671F\u9593\u5167\uFF0C\u53EF\u9078\u64C7\u5141\u8A31\u591A\u4F4D\u8207\u6703\u8005\u540C\u6642\u5206\u4EAB\u756B\u9762\u3002",
    "meetings.fullPlanItem12": "\u5206\u7D44\u8A0E\u8AD6",
    "meetings.fullPlanItem12Tip": "\u8996\u8A0A\u5206\u7D44\u8A0E\u8AD6\u5141\u8A31\u60A8\u5C07 Zoom \u6703\u8B70\u5206\u6210\u6700\u591A 50 \u500B\u55AE\u7368\u7684\u5DE5\u4F5C\u968E\u6BB5\uFF0C\u9032\u884C\u8A0E\u8AD6\u3001\u5C08\u6848\u548C\u5176\u4ED6\u66F4\u591A\u529F\u80FD\u3002",
    "meetings.fullPlanItem14": "\u865B\u64EC\u80CC\u666F",
    "meetings.fullPlanItem15": "\u500B\u4EBA\u6703\u8B70 ID",
    "meetings.fullPlanItem15Tip": "\u5EFA\u7ACB\u60A8\u81EA\u5DF2\u7684\u6C38\u4E45\u7DDA\u4E0A\u6703\u8B70\u5BA4\u3002\u60A8\u53EF\u96A8\u6642\u958B\u59CB\u6B64\u6703\u8B70\uFF0C\u6216\u70BA\u5C07\u4F86\u4F7F\u7528\u7684\u6703\u8B70\u6392\u7A0B\u3002",
    "one.messaging": "傳訊",
    "one.new": "全新",
    "meetings.fullPlanItem16Tip": "\u60A8\u53EF\u4EE5\u900F\u904E Chat \u8F15\u9B06\u50B3\u9001\u7FA4\u7D44\u6D88\u606F\u3001\u6A94\u6848\u3001\u756B\u9762\u64F7\u53D6\u3001\u7A0B\u5F0F\u78BC\u7247\u6BB5\u3001\u8A9E\u97F3\u8A0A\u606F\u548C\u5F71\u50CF\u3002 \u6587\u5B57\u53EF\u683C\u5F0F\u5316\uFF0C\u4E14\u4F7F\u7528\u8005\u53EF\u5206\u4EAB GIF \u548C\u8868\u60C5\u8CBC\u5716\u3002 \u4E0A\u7DDA\u72C0\u614B\u53EF\u986F\u793A\u804A\u5929\u8207\u6703\u8005\u7576\u524D\u4F7F\u7528\u7684\u662F\u96FB\u8166\u3001\u884C\u52D5\u88DD\u7F6E\uFF0C\u9084\u662F\u70BA\u5FD9\u788C\u72C0\u614B\u3002",
    "meetings.fullPlanItem17": "\u4E3B\u6301\u4EBA\u63A7\u5236\u9805",
    "meetings.fullPlanItem18": "\u5728\u5206\u4EAB\u756B\u9762\u4E0A\u5171\u540C\u8A3B\u8A18",
    "meetings.fullPlanItem19": "\u9060\u7AEF\u9375\u76E4\u548C\u6ED1\u9F20\u63A7\u5236",
    "meetings.fullPlanItem21": "\u591A\u65B9\u5206\u4EAB",
    "endToEndEncryptionForZoomMeetings": "Zoom Meetings 的端對端加密功能",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "啟用時，Zoom Meetings 的 Zoom 端對端加密 (E2EE) 可確保在特定會議中使用 Zoom 用戶端所有與會者之間的通訊，使用僅與會者裝置才知道的加密金鑰進行加密。 此可確保包含 Zoom 在內的第三方皆無法取得會議的私有金鑰。",
    "enterpriseGradeSecurityFeatures": "企業級安全性功能",
    "256BitAesGcmEncryptionForRealTime": "將 256 位元 AES-GCM 加密用於傳輸中的即時內容、進階聊天加密、密碼、等候室、鎖定會議、音訊簽章、畫面分享浮水印、雙因素認證以及更多其他功能。",
    "meetings.fullPlanItem29": "\u7B49\u5019\u5BA4",
    "meetings.fullPlanItem29Tip": "\u7B49\u5019\u5BA4\u529F\u80FD\u53EF\u4F9B\u4E3B\u6301\u4EBA\u63A7\u5236\u8207\u6703\u8005\u4F55\u6642\u52A0\u5165\u6703\u8B70\u3002 \u4F5C\u70BA\u6703\u8B70\u4E3B\u6301\u4EBA\uFF0C\u60A8\u53EF\u4EE5\u9010\u4E00\u5141\u8A31\u55AE\u500B\u8207\u6703\u8005\u6216\u4E00\u6B21\u6027\u5141\u8A31\u6240\u6709\u8207\u6703\u8005\u52A0\u5165\u6703\u8B70\u3002 \u60A8\u53EF\u5728\u8A2D\u5B9A\u4E2D\u9078\u64C7\u8981\u5C07\u8AB0\u653E\u5165\u7B49\u5019\u5BA4\uFF0C\u6216\u5141\u8A31\u8AB0\u81EA\u52D5\u52A0\u5165\u6703\u8B70\u3002 \u6240\u6709\u5E33\u6236\u7686\u6709\u7B49\u5019\u5BA4\u529F\u80FD\u3002 \u4E3B\u6301\u4EBA\u53EF\u5411\u7B49\u5019\u5BA4\u767C\u9001\u6D88\u606F\u3002 \u5982\u679C\u60A8\u5C6C\u65BC\u4ED8\u8CBB\u8A08\u756B\uFF0C\u5247\u53EF\u81EA\u8A02\u7B49\u5019\u5BA4\u3002",
    "meetings.fullPlanItem41": "Zoom for Home \u88DD\u7F6E\u5167\u5EFA",
    "meetings.fullPlanItem61": "\u91D8\u9078\u591A\u4EBA",
    "meetings.fullPlanItem61Tip": "\u4E3B\u6301\u4EBA\u6700\u591A\u53EF\u4EE5\u6388\u6B0A 9 \u4EBA\u91D8\u9078\u8996\u8A0A\u7684\u529F\u80FD\uFF0C\u5141\u8A31\u4ED6\u5011\u5EFA\u7ACB\u81EA\u8A02\u6AA2\u8996\u756B\u9762\u3002 \u56E0\u6B64\uFF0C\u7121\u8AD6\u767C\u8A00\u8005\u662F\u8AB0\uFF0C\u5DF2\u91D8\u9078\u7684\u8996\u8A0A\u90FD\u4FDD\u6301\u53EF\u898B\u3002",
    "meetings.fullPlanItem62": "\u805A\u7126\u591A\u4EBA",
    "meetings.fullPlanItem62Tip": "\u4E3B\u6301\u4EBA\u6700\u591A\u53EF\u4EE5\u805A\u7126 9 \u4F4D\u89C0\u773E\u7684\u8996\u8A0A\uFF0C\u56E0\u6B64\uFF0C\u7121\u8AD6\u767C\u8A00\u8005\u662F\u8AB0\uFF0C\u5168\u9AD4\u8207\u6703\u8005\u90FD\u6703\u770B\u898B\u5DF2\u805A\u7126\u4EBA\u58EB\u7684\u8996\u8A0A\u3002",
    "meetings.fullPlanNewItem1": "\u6FFE\u93E1",
    "meetings.fullPlanNewItem1Tip": "\u4F7F\u7528\u8DA3\u5473\u5341\u8DB3\u7684\u5F69\u8272\u6FFE\u93E1\u6216\u88DD\u98FE\u6027\u7684\u52D5\u7269\u8CBC\u5716\uFF0C\u70BA\u6B61\u6A02\u6642\u523B\u3001\u6D3E\u5C0D\u7B49\u5834\u5408\u589E\u6DFB\u66F4\u591A\u6A02\u8DA3\u3002",
    "meetings.fullPlanNewItem2": "\u6295\u7968",
    "meetings.fullPlanNewItem3": "\u806F\u5E2D\u4E3B\u6301\u4EBA\u8207\u5099\u9078\u4E3B\u6301\u4EBA",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/zh-tw/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">\u6DF1\u5165\u77AD\u89E3</a>\u6211\u5011\u7684\u6703\u8B70\u806F\u5E2D\u4E3B\u6301\u4EBA\u63A7\u5236\u9805\u3002",
    "meetings.fullPlanItem24": "\u6307\u6D3E\u6703\u8B70\u6392\u7A0B\u8005",
    "meetings.fullPlanItem24Tip": "\u5141\u8A31\u60A8\u6307\u6D3E\u67D0\u4EBA\u70BA\u60A8\u8A2D\u5B9A\u60A8\u7684\u6703\u8B70\u3002\u88AB\u6307\u6D3E\u8005\u5FC5\u9808\u64C1\u6709\u5C08\u696D\u7248\u8A08\u756B\u3002",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "\u5141\u8A31\u5E33\u6236\u64C1\u6709\u8005\u3001\u7BA1\u7406\u54E1\u548C\u60A8\u7684\u958B\u767C\u4EBA\u54E1\u5B89\u5168\u5730\u5B58\u53D6 Zoom REST API\u3002\u6839\u64DA\u5E33\u6236\u985E\u578B (\u5C08\u696D\u7248\u3001\u5546\u696D\u7248\u3001\u4F01\u696D\u7248\u7B49\u7B49) \u548C API \u8ACB\u6C42\u985E\u578B (\u8F15\u578B\u3001\u4E2D\u578B\u3001\u91CD\u578B\u7B49\u7B49)\uFF0C\u70BA\u5E33\u6236\u5C64\u7D1A\u5957\u7528 API \u901F\u7387\u9650\u5236\u3002\u67D0\u4E9B API \u50C5\u9650\u7279\u5B9A\u5E33\u6236\u985E\u578B\u5B58\u53D6\u3002\u5982\u9700\u5B8C\u6574\u7684\u8A73\u7D30\u8CC7\u8A0A\uFF0C\u8ACB\u4F7F\u7528 API \u901F\u7387\u9650\u5236\u548CAPI \u53C3\u8003\u6587\u4EF6\u3002",
    "meetings.fullPlanItem25_pro": "\u5C08\u696D\u7248 REST API \u901F\u7387\u9650\u5236",
    "meetings.fullPlanItem25_biz": "REST API \u901F\u7387\u9650\u5236",
    "meetings.fullPlanItem26": "Skype for Business (Lync) \u4E92\u901A\u6027",
    "meetings.fullPlanItem26Tip": "\u5141\u8A31 Lync 2010\u30012013 \u4F7F\u7528\u8005\u548C Skype for Business \u4F7F\u7528\u8005\u81EA Lync \u806F\u7D61\u4EBA\u8ACB\u55AE\u555F\u52D5 Zoom \u6703\u8B70\u3002",
    "meetings.fullPlanItem27": "\u76F4\u64AD",
    "meetings.fullPlanItem27Tip": "\u53EF\u5C0D Facebook\u3001Youtube \u6216\u7B2C\u4E09\u65B9\u670D\u52D9\u9032\u884C\u76F4\u64AD\u3002",
    "meetings.fullPlanItem28": "\u5831\u544A",
    "meetings.fullPlanItem28Tip": "\u5132\u5B58\u767D\u677F\u5DE5\u4F5C\u968E\u6BB5",
    "meetings.fullPlanItem30": "\u4F7F\u7528\u8005\u7BA1\u7406",
    "meetings.fullPlanItem30Tip": "\u64C1\u6709\u8005\u548C\u7BA1\u7406\u54E1\u53EF\u65B0\u589E\u3001\u522A\u9664\u548C\u6307\u6D3E\u89D2\u8272\u53CA\u9644\u52A0\u529F\u80FD\u3002",
    "one.autoCaptions": "自動字幕",
    "one.englishOnly": "僅英文",
    "meetings.fullPlanItem31": "\u7BA1\u7406\u54E1\u5165\u53E3\u7DB2\u7AD9",
    "meetings.fullPlanItem31Tip": "\u5229\u7528Zoom\u7BA1\u7406\u54E1\u5165\u53E3\u7DB2\u7AD9\uFF0C\u4EE5\u4E00\u500B\u5E33\u6236\u7BA1\u7406\u60A8\u516C\u53F8\u6240\u6709\u7684\u4F7F\u7528\u8005\uFF0C\u5305\u62EC\u7C21\u5316\u8A08\u8CBB\u6D41\u7A0B\u3001\u9032\u968E\u4F7F\u7528\u8005\u7BA1\u7406\u8A2D\u5B9A\u548C\u5B8C\u6574\u4F7F\u7528\u8005\u8CC7\u8A0A\u3002",
    "meetings.fullPlanItem32": "LTI \u6574\u5408",
    "meetings.fullPlanItem32Tip": "\u8F15\u9B06\u70BA\u4EFB\u4F55\u8AB2\u7A0B\u6D3B\u52D5\u65B0\u589E\u6703\u8B70\uFF0C\u4E26\u4F7F\u7528\u60A8\u7684\u5B78\u7FD2\u7BA1\u7406\u7CFB\u7D71\u9080\u8ACB\u9069\u5408\u7684\u5B78\u751F\uFF08\u53EF\u642D\u914D Moodle\u3001Canvas\u3001Desire2Learn \u548C Blackboard \u4F7F\u7528\uFF09\u3002",
    "meetings.fullPlanItem33": "\u96F2\u7AEF\u9304\u88FD\u6A94\u6848\u9010\u5B57\u7A3F",
    "meetings.fullPlanItem33Tip": "\u96F2\u7AEF\u9304\u88FD\u9010\u5B57\u7A3F\u662F\u60A8\u9304\u88FD\u5230\u96F2\u7AEF\u7684\u6703\u8B70\u6216\u7DB2\u8DEF\u7814\u8A0E\u6703\u97F3\u8A0A\u7684\u97F3\u8A0A\u8F49\u6587\u5B57\u7A3F\u3002\u8ACB\u6CE8\u610F\uFF0C\u73FE\u968E\u6BB5\u50C5\u652F\u63F4\u82F1\u8A9E\u8A9E\u7A2E\u3002 <a href=\"https://support.zoom.us/hc/zh-tw/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">\u9EDE\u6309\u6B64\u8655</a> \u4EE5\u77AD\u89E3\u8A73\u60C5\u3002",
    "meetings.fullPlanItem34": "\u54C1\u724C\u5316",
    "meetings.fullPlanItem34Tip": "\u65B0\u589E\u516C\u53F8\u54C1\u724C\u5316\u81F3\u60A8\u81EA\u5DF1\u81EA\u8A02\u7684\u9801\u9762\uFF0C\u60A8\u7684\u4F7F\u7528\u8005\u53EF\u5728\u6B64\u9801\u9762\u52A0\u5165\u6703\u8B70\u3002\u5EFA\u7ACB\u54C1\u724C\u5316\u96FB\u5B50\u90F5\u4EF6\u7BC4\u672C\uFF0C\u4EE5\u767C\u9001\u9080\u8ACB\u7D66\u89C0\u773E\u3002",
    "meetings.fullPlanItem35": "\u8A17\u7BA1\u7DB2\u57DF",
    "meetings.fullPlanItem35Tip": "\u4F7F\u7528\u60A8\u516C\u53F8/\u5927\u5B78\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u7DB2\u57DF\u81EA\u52D5\u5C07\u4F7F\u7528\u8005\u65B0\u589E\u81F3\u60A8\u7684\u5E33\u6236\u3002",
    "meetings.fullPlanItem37": "\u8A9E\u8A00\u53E3\u8B6F",
    "meetings.fullPlanItem37Tip": "\u5141\u8A31\u6703\u8B70\u4E3B\u6301\u4EBA\u6307\u5B9A\u6703\u8B70\u548C\u7DB2\u8DEF\u7814\u8A0E\u6703\u4E2D\u7684\u53E3\u8B6F\u8005\u3002\u6703\u8B70\u6216\u7DB2\u8DEF\u7814\u8A0E\u6703\u958B\u59CB\u6642\uFF0C\u6703\u8B70\u4E3B\u6301\u4EBA\u53EF\u4EE5\u958B\u555F\u53E3\u8B6F\u529F\u80FD\uFF0C\u53E3\u8B6F\u4EBA\u54E1\u96A8\u5373\u80FD\u5920\u4F7F\u7528\u81EA\u5DF1\u7684\u8A9E\u8A00\u983B\u9053\u3002\u8207\u6703\u8005\u53EF\u4EE5\u9078\u64C7\u6240\u9700\u7684\u8A9E\u8A00\u983B\u9053\u6536\u807D\u81EA\u5DF1\u6240\u9078\u7684\u8A9E\u8A00\u53E3\u8B6F\u3002\u53C3\u6703\u8005\u4E0D\u4F46\u53EF\u4EE5\u807D\u898B\u7FFB\u8B6F\u904E\u7684\u97F3\u8A0A\u5167\u5BB9\uFF0C\u9084\u53EF\u4EE5\u9078\u64C7\u8ABF\u4F4E\u539F\u59CB\u97F3\u8A0A\u7684\u97F3\u91CF\u3002",
    "meetings.fullPlanItem39": "\u9AD8\u7D1A\u4E3B\u7BA1\u696D\u52D9\u5BE9\u67E5",
    "meetings.fullPlanItem39Tip": "\u8A73\u7D30\u8DA8\u52E2\u63A1\u7D0D\u5206\u6790\u3001\u6295\u8CC7\u5831\u916C\u7387 (ROI) \u8FFD\u8E64\u3001\u7522\u54C1\u8DEF\u7DDA\u5716\u8A0E\u8AD6\u3002",
    "meetings.fullPlanItem40": "\u7D81\u5B9A\u6298\u6263",
    "meetings.fullPlanNewItem4": "\u5305\u62ECWebinar 500",
    "one.includeWbn1000": "*企業加強版包括 Webinar 1000",
    "meetings.fullPlanItem51": "Zoom Whiteboards",
    "meetings.unlimited": "\u7121\u9650\u5236",
    "one.translatedCations": "已翻譯字幕",
    "one.entPlus": "Enterprise Plus",
    "mail": "郵件",
    "zoomMailAndCalendarInTheZoomApp": "Zoom 應用程式中的 Zoom Mail 與 Calendar 用戶端",
    "mailService": "郵件服務",
    "emailServiceWithFullTimeEndToEnd": "電子郵件服務具有全程端對端加密以加強保護隱私權",
    "customMailDomain": "自訂郵件網域",
    "customMailDomainWithMailService": "自訂郵件網域和郵件服務",
    "calendarClient": "Calendar 用戶端",
    "scheduleAndJoinMeetings": "在 Zoom 應用程式中安排和加入會議",
    "calendarService": "Calendar 服務",
    "meetingSchedulingAndAppointment": "會議排程和預約",
    "zoomCustomerManagedKey": "Zoom Customer Managed Key",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Bring your own encryption keys to protect Zoom data at rest",
    "phone.fullPlanItem1": "國內無限制通話",
    "phone.fullPlanItem2": "國際計量通話",
    "phone.fullPlanItem3": "\u7121\u9650\u5236\u64A5\u51FA\u901A\u8A71",
    "phone.fullPlanItem4": "\u9818\u5148\u696D\u754C\u7684\u9AD8\u6E05\u6670\u5EA6\u901A\u8A71\u54C1\u8CEA",
    "phone.fullPlanItem4Tip": "\u542B\u4E3B\u52D5\u5F0F\u964D\u566A\u3001\u6D88\u9664\u56DE\u97F3\u548C\u9375\u76E4\u8F38\u5165\u6291\u5236\u529F\u80FD",
    "phone.fullPlanItem5": "\u539F\u751F Windows\u3001MacOS \u548C Linux \u684C\u4E0A\u578B\u61C9\u7528\u7A0B\u5F0F",
    "phone.fullPlanItem6": "iOS \u548C Android \u7248\u539F\u751F\u884C\u52D5\u61C9\u7528\u7A0B\u5F0F",
    "phone.fullPlanItem7": "\u63A5\u5165\u73FE\u6709\u865F\u78BC\u6216\u8CFC\u8CB7\u65B0\u865F\u78BC (DID)",
    "phone.fullPlanItem8": "\u53D7\u8A71\u65B9\u4ED8\u8CBB\u865F\u78BC",
    "phone.fullPlanItem9": "\u96FB\u8A71\u5206\u6A5F\u865F\u78BC",
    "phone.fullPlanItem10": "\u5E36\u6709\u8F49\u9304\u529F\u80FD\u7684\u8A9E\u97F3\u4FE1\u7BB1",
    "phone.fullPlanItem10Tip": "\u900F\u904E\u884C\u52D5/\u684C\u4E0A\u578B\u61C9\u7528\u7A0B\u5F0F\u548C\u96FB\u5B50\u90F5\u4EF6\u5B58\u53D6\u8A9E\u97F3\u4FE1\u7BB1\u9010\u5B57\u7A3F",
    "phone.fullPlanItem11": "\u7121\u9650\u5236\u81EA\u52D5\u61C9\u7B54\u7CFB\u7D71/IVR",
    "phone.fullPlanItem12": "\u4F9D\u64DA\u59D3\u540D\u76EE\u9304\u64A5\u865F",
    "phone.fullPlanItem13": "\u81EA\u52D5\u901A\u8A71\u5206\u914D (ACD) \u7FA4\u7D44\uFF0C\u5E36\u6709\u901A\u8A71\u4F47\u5217\u529F\u80FD",
    "phone.fullPlanItem14": "\u63D2\u8A71/\u76E3\u63A7/\u79C1\u8A9E/\u63A5\u7BA1",
    "phone.fullPlanItem15": "\u5047\u65E5\u548C\u8FA6\u516C\u6642\u9593\u8DEF\u7531",
    "phone.fullPlanItem16": "3 \u65B9\u81E8\u6642\u6703\u8B70\u901A\u8A71",
    "phone.fullPlanItem17": "\u901A\u8A71\u9304\u97F3",
    "phone.fullPlanItem17Tip": "\u63D0\u4F9B\u81EA\u52D5\u548C\u624B\u52D5\u901A\u8A71\u9304\u97F3\u3002",
    "phone.fullPlanItem18": "\u53EF\u914D\u7F6E\u7121\u8A18\u540D\u548C\u5177\u540D\u4F86\u96FB\u5C01\u9396",
    "phone.fullPlanItem19": "\u7DCA\u6025\u901A\u8A71",
    "phone.fullPlanItem19Tip": "\u5C07\u4F86\u96FB\u7F6E\u65BC\u672C\u5730\u7DCA\u6025\u670D\u52D9",
    "phone.fullPlanItem20": "Nomadic E911 \u5730\u5740\u641C\u5C0B\u7CFB\u7D71 (\u7F8E\u570B\u548C\u52A0\u62FF\u5927) -",
    "phone.fullPlanItem20Tip": "\u52D5\u614B\u5075\u6E2C\u4F7F\u7528\u8005\u4F4D\u7F6E\uFF0C\u4E26\u56DE\u5831\u5C0D\u61C9\u7DCA\u6025\u5730\u5740\u81F3\u7576\u5730\u7DCA\u6025\u670D\u52D9\u55AE\u4F4D (\u50C5\u9650\u7F8E\u570B\u548C\u52A0\u62FF\u5927) \u53CA\u5167\u90E8\u5B89\u5168\u5718\u968A",
    "phone.fullPlanItem21": "\u61C9\u6025\u56DE\u61C9\u4E2D\u5FC3",
    "phone.fullPlanItem21Tip": "\u555F\u7528\u5167\u90E8\u5B89\u5168\u5718\u968A\u5C0D\u7DCA\u6025\u4F86\u96FB\u4E4B\u8B66\u5831\uFF0C\u4EE5\u53CA\u5C0D\u7DCA\u6025\u4F86\u96FB\u9032\u884C\u9304\u88FD/\u76E3\u63A7/\u63D2\u8A71\uFF0C\u4EE5\u5354\u52A9\u5354\u8ABF\u56DE\u61C9\u3002",
    "phone.fullPlanItem22": "\u5171\u4EAB\u7DDA\u8DEF\u986F\u793A/\u59D4\u6D3E",
    "phone.fullPlanItem23": "\u88DD\u7F6E\u9593\u901A\u8A71\u5207\u63DB",
    "phone.fullPlanItem24": "\u901A\u8A71\u99D0\u7559",
    "phone.fullPlanItem25": "\u804A\u5929 (\u4E0A\u7DDA\u72C0\u614B\u3001\u4E00\u5C0D\u4E00\u548C\u5718\u968A\u50B3\u8A0A)",
    "phone.fullPlanItem25Tip": "\u8207\u4EFB\u4F55 Zoom \u4F7F\u7528\u8005\u804A\u5929",
    "endToEndEncryptionForZoomPhone": "Zoom Phone 的端對端加密",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "在 Zoom Phone 啟用時，端對端加密 (E2EE) 使用僅裝置通話者和接收者知道的加密金鑰，進而為通話加密。 此外，使用者將來也可以向通話者提供一個獨特的安全碼，藉此驗證 E2EE 狀態。",
    "256BitAesGcmEncryptionForRealTimeContent": "將 256 位元 AES-GCM 加密用於即時內容與媒體、SIP 註冊期間的 TLS 加密、來電者 ID 遮蔽、私有網路對接、工具詐騙偵測以及通話封鎖清單。",
    "phone.fullPlanItem43": "\u96FB\u8A71\u96F6\u63A5\u89F8\u4F48\u5EFA",
    "phone.fullPlanItem44": "\u5E33\u6236\u6DF7\u5408\u8A08\u756B\u7A2E\u985E",
    "phone.fullPlanItem46": "\u5373\u6642\u5831\u544A\u548C\u54C1\u8CEA\u5100\u8868\u677F",
    "phone.fullPlanItem47": "\u652F\u63F4\u865B\u64EC\u684C\u9762 (VDI) \u74B0\u5883",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/zh-tw/articles/360031096531-Getting-Started-with-VDI\">\u77AD\u89E3\u95DC\u65BC VDI \u7684\u8A73\u60C5</a>",
    "phone.fullPlanItem48": "\u5168\u5929 24 \u5C0F\u6642\u5168\u7403\u9867\u5BA2\u95DC\u61F7",
    "phone.fullPlanItem49": "\u63A5\u5165\u60A8\u7684\u5C08\u7528\u71DF\u904B\u5546\u652F\u63F4",
    "phone.fullPlanItem49Tip": "\u652F\u63F4\u8207\u60A8\u73FE\u6709 PSTN \u670D\u52D9\u4F9B\u61C9\u5546\u7684\u76F4\u63A5\u548C\u73FE\u5834\u70BA\u4E3B\u5C0D\u63A5",
    "phone.fullPlanItem50": "\u8207\u820A\u5F0FPBX\u7684\u6DF7\u5408\u6574\u5408",
    "phone.fullPlanItem51": "對講機",
    "phone.fullPlanItem61": "線上傳真",
    "phone.fullPlanItem61Tip": "在美國與加拿大境內無限量傳送和接收傳真。如需國際傳真，請<a href=\"{href}\" target=\"_blank\" style=\"color: #0B5CFF;\">查看費率</a>",
    "phone.fullPlanSms": "\u7C21\u8A0A\u548C\u591A\u5A92\u9AD4\u8A0A\u606F",
    "phone.fullPlanSmsTip": "\u50C5\u9069\u7528\u65BC\u8CFC\u8CB7\u901A\u8A71\u8A08\u756B\u7684\u7F8E\u570B\u548C\u52A0\u62FF\u5927\u865F\u78BC \u53EF\u7528\u65BC\u76F4\u64A5\u865F\u78BC (\u975E\u516C\u53F8\u865F\u78BC)\u3002",
    "notIncluded": "Not Included",
    "included": "Included",
    "helpTooltipIcon": "Help Tooltip icon",
    "phone.fullPlanItem20Pdf": "\u4E0B\u8F09\u898F\u683C\u8868",
    "marketing.new_pricing.phone.metered_plan.new.item1": "分機對分機、撥入及撥出通話。 所有撥出分鐘數將以計量方式計算費率。 檢視計量費率。",
    "marketing.new_pricing.phone.metered_plan.item1": "\u7F8E\u570B\u53CA\u52A0\u62FF\u5927\u865F\u78BC",
    "marketing.new_pricing.phone.item.sms": "\u570B\u5167\u7C21\u8A0A\u548C\u591A\u5A92\u9AD4\u8A0A\u606F",
    "marketing.new_pricing.phone.item.sms.tip": "\u50C5\u9069\u7528\u65BC\u8CFC\u8CB7\u901A\u8A71\u8A08\u756B\u7684\u7F8E\u570B\u548C\u52A0\u62FF\u5927\u865F\u78BC \u53EF\u7528\u65BC\u76F4\u64A5\u865F\u78BC (\u975E\u516C\u53F8\u865F\u78BC)\u3002",
    "marketing.new_pricing.phone.metered_plan.item3": "\u5F9E\u591A\u90E8\u88DD\u7F6E\u53CA/\u6216\u61C9\u7528\u7A0B\u5F0F\u64A5\u6253\u548C\u63A5\u807D\u96FB\u8A71",
    "marketing.new_pricing.common.one_management_portal": "單一管理入口網站",
    "marketing.new_pricing.common.one_management_portal_tooltip": "在 Zoom 中央管理員入口網站中佈建和管理使用者、監控通話品質和使用狀況資料",
    "marketing.new_pricing.phone.unlimited_plan.item2": "\u7F8E\u570B\u53CA\u52A0\u62FF\u5927\u5883\u5167\u7121\u9650\u5236\u901A\u8A71",
    "marketing.new_pricing.phone.domestic_plan.item5": "\u9078\u64C7\u6027\u9644\u52A0\u8A08\u756B\uFF1A\u7121\u9650\u5236\u64A5\u6253 19 \u500B\u570B\u5BB6/\u5730\u5340",
    "marketing.new_pricing.phone.domestic_plan.item5.tip": "\u9644\u52A0\u8A08\u756B\u53EF\u96A8\u4EFB\u4F55\u7121\u9650\u5236\u901A\u8A71\u8A08\u756B\u4E00\u540C\u8CFC\u8CB7\u3002\u63D0\u4F9B\u64A5\u6253\u4E0B\u5217\u570B\u5BB6/\u5730\u5340\u7684\u7121\u9650\u5236\u570B\u969B\u901A\u8A71\uFF1A\u7F8E\u570B\u3001\u52A0\u62FF\u5927\u3001\u82F1\u570B\u3001\u611B\u723E\u862D\u3001\u6FB3\u6D32\u3001\u7D10\u897F\u862D\u3001\u5967\u5730\u5229\u3001\u4E39\u9EA5\u3001\u6CD5\u570B\u3001\u5FB7\u570B\u3001\u7FA9\u5927\u5229\u3001\u8461\u8404\u7259\u3001\u897F\u73ED\u7259\u3001\u745E\u5178\u3001\u6BD4\u5229\u6642\u3001\u8377\u862D\u3001\u745E\u58EB\u548C\u6CE2\u591A\u9ECE\u5404\u3002",
    "phone.fullPlanItem27": "\u96A8\u63D2\u5373\u7528 VoIP \u96FB\u8A71",
    "phone.fullPlanItem27Tip": "\u652F\u63F4\u5E36\u6709\u9644\u63A5\u76D2\u7684\u684C\u4E0A\u578B\u96FB\u8A71\u3001\u6703\u8B70\u96FB\u8A71\u548C\u7121\u7DDA\u88DD\u7F6E",
    "phone.fullPlanItem28": "\u985E\u6BD4\u88DD\u7F6E\u652F\u63F4 (ATA\u3001\u547C\u53EB\u7B49)",
    "phone.fullPlanItem28Tip": "ATA \u53EF\u652F\u63F4\u6700\u591A 288 \u500B\u9023\u63A5\u57E0",
    "phone.fullPlanItem29": "\u5171\u4EAB\u96FB\u8A71",
    "phone.fullPlanItem31": "\u5C07\u4F86\u96FB\u63D0\u5347\u70BA Zoom \u6703\u8B70",
    "phone.fullPlanItem32": "\u5C07\u4F86\u96FB\u8F49\u79FB\u81F3 Zoom \u6703\u8B70\u6216 Zoom Room",
    "phone.fullPlanItem34": "Salesforce",
    "phone.fullPlanItem34Tip": "\u539F\u751F Salesforce Lightning \u61C9\u7528\u7A0B\u5F0F\uFF0C\u542B\u64A5\u865F\u9375\u76E4\u3001\u9EDE\u6309\u64A5\u865F\u3001\u6D3B\u52D5\u7D00\u9304\u3001\u5F48\u51FA\u756B\u9762",
    "phone.fullPlanItem35": "Slack",
    "phone.fullPlanItem35Tip": "\u8207 Slack /\u6307\u4EE4\u548C\u64A5\u865F\u6309\u9375\u4E4B\u539F\u751F\u6574\u5408",
    "phone.fullPlanItem36": "\u806F\u7D61\u4E2D\u5FC3",
    "phone.fullPlanItem36Tip": "Five9\u3001Twilio\u3001Genesys\u3001NICE inContact\u3001Talkdesk",
    "phone.fullPlanItem37": "Microsoft",
    "phone.fullPlanItem37Tip": "\u65E5\u66C6\u53CA\u4E0A\u7DDA\u72C0\u614B\u8207 Outlook \u6574\u5408",
    "phone.fullPlanItem38": "Google",
    "phone.fullPlanItem38Tip": "\u9EDE\u6309\u64A5\u865F\u3001\u65E5\u66C6\u548C\u4E0A\u7DDA\u72C0\u614B\u8207 Google Calendar \u548C Gmail \u6574\u5408",
    "phone.fullPlanItem40": "\u900F\u904E SAML 2.0 \u55AE\u4E00\u767B\u5165",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem41": "256 \u4F4D\u5143\u9A57\u8B49/\u5A92\u9AD4\u52A0\u5BC6\u652F\u63F4",
    "phone.fullPlanItem42": "\u4F01\u696D API \u548C\u5B89\u5168",
    "phone.fullPlanItem45": "FEDRamp \u4E2D\u7B49\u6CD5\u898F\u9075\u5FAA",
    "phone.fullPlanItem46Tip": "Requires a Business, Education, or Enterprise account to access the Dashboard",
    "phone.fullPlanMeterd": "\u8A08\u91CF",
    "billing.common.select": "特選",
    "phone.fullPlanUnlimited": "區域無限制",
    "phone.fullPlanItem26": "\u88DD\u7F6E\u652F\u63F4",
    "phone.fullPlanItem30": "Zoom會議",
    "phone.fullPlanItem33": "\u6574\u5408",
    "phone.fullPlanItem39": "\u4E2D\u5FC3\u5316\u7BA1\u7406",
    "marketing.new_pricing.basic_plus.comparison.meeting_duration": "40 mins with 4 extensions up to {0} mins per billing cycle",
    "marketing.new_pricing.basic_plus.comparison.recording": "Local & {0} cloud",
    "zoomOneRequired": "需要 Zoom One",
    "zoomOneAddOnRequired": "This is a Zoom One Add-On and requires a paid Zoom One license in order to purchase.",
    "sessionTypeOptions": "會程類型選項",
    "events.webinarTitle": "網路研討會",
    "webinarOrMeeting": "網路研討會或會議",
    "multiDayMultiTrackConcurrentSessions": "多日、多軌、同步會程",
    "teamCollaboration": "團隊協作",
    "licensesOf_500CapacityAndAboveComeWith_5HubHostsAnd_3CoEditorsAndThe_100CapacityLicensesComeWith_2HubHostsAnd_1CoEditorEachOfThese_5HostsCanCollaborateOnEachOthersEventsIncludingHostingSessionsEditingAndUpdatingEventContentCreatingAndPushingEventsLiveAndAssigningRolesWithinAnEventAdditionalHostsAndCoEditorsCanBePurchasedFor_75PerHostOrCoEditorPerMonthForZoomEventsAnd_65PerHostOrCoEditorPerMonthForZoomSessions": "容量 500 人以上的授權隨附 5 位中心主持人和 3 位共同編輯者，容量 100 人的授權隨附 2 位中心主持人和 1 位共同編輯者。 5 位主持人皆可在彼此的活動中進行協作，包括主持會議、編輯和更新活動內容、建立以及將活動上線，並可指派活動中的角色。 如需額外的主持人和共同編輯者，可以用每位主持人或每位共同編輯者每月的價格購買，Zoom Events 的價格為 75 美元，Zoom Sessions 的價格為 65 美元。",
    "eventOrSessionBranding": "活動或會程品牌化",
    "inZoomEventsAndZoomSessionsEventHostsCanCreateAUniqueColorPaletteAndApplyBrandingAcrossTheEntireEventIncludingAttendeeEmailsInZoomWebinarsEventHostsCanApplyNameTagsUploadABacksplashAndIncludeUniformVirtualBackgroundsForEachSpeaker": "在 Zoom Events 和 Zoom Sessions 中，活動主持人可建立獨特的調色盤，並將品牌化套用至包含觀眾電子郵件的整個活動中。 在 Zoom Webinars 中，活動主持人可套用名稱標籤、上傳壁紙，並包含每位演講者的一致虛擬背景。",
    "productionTools": "生產工具",
    "useBackstageSimuliveAndLaunchInSessionResourcesAndCtasThroughoutYourEventToKeepYourTeamOrganizedAndYourAttendeesEngaged": "在您的活動中使用後台、預錄後直播並啟動會議中資源和 CTA，讓您的團隊井井有條，並讓觀眾進行互動。",
    "expoAndSponsors": "Expo 與贊助商",
    "highlightYourSponsorsAndKeepYourAttendeesEngagedWithTheVirtualExpoHall": "凸顯您的贊助商並讓您的觀眾與虛擬展覽會館進行互動。",
    "events.eventsProductFeature3": "\u6D3B\u52D5\u4E2D\u5FC3",
    "eventHubsThatAllowYouToOrganizeYourEventsAndPostEventRecordings": "活動中心可讓您整理各項活動以及張貼活動錄製內容。",
    "eventAnalyticsAndReporting": "活動分析工具和報告",
    "eventAnalyticsToTrackRevenueEngagementAndAttendanceForAllOfYourEvents": "活動分析工具可追蹤您所有活動的營收、參與度和出席率。",
    "interactiveInSessionFeatures": "互動式會議中功能",
    "inSessionQAndAChatPollingAndQuizzes": "會議中問答、聊天、投票及測驗",
    "durationPerSession": "每場會議持續時間",
    "100InteractiveVideoPanelists_49ViewableOnScreenAtOneTime": "100 名以上互動視訊嘉賓 (一次可在畫面上顯示 49 名)",
    "eventRegistration": "活動註冊",
    "eventManagementPlatformEventInformationSpeakerListRegistration": "活動管理平台 (活動資訊、演講者名單、註冊)",
    "sessionBranding": "工作階段品牌化",
    "setMatching": "Set matching virtual backgrounds, speaker name tags, and a branded backsplash.",
    "eventBranding": "活動品牌化",
    "customizeRegistration": "Customize the registration page, lobby page and much more with your own branded colors, fonts and logos.",
    "speakerBioInformation": "演講者簡歷資訊",
    "sessionVideoPreviews": "會議視訊預覽",
    "streamingSessionsInEventLobby": "活動大廳直播會議",
    "giveYourAttendeesAWayToPreviewConcurrentSessionsThatAreTakingPlaceByScrollingThroughTheLiveSessionsWithinTheEventLobby": "Give your attendees a way to preview concurrent sessions that are taking place, by scrolling through the live sessions within the Event Lobby.",
    "eventSponsors": "活動贊助商",
    "expoFloor": "Expo 樓層",
    "expoFloorForAttendeesToInteractWithSponsorsEngageInLiveConversationsAndExploreExpoBooths": "Expo Floor for attendees to interact with sponsors, engage in live conversations and explore Expo Booths.",
    "associatedWithAnEventHubPerLicense": "與活動中心關聯 (每個授權)",
    "customizablePreAndPostEventEmailReminders": "可自訂的活動前後電子郵件提醒",
    "customizableRegistration": "可自訂的註冊功能",
    "ticketing": "票務",
    "paidFree": "付費/免費",
    "practiceSession": "研討會彩排階段",
    "productionStudio": "製作工作室",
    "avoidAdditionalProductionAndAgencyCostsByDesigningYourOwnInSessionLayoutsCreateMultipleWebinarScenesWithCustomLayoutsAndDetermineTheirSequenceCustomizeVideoBordersChangeAspectRatiosAndAddSceneWallpapers": "設計您自己的會議版面，省下額外的製作和代辦成本。 使用自訂版面功能，為多個網路研討會製作場景，並決定其順序。 自訂影片邊框、更改比例，並新增場景桌布",
    "1080pVideoResolution": "1080p 視訊解析度",
    "backstage": "幕後效果",
    "aBehindTheScenesEventManagementSpaceForTheProductionCrewAndPanelistsToCollaborateBeforeDuringAndAfterASessionThisFeatureCanBeUsedInWebinarsHostedFromTheWebPortalForAnyoneWithAnAnnualZoomSessionOrZoomEventsLicense": "可讓製作團隊和嘉賓在會議前、會議期間、會議後進行協作的幕後活動管理空間。此功能可用於從入口網站舉行的網路研討會，適用於具有 Zoom Sessions 或 Zoom Events 年度授權的任何人。",
    "simulive": "Simulive",
    "provideEngagingContentAtAnyTimeOfTheDayInAnyTimeZoneSimuliveWillBringTheLiveExperienceToAllAttendeesWithPreRecordedContentThatStartsAndEndsAutomaticallyThisFeatureCanBeUsedInWebinarsHostedFromTheWebPortalForAnyoneWithAnAnnualZoomSessionOrZoomEventsLicense": "在任何時區、一天中的任何時間提供吸引人的內容。 預錄後直播以自動開始與結束的預錄內容，為所有觀眾帶來觀看直播的體驗。 此功能可用於從入口網站舉行的網路研討會，適用於具有 Zoom Sessions 或 Zoom Events 年度授權的任何人。",
    "sessionResources": "會程資源",
    "allowAttendeesToViewAndDownloadDocumentsDuringTheSessionThroughCustomizableCallsToActionWithinAWebinarSessionThisFeatureCanBeUsedInWebinarsHostedFromTheWebPortalForAnyoneWithAnAnnualZoomSessionOrZoomEventsLicense": "讓觀眾可在網路研討會會程中，透過可自訂的行動號召 (CTA) 檢視和下載文件。 此功能可用於從入口網站舉行的網路研討會，適用於具有 Zoom Sessions 或 Zoom Events 年度授權的任何人。",
    "lobbyChat": "大廳聊天",
    "livePollingAndResults": "即時投票和結果",
    "qAndA": "問答",
    "sessionSurveys": "會議問卷調查",
    "eventSurveys": "活動問卷調查",
    "liveTranscription": "即時轉錄",
    "languageInterpreterSupport": "口譯人員支援",
    "cloudRecordingsAndTextTranscripts": "雲端錄製和文字逐字稿",
    "performanceAndAudienceEngagementReports": "績效和觀眾參與度報告",
    "detailedAnalyticsDashboardsAndReporting": "詳細的分析工具儀表板和報告",
    "billingManagementAccountLevelAndHubLevel": "計費管理帳戶層級和中心層級",
    "paymentProviderStripe": "付款提供商 - Stripe",
    "paymentProviderPaypal": "付款提供商 - PayPal",
    "taxation": "稅收",
    "taxComplianceControlForEu": "歐盟稅務合規控制",
    "recordingCloudLocal": "錄製 - 雲端/本機",
    "onDemandRecordingAvailable": "可提供隨需錄製",
    "postEvent": "活動後",
    "postEventSurvey": "活動後問卷調查",
    "marketoIntegration": "Marketo 整合",
    "pardotIntegration": "Pardot 整合",
    "eloquaIntegration": "Eloqua 整合",
    "attendeeNetworking": "觀眾溝通",
    "inWebinarChatOnly": "僅限網路研討會中聊天",
    "inSessionChatOnly": "僅限會議中聊天",
    "networkingFeaturesIncludingAttendeeProfileCreation_1_1ChatAndMore": "人脈網路功能包括建立觀眾的設定檔、一對一聊天等",
    "professionalServicesAvailable": "可提供專業服務",
    "3hoursPPA": "3 hours of professional services included in Zoom Sessions and Zoom Events licenses for capacities over 10,000 attendees. 1 hour is included for 1000, 3000, and 5000. Not included in Pay Per Attendee plans.",
    "asAnAddOn": "做為附加元件",
    "localizationToAllZoomLanguages": "本地化為所有 Zoom 語言",
    "eventAttributes": "活動屬性",
    "hubCollaboration": "中心/協作",
    "eventSetup": "活動設定",
    "audienceEngagement": "觀眾參與度",
    "analytics": "分析工具",
    "paymentsBilling": "付款/計費",
    "postEventFeatures": "活動後功能",
    "events.fullPlanItem14": "整合",
    "additionalFeatures": "其他功能",
    "marketing.new_pricing.clips": "Clips",
    "marketing.new_pricing.clips_tips": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "marketing.new_pricing.notes_tips": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "marketing.new_pricing.included_x": "{0} included",
    "createAndShareNewOrExistingWhiteboardsInMeetingsAndWebinar": "在會議和網路研討會內建立和分享新的白板或現有白板",
    "shareWhiteboardsInPresentationOrCollaborationMode": "在簡報或協作模式中分享白板",
    "zoomWebMeetingIntegration": "Zoom 網路會議整合",
    "guestAndTemporaryAccessInMeetingWebinar": "會議/網路研討會中的訪客和臨時存取",
    "hostOwnsAllContentCreatedInMeetingAndWebinar": "主持人擁有會議和網路研討會中建立的所有內容",
    "shareClaimAndJoinWhiteboardsInZoomRoom": "在 Zoom Room 中分享、獲取和加入白板",
    "meetingAndWebinarSpecificWhiteboardSettings": "會議和網路研討會特定的白板設定",
    "shareWhiteboardsWithZoomTeamChatsAndChannels": "使用 Zoom Team Chat 和頻道分享白板",
    "unlmitedConcurrentlyEditableWhiteboards": "無限制且可同時編輯的白板",
    "standardFeaturesAndAdvancedDocumentControl": "標準功能和進階文件控制項",
    "canBeAddedToZoomOneBasicOrProPlans": "可以新增至基礎版或專業版 Zoom One 計畫",
    "advancedWhiteboardFeatures": "進階白板功能，包括自訂和組織範本及第三方整合功能",
    "marketing.new_pricing.ai_companion": "AI Companion",
    "companionModalTitle": "Zoom AI Companion",
    "companionModalDesc": "所有 Zoom 平台皆可使用的整合式 AI 助理，顛覆您的日常工作",
    "companionModalContent": "使用可搜尋的轉錄、後續步驟擷取、主題章節和更多功能，快速瀏覽錄製內容;存取即時或會議後摘要，並且透過團體聊天或電子郵件輕鬆與他人分享;當加入直播會議遲到時，詢問 AI Companion 剛才所討論的主題;個人化訊息語氣、長度，以及其他適用於聊天和電子郵件的重寫偏好",
    "enjoyCompanionTipForNN": "Enjoy Zoom AI Companion when you purchase a Zoom One plan!",
    "enjoyCompanionTipForPaid": "Zoom AI Companion 現在適用於所有付費客戶.",
    "enjoyCompanionTip": "Zoom AI Companion 現在適用於所有付費客戶!",
    "marketing.enjoy_companion.more_feature_come": "即將推出更多令人讚嘆的功能！",
    "marketing.enjoy_companion.top_features": "熱門功能",
    "marketing.enjoy_companion.legal_terms": "Zoom AI Companion 包含於 Zoom 使用者帳戶的付費服務，無需額外費用。 可能排除特定垂直產業和地理區域。",
    "subscriptionPlansGreaterThan_50UsdMonth": "超過每個月 50 美元的訂閱方案",
    "subscriptionPlansGreaterThan_200UsdMonth": "超過每個月 200 美元的訂閱方案",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "透過任何裝置簡化視訊會議和傳訊",
    "allPlansClipsCoreFeatureDescription1": "輕鬆錄製、編輯和分享短片",
    "allPlansClipsCoreFeatureDescription2": "無限制的影片和進階功能",
    "allPlansClipsCoreFeatureToolTip": "輕鬆建立、編輯和分享短片。 儲存的短片容易查詢，提高參與度。",
    "allPlansNotesCoreFeatureDescription1": "輕鬆錄製、編輯和分享短片",
    "allPlansNotesCoreFeatureDescription2": "無限制的影片和進階功能",
    "allPlansNotesCoreFeatureToolTip": "Notes 提供強大的個人或協作文件編輯器，設有豐富格式選項，不論是會議中或會議外都能使用。",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "輕鬆進行一對一交流、小型或大型團體",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "快速尋找聯絡人、即時訊息、群組聊天和檔案，動動手指即可掌握各類知識和資訊。",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "直接於 Zoom Team Chat 內使用喜愛的應用程式大幅提高生產力",
    "enhanceCollaborationWithSeamlessFileSharing": "流暢分享檔案增強協作能力",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "絕不錯過任何會議對話。 Zoom Team Chat 中的專屬群組聊天，可為全部與會者提供會議前、會議期間和會議結束後的交流空間。",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "將頻道備份至 Zoom 雲端或第三方儲存空間",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "自訂個人虛擬頭像增添會議趣味性，無須開啟視訊即可展現自我",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "展現參與度並以非口頭的方式和其他與會者快速交流",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "使用各種會議濾鏡注入繽紛樂趣",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "為會議建立單選或複選投票問題。",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Available to all phone standalone customers. Support plans will vary when paired with meetings plans.",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "搜尋我們的知識庫文件以解決技術問題並取得支援資源。",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "尋找解決方案、提出問題並與其他 Zoom 使用者協作的地方。",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "與我們的聊天機器人互動以獲得問題的解答並解決技術問題。",
    "aiCompanion": "AI Companion",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "已翻譯字幕",
    "workspaceReservation": "工作區預約",
    "accessAcrossAnyDevice": "跨裝置存取",
    "directChannelOrGroupChat": "直接聊天、頻道或群組聊天",
    "messageAndFileHistory": "訊息和檔案記錄",
    "findPeopeChannelsAndFilesInSearch": "從搜尋中找到對象、頻道和檔案",
    "applicationIntegrations": "應用程式整合",
    "secureFileSharing": "安全的檔案分享",
    "persistentMeetingChat": "持續會議聊天",
    "cloudStorage": "雲端儲存",
    "avatars": "虛擬頭像",
    "inMeetingReactions": "會議中回應",
    "virtualBackgrounds": "虛擬背景",
    "videoFilters": "視訊過濾器",
    "inMeetingPollsAndQuizzes": "會議中投票/測驗",
    "liveStreamingAcrossPlatforms": "跨平台現場直播",
    "appearanceTouchUp": "美顏",
    "originalSoundForMusicians": "專為音樂人士提供的原始音效",
    "knowledgeBase": "知識庫",
    "zoomCommunity": "Zoom 社群",
    "chatbot": "聊天機器人",
    "submitWebTickets": "提交網頁支援票證",
    "liveChatSupport": "線上聊天支援",
    "livePhoneSupport": "線上電話支援",
    "meetWithAgentOnVideo": "與專員進行視訊",
    "billing.zone_basic_plus.comments.checkout_desc": "Any unused extended meetings do not roll over. Your 4 extended meetings refresh at the beginning of each monthly billing cycle.",
    "billing.zone_basic_plus.comments.extend_your_meetings": "Extend your meetings",
    "billing.zone_basic_plus.comments.extend_your_meetings_desc": "Four {0} minute meetings per month for seamless collaboration",
    "billing.zone_basic_plus.comments.more_great_feature": "More great features",
    "billing.zone_basic_plus.comments.more_great_feature_desc": "Everything from the Basic Free plan, plus {0} GB of Cloud Storage",
    "billing.zone_basic_plus.title": "Zoom One Basic Plus",
    "billing.zone_basic_plus.bill_info": "{number} user  •  {price}{billingCycle}",
    "billing.common.employees": "員工",
    "billing.planform.meeting_license_tips.need_unassign_user": "To proceed with the downgrade, unassign {0} user(s) by {1}. Otherwise, downgrade will not be processed.",
    "billing.planform.meeting_license_decrease_tips.need_decrease_addon": "To decrease the number of users for Zoom One {plan}, you need to adjust the add-on {product} license quantity to be equal to or less than Zoom One {plan}. <a href=\"/billing\">Return to Plan Management</a>",
    "billing.planform.meeting_cycle_tips.can_not_select_monthly": "If you\u2019d like to have a Zoom One {plan} monthly subscription, you need to update your {product} plan to a monthly subscription first.  <a href=\"/billing\">Return to Plan Management</a>",
    "billing.planform.meeting_license_disable_downsell": "You are not able to make this change to your account mid-contract. To contact our team, please use this <a href=\"/billing/contactus?type=downsell&mrs={0}&current_term={1}&renewal_term={2}&subscription_end_date={3}&current_term_period_type={4}&renewal_term_period_type={5}&plan_code={6}&is_one_month={7}\" target=\"_blank\">form</a>.",
    "billing.planform.meeting_license_custom_pricing": "Your account has custom pricing. To decrease the license count, please <a href=\"/billing/contactus\" target=\"_blank\">contact us</a>.",
    "billing.vat_number": "VAT \u7A05\u865F",
    "billing.not_vat_registered": "\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05",
    "billing.not_vat_tips": "\u82E5\u60A8\u662F\u5DF2\u8FA6\u7406\u767B\u8A18\u7684\u6B50\u76DF\u4F01\u696D\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F",
    "billing.vat_checkbox_desc": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u5C07\u6839\u64DA\u6B50\u76DF\u6CD5\u898F\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
    "billing.amMsg": "\u8ACB\u8F38\u5165\u60A8\u7684\u589E\u503C\u7A05\u767B\u8A18\u865F\u78BC",
    "billing.amMsgDesc": "\u4E00\u7D93\u6838\u53D6\u6B64\u65B9\u584A\uFF0C\u672C\u4EBA\u78BA\u8A8D\u81EA\u8EAB/\u6211\u5011\u5DF2\u5728\u4E9E\u7F8E\u5C3C\u4E9E\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\u3002 \u672C\u4EBA\u5C0D\u65BC\u6B64\u8072\u660E\u7684\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u627F\u64D4\u6240\u6709\u8CAC\u4EFB\u3002 Zoom\u5C0D\u65BC\u6B64\u8072\u660E\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u7684\u90E8\u4EFD\u4E0D\u627F\u64D4\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u672C\u4EBA/\u6211\u5011\u5DF2\u5728\u4E9E\u7F8E\u5C3C\u4E9E\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA\u63A5\u53D7\u4E26\u77AD\u89E3Zoom\u5C07\u4E0D\u6703\u6536\u53D6\u4E9E\u7F8E\u5C3C\u4E9E\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u53EF\u80FD\u9700\u8981\u81EA\u884C\u8A55\u4F30\u61C9\u652F\u4ED8\u7684\u589E\u503C\u7A05\u3002",
    "billing.vat_registration_placeholder": "\u589E\u503C\u7A05\u767B\u8A18\u865F\u78BC",
    "billing.registered_for_vat": "\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05",
    "billing.gst_number": "\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u865F\u78BC",
    "billing.not_gst_registered": "\u672A\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05",
    "billing.not_gst_tips": "\u82E5\u60A8\u5C6C\u65BC\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u7684\u4F01\u696D\uFF0C\u8ACB\u8F38\u5165\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u865F\u78BC",
    "billing.not_gst_tips_for_au": "若您是已註冊澳洲 GST 的企業，請輸入您的澳洲商業登記號碼 (「ABN」)。 提供澳洲商業登記號碼 (ABN) 即視同聲明您已註冊澳洲 GST，且取得 Zoom 服務係為在澳洲經營企業之目的 (而非基於私人或您國內的用途)。",
    "billing.gst_checkbox_desc": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3Zoom\u5C07\u6839\u64DA\u7576\u5730\u6CD5\u898F\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u3002",
    "billing.vat_header_val_BS": "\u82E5\u60A8\u5DF2\u5728\u5DF4\u54C8\u99AC\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u60A8\u7684TIN\uFF0C\u8A72\u7DE8\u865F\u5C07\u8F09\u660E\u65BC\u958B\u7ACB\u7D66\u60A8\u7684\u767C\u7968\u4E0A\u3002",
    "billing.vat_header_val_BH": "\u82E5\u60A8\u5DF2\u767B\u8A18\u7E73\u7D0D\u5DF4\u6797\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05ID\u7DE8\u865F\u3002",
    "billing.vat_id_number_placeholder": "\u589E\u503C\u7A05ID\u7DE8\u865F",
    "billing.vat_checkout_popup_message_IS_BH": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u6D88\u8CBB\u8005\u3001\u4F01\u696D\u6216\u653F\u5E9C\u6A5F\u95DC\u4E26\u672A\u767B\u8A18\u7D0D\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002 Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u7A05\u52D9\u72C0\u614B\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u6D88\u8CBB\u8005\u3001\u4F01\u696D\u6216\u653F\u5E9C\u6A5F\u95DC\u4E26\u672A\u767B\u8A18\u7D0D\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u5728\u9069\u7528\u60C5\u6CC1\u4E0B\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
    "billing.vat_header_val_BD": "\u82E5\u60A8\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165BIN",
    "billing.vat_checkout_popup_message_BD": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u672C\u4EBA/\u6211\u5011\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
    "billing.vat_header_val_BB": "\u82E5\u60A8\u5DF2\u5728\u5DF4\u8C9D\u591A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u60A8\u7684\u589E\u503C\u7A05\u7DE8\u865F\uFF0C\u8A72\u7DE8\u865F\u5C07\u8F09\u660E\u65BC\u958B\u7ACB\u7D66\u60A8\u7684\u767C\u7968\u4E0A\u3002",
    "billing.byMsg": "\u8ACB\u8F38\u5165\u60A8\u7684\u7A05\u52D9\u8B58\u5225\u78BC\uFF08TIN\uFF09",
    "billing.inMsg": "\u82E5\u60A8\u5C6C\u65BC\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u7684\u4F01\u696D\uFF0C\u8ACB\u8F38\u5165\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u865F\u78BC\u3002\u82E5\u7121\u6CD5\u63D0\u4F9B\u6709\u6548\u7684GSTIN\uFF0C\u5C07\u5C0E\u81F4\u7121\u6CD5\u958B\u7ACB\u96FB\u5B50\u767C\u7968\u3002\u5C07\u81EA\u52D5\u9A57\u8B49SEZ\u72C0\u614B\u3002<br /><br />ZVC India\u5FC5\u9808\u6838\u767C\u96FB\u5B50\u767C\u7968\u4E26\u63D0\u4F9B\u7D66\u5370\u5EA6\u5883\u5167\u8A3B\u518A\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u7684\u5BA2\u6236\u3002\u70BA\u4E86\u9054\u6210\u6B64\u76EE\u7684\uFF0C\u52D9\u5FC5\u78BA\u4FDD\u60A8\u7684\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u8A3B\u518A\u865F\u78BC\u6240\u6307\u6D3E\u7684\u5DDE\u8207\u4ED8\u6B3E\u53CA\u8CB7\u65B9\u5730\u5740\u7684\u6240\u5728\u5DDE\u4E00\u81F4\u3002",
    "billing.tin_number": "TIN\u865F\u78BC",
    "billing.tax_checkbox_by": "\u514D\u7A05",
    "billing.vat_header_val_KHM": "\u82E5\u60A8\u5DF2\u5728\u67EC\u57D4\u5BE8\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u7A05\u52D9\u8B58\u5225\u78BC\u3002",
    "billing.vat_checkout_popup_message_KHM": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002 Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
    "billing.vat_header_val_CM": "If you are a business customer, enter your NIU and it will be displayed on invoices issued to you",
    "billing.tax_promote_cl": "\u8ACB\u8F38\u5165\u60A8\u7684\u7A05\u7C4D\u7DE8\u865F\uFF08RUT\uFF09\uFF0C\u4E0D\u542B\u5C0F\u6578\u9EDE\u53CA\u9023\u5B57\u865F\u3002",
    "billing.rut_number": "RUT\u865F\u78BC",
    "billing.tax_checkbox_desc_cl": "\u4E00\u7D93\u6838\u53D6\u6B64\u65B9\u584A\uFF0C\u5373\u8868\u793A\u672C\u4EBA\u78BA\u8A8D\u9700\u7E73\u7D0D\u667A\u5229\u589E\u503C\u7A05\uFF0C\u56E0\u6B64Zoom\u4E0D\u61C9\u53E6\u884C\u6536\u53D6\u589E\u503C\u7A05\u3002",
    "billing.vat_header_val_GH": "\u82E5\u60A8\u5DF2\u5728\u52A0\u7D0D\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u7A05\u52D9\u8B58\u5225\u78BC\u3002",
    "billing.vat_header_val_IS": "\u82E5\u60A8\u5DF2\u767B\u8A18\u7E73\u7D0D\u51B0\u5CF6\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05ID\u7DE8\u865F\u3002",
    "billing.tax_promote_vat_cat1": "\u5982\u679C\u60A8\u662F\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\u5BA2\u6236\uFF0C\u8ACB\u9644\u4E0A\u60A8\u7684\u589E\u503C\u7A05\u7DE8\u865F\uFF0C\u800C\u9019\u5C07\u6703\u986F\u793A\u5728Zoom\u70BA\u60A8\u958B\u7ACB\u7684\u767C\u7968\u4E0A",
    "billing.tax_number_on_invoice_tips": "\u82E5\u60A8\u60F3\u8981\u5728\u7531Zoom\u7C3D\u767C\u7D66\u60A8\u7684\u767C\u7968\u4E0A\u986F\u793A\u7D0D\u7A05\u7DE8\u865F\uFF0C\u8ACB\u5728\u9019\u88E1\u8F38\u5165\u8A73\u7D30\u8CC7\u6599\u3002",
    "billing.vat_header_val_KAZ": "\u82E5\u60A8\u5DF2\u5728\u54C8\u85A9\u514B\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F\u3002",
    "billing.keMsg": "\u8ACB\u8F38\u5165\u60A8\u7684\u500B\u4EBA\u8B58\u5225\u78BC\uFF08PIN\uFF09\uFF0C\u8A72\u8B58\u5225\u78BC\u5C07\u8F09\u660E\u65BC\u958B\u7ACB\u7D66\u60A8\u7684\u767C\u7968\u4E0A\u3002",
    "billing.tax_promote_default": "\u82E5\u60A8\u662F\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\u7684\u4F01\u696D\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F",
    "billing.vat_cat2_checkbox_desc": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u5C07\u6839\u64DA\u7576\u5730\u6CD5\u898F\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
    "billing.tax_promote_my": "\u5982\u679C\u60A8\u662F\u5DF2\u767B\u8A18\u7D0D\u7A05\u5BA2\u6236\uFF0C\u8ACB\u9644\u4E0A\u60A8\u7684\u7D0D\u7A05\u7DE8\u865F\uFF0C\u800C\u9019\u5C07\u6703\u986F\u793A\u5728Zoom\u70BA\u60A8\u958B\u7ACB\u7684\u767C\u7968\u4E0A",
    "billing.tax_number_promote.default": "\u82E5\u60A8\u662F\u4F01\u696D\u5BA2\u6236\uFF0C\u8ACB\u8F38\u5165\u60A8\u7684\u7A05\u52D9\u8B58\u5225\u78BC",
    "billing.mdMsgDesc": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u672C\u4EBA/\u6211\u5011\u4E26\u975E\u4F01\u696D\u5BA2\u6236\uFF08\u5373\u91DD\u5C0D\u6469\u723E\u591A\u74E6\u7A05\u52D9\u76EE\u7684\u4E4B\u6CD5\u5F8B\u5BE6\u9AD4\uFF09\u3002 \u672C\u4EBA\u5C0D\u65BC\u6B64\u8072\u660E\u7684\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u627F\u64D4\u6240\u6709\u8CAC\u4EFB\u3002 Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u7A05\u52D9\u72C0\u614B\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u672C\u4EBA/\u6211\u5011\u4E26\u975E\u4F01\u696D\u5BA2\u6236\uFF08\u5373\u91DD\u5C0D\u6469\u723E\u591A\u74E6\u7A05\u52D9\u76EE\u7684\u4E4B\u6CD5\u5F8B\u5BE6\u9AD4\uFF09\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u5728\u9069\u7528\u60C5\u6CC1\u4E0B\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
    "billing.ngMsg": "\u5982\u679C\u60A8\u662F\u4F01\u696D\u5BA2\u6236\uFF0C\u8ACB\u9644\u4E0A\u60A8\u7684\u7A05\u52D9\u8B58\u5225\u78BC\uFF08TIN\uFF09\uFF0C\u800C\u9019\u5C07\u6703\u986F\u793A\u5728Zoom\u70BA\u60A8\u958B\u7ACB\u7684\u767C\u7968\u4E0A\u3002",
    "billing.tax_promote_no": "\u5728\u300CMVA\u300D\u524D\u9762\u8F38\u5165\u60A8\u76849\u4F4D\u6578\u589E\u503C\u7A05ID",
    "billing.mva_number": "\u632A\u5A01\u589E\u503C\u7A05\uFF08MVA\uFF09\u7DE8\u865F",
    "billing.vat_checkout_popup_message_RU": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u4FC4\u7F85\u65AF\u589E\u503C\u7A05\u3002",
    "billing.vat_header_val_RS": "\u82E5\u60A8\u5DF2\u5728\u585E\u723E\u7DAD\u4E9E\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u60A8\u7684\u589E\u503C\u7A05\u7DE8\u865F\uFF0C\u8A72\u7DE8\u865F\u5C07\u8F09\u660E\u65BC\u958B\u7ACB\u7D66\u60A8\u7684\u767C\u7968\u4E0A\u3002",
    "billing.vat_checkout_popup_message_TW": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002 Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u53F0\u7063\u589E\u503C\u7A05\u3002",
    "billing.vat_header_val_TZ": "\u82E5\u60A8\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u767B\u8A18\u865F\u78BC\uFF08VRN\uFF09",
    "billing.tax_promote_tr": "\u82E5\u60A8\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F",
    "billing.ugMsg": "\u82E5\u60A8\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165TIN",
    "billing.vat_header_val_UKR": "\u82E5\u60A8\u5DF2\u5728\u70CF\u514B\u862D\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F\u3002",
    "billing.vat_header_val_VNM": "\u82E5\u60A8\u662F\u4F01\u696D\u5BA2\u6236\uFF0C\u8ACB\u8F38\u5165\u7A05\u52D9\u8B58\u5225\u78BC\u3002\u4E00\u7D93\u8F38\u5165\u7A05\u52D9\u8B58\u5225\u78BC\uFF0C\u5373\u4EE3\u8868\u5BA2\u6236\u8072\u660E\u5176\u70BA\u4F01\u696D\u5BA2\u6236\uFF0C\u56E0\u6B64\u6709\u8CAC\u4EFB\u5411\u8D8A\u5357\u7A05\u52D9\u6A5F\u95DC\u7533\u5831\u4EFB\u4F55\u61C9\u4ED8\u7A05\u91D1\u3002",
    "billing.vat_checkout_popup_message_VNM": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7D0D\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u7A05\u52D9\u72C0\u614B\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u672C\u4EBA/\u6211\u5011\u4E26\u672A\u767B\u8A18\u7D0D\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\uFF08\u5982\u9069\u7528\uFF09\u3002",
    "billing.vat_header_val_GE": "\u82E5\u60A8\u5DF2\u5728\u55AC\u6CBB\u4E9E\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F\u3002",
    "billing.vat_checkout_popup_message": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002 Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6{0}\u7684\u589E\u503C\u7A05\u3002",
    "billing.vat_checkout_popup_message_KAZ": "\u54C8\u85A9\u514B",
    "billing.vat_checkout_popup_message_GE": "\u55AC\u6CBB\u4E9E",
    "billing.vat_checkout_popup_message_UKR": "\u70CF\u514B\u862D",
    "billing.gst_checkbox_desc_template": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u62D2\u7D55\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u5C07\u6839\u64DA{0}\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u3002",
    "billing.tax_checkbox_desc_non_inr_in": "\u5370\u5EA6\u6CD5\u898F",
    "billing.tax_promote_co": "\u5982\u679C\u60A8\u662F\u589E\u503C\u7A05\u4EE3\u7406\u4EBA\uFF0C\u4E14\u60A8\u8A8D\u70BA\u7531Zoom\u63D0\u4F9B\u7684\u7522\u54C1\u61C9\u514D\u5FB5\u589E\u503C\u7A05\uFF0C\u8ACB\u65BC\u7A05\u7C4D\u7DE8\u865F\u6B04\u4F4D\u4E2D\u9078\u53D6\u300C\u589E\u503C\u7A05\u4EE3\u7406\u4EBA\u300D\u6216\u300CAgente de IVA\u300D\u503C\u3002\u5982\u679C\u60A8\u9078\u53D6\u6B64\u9078\u9805\uFF0C\u5247\u60A8\u5728\u54E5\u502B\u6BD4\u4E9E\u589E\u503C\u7A05\u7533\u5831\u671F\u9593\u4FBF\u6709\u7FA9\u52D9\u9032\u884C\u7533\u5831\u3002",
    "billing.byCheckboxMsg": "\u4E00\u7D93\u6838\u53D6\u6B64\u65B9\u584A\uFF0C\u5373\u8868\u793A\u672C\u4EBA\u78BA\u77E5\u884C\u70BA\u4EE3\u8868\u4F01\u696D\u5BA2\u6236\uFF08\u5373\u91DD\u5C0D\u767D\u4FC4\u7F85\u65AF\u7A05\u52D9\u76EE\u7684\u4E4B\u6CD5\u5F8B\u5BE6\u9AD4\uFF09\uFF0C\u4E14\u672C\u4EBA\u4E26\u975E\u91DD\u5C0D\u767D\u4FC4\u7F85\u65AF\u7A05\u52D9\u76EE\u7684\u4E4B\u500B\u4EBA\u6216\u55AE\u7368\u4F01\u696D\u5BB6\u3002 \u672C\u4EBA\u5C0D\u65BC\u6B64\u8072\u660E\u7684\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u627F\u64D4\u6240\u6709\u8CAC\u4EFB\u3002 Zoom\u5C0D\u65BC\u6B64\u8072\u660E\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u7684\u90E8\u4EFD\u4E0D\u627F\u64D4\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u70BA\u4E86\u8B49\u660E\u672C\u4EBA\u884C\u70BA\u4EE3\u8868\u4F01\u696D\u5BA2\u6236\u800C\u975E\u91DD\u5C0D\u767D\u4FC4\u7F85\u65AF\u7A05\u52D9\u76EE\u7684\u4E4B\u500B\u4EBA\u6216\u55AE\u7368\u4F01\u696D\u5BB6\uFF0C\u672C\u4EBA\u63A5\u53D7\u4E26\u77AD\u89E3Zoom\u5C07\u4E0D\u6703\u6536\u53D6\u767D\u4FC4\u7F85\u65AF\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA\u6240\u4EE3\u8868\u7684\u4F01\u696D\u5BA2\u6236\u53EF\u80FD\u9700\u8981\u81EA\u884C\u8A55\u4F30\u61C9\u652F\u4ED8\u7684\u589E\u503C\u7A05\u3002",
    "billing.uzCheckboxMsg": "By checking this box, I acknowledge that I am acting on behalf of a business customer (i.e. a legal entity for Uzbekistan tax purposes) and I am not an individual or individual entrepreneur for Uzbekistan tax purposes. I take full responsibility for the accuracy and completeness of this statement. Zoom waives any responsibility to accept liability due to either an incomplete or an inaccurate statement. Furthermore, in certifying that I am acting on behalf of a business customer and not an individual or individual entrepreneur for Uzbekistan tax purposes, I accept and understand that Zoom will not charge Uzbekistan VAT and the business customer I am acting on behalf of may be required to self-assess for VAT due.",
    "billing.vat_header_val_OM": "\u82E5\u60A8\u5DF2\u5728\u963F\u66FC\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F\u3002",
    "billing.vat_checkout_popup_message_OM": "\u963F\u66FC",
    "billing.tax_promote.include_your_vat_number": "\u82E5\u60A8\u662F\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\u7684\u5BA2\u6236\uFF0C\u8ACB\u9644\u4E0A\u589E\u503C\u7A05\u7DE8\u865F",
    "billing.vat_header_val_TW": "\u82E5\u60A8\u5DF2\u5728\u53F0\u7063\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F\u3002",
    "billing.tax_checkbox_desc_template": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u5C07\u6839\u64DA{0}\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
    "billing.tax_checkbox_desc_no": "\u632A\u5A01\u6CD5\u898F",
    "billing.tax_checkbox_desc_tr": "\u571F\u8033\u5176\u6CD5\u898F",
    "billing.tax_input_placeholder": "\u7A05\u52D9\u8B58\u5225\u78BC",
    "billing.pin_number": "PIN\u78BC",
    "billing.tax_checkbox_md": "\u975E\u4F01\u696D\u5BA2\u6236",
    "billing.xx_and_above": "{0} 或以上",
    "billing.under_xx": "{0} 以下",
    "billing.sign_up_error_msg_1": "請更新或取消變更以註冊",
    "billing.dont_have_account": "還沒有帳戶？",
    "billing.sign_in_df_account": "登入不同帳戶",
    "billing.common.form_xx_month": "每月 {0} 起",
    "billing.common.from_xx_month_after_trial": "試用 {duration} 天後，每月 {price} 起",
    "billing.common.save_count": "省下 {0}",
    "billing.error.empty_valid": "需要{0}",
    "billing.error.inr_non_india_error": "若要以 INR 完成購買，您的聯絡人地址必須在印度。 如果您要選取不同國家/地區，請",
    "billing.error.inr_non_india_error_switch_to_usd": "切換為 USD",
    "billing.address.address_line2": "地址行 2",
    "billing.address.phone": "\u96FB\u8A71\u865F\u78BC",
    "billing.see_more": "查看更多",
    "billing.enhance_experience": "提升您的 Zoom 體驗",
    "billing.create_account.sign_up": "註冊",
    "billing.create_account.sign_up_desc": "您將成為此帳戶的擁有者，並具有完整的管理功能使用權限。",
    "billing.create_account.sign_up_desc_for_zp": "您將成為此帳戶的擁有者，並具有完整的管理功能使用權限。 Zoom Phone 僅供商業版使用。",
    "billing.create_account.have_account": "有帳戶了嗎？",
    "billing.create_account.sign_in": "登入",
    "billing.create_account.age": "年齡",
    "billing.create_account.password": "密碼",
    "billing.password.mustMatchAll": "密碼必須符合所有要求",
    "billing.create_account.continue_to_address": "繼續填寫地址",
    "billing.create_account.full_name": "全名",
    "billing.create_account.sdk_registered": "為能購買視訊SDK，您必須使用新的個別Zoom帳戶位址以用於應用程式開發用途。",
    "billing.create_account.sdk_registered_new": "The email address you’ve entered is associated with an existing account. Please create a new account with a different email address to purchase Video SDK.",
    "billing.address.business_info": "公司資訊",
    "billing.pay_method.save_pay_method": "儲存付款方式",
    "billing.pay_method.continue_to_order_review": "繼續前往訂單檢閱",
    "billing.pay_method.verify_pay_method": "驗證付款方式",
    "billing.common.n_a": "不適用",
    "billing.order_summary": "訂單摘要",
    "billing.order_summary_current": "目前方案",
    "billing.order_summary_updated": "已更新的訂單摘要",
    "billing.order_summary.item_ss": "項目",
    "billing.order_summary.annual_subscription": "年度訂閱",
    "billing.order_summary.monthly_subscription": "每月訂閱",
    "billing.order_summary.quarterly_subscription": "每季訂閱",
    "billing.order_summary.two_years_subscription": "兩年訂閱",
    "billing.order_summary.three_years_subscription": "三年訂閱",
    "billing.order_summary.subtotal": "小計",
    "billing.order_summary.total": "總計",
    "billing.order_summary.todays_total": "今日總計",
    "billing.order_summary.todays_total_tip_upgrade": "\u4eca\u5929\u7684\u8cbb\u7528\u5c07\u4f9d\u6bd4\u4f8b\u8a08\u7b97\uff0c\u4e26\u6703\u5728\u60a8\u5b8c\u6210\u8a02\u55ae\u6642\u4e00\u4f75\u8a08\u7b97\u3002\u60a8\u6703\u6536\u5230\u8f09\u660e\u6700\u5f8c\u7e3d\u91d1\u984d\u7684\u767c\u7968\u3002",
    "billing.order_summary.total_billed_monthly": "每月結算總計",
    "billing.order_summary.total_billed_monthly_new": "新的每月總計",
    "billing.order_summary.total_billed_monthly_current": "目前每月總計",
    "billing.order_summary.total_billed_quarterly_current": "目前每季總計",
    "billing.order_summary.total_billed_two_years_current": "目前兩年總計",
    "billing.order_summary.total_billed_three_years_current": "目前三年總計",
    "billing.order_summary.total_billed_annually": "每年結算總計",
    "billing.order_summary.total_billed_quarterly": "每季收費總計",
    "billing.order_summary.total_billed_quarterly_new": "新的每季總計",
    "billing.order_summary.total_billed_two_years": "兩年收費總計",
    "billing.order_summary.total_billed_two_years_new": "新的兩年總計",
    "billing.order_summary.total_billed_three_years": "三年收費總計",
    "billing.order_summary.total_billed_three_years_new": "新的三年總計",
    "billing.order_summary.total_billed_annually_new": "新年度總計",
    "billing.order_summary.total_billed_annually_current": "目前年度總計",
    "billing.order_summary.total_billed_trial_tip": "{date}，您將自動註冊 {plan} {billingCycle} 訂閱，並向您收取剩餘計費期間按比例結算的費用。如果您在 {date} 之前取消免費試用，您的總 {billingCycle} 帳單將自動調整，以排除 {plan}。",
    "billing.order_summary.next_charge_date": "下一個收費日期",
    "billing.order_summary.extra_charges": "附加適用稅金、規費和超量費用",
    "billing.order_summary.plus_applicable_taxes": "附加適用稅金",
    "billing.order_summary.prorated_title": "\u4ECA\u5929\u7684\u8CBB\u7528\u662F\u591A\u5C11\uFF1F",
    "billing.order_summary.prorated_desc": "今天，我們將會針對您的下次訂閱期間，收取按比例收費與全額收費費用 (不包含非自動續約的計畫)。",
    "billing.order_summary.prorated_cycle_change_desc": "您將會收到現有方案未使用期間產生的額度。 此額度將套用至您的新方案，您將從今天開始支付該方案的費用。",
    "billing.order_summary.prorated_upsell_desc": "今天，我們將會針對您的下次訂閱期間，收取按比例收費與全額收費費用 (不包含非自動續約的計畫)。",
    "billing.order_summary.prorated_downsell_desc": "-",
    "billing.order_summary.taxes_desc": "根據您提供的帳單資訊，您的購買可能需要支付當地的稅金。 最終收取的費用可能與此處顯示的金額不同，實際費用會顯示在您的發票上。",
    "billing.order_summary.taxes_desc2": "依據您提供的帳單資訊，您的購買可能需要繳納地方稅。 最終收取的費用可能與此處顯示的金額不同，實際費用會顯示在您的發票上。",
    "billing.order_summary.prorated_charge_today": "按比例收取今日費用",
    "billing.order_summary.inr_discount_title": "您收到了一筆 {discount}% 的折扣",
    "billing.order_summary.inr_discount_tooltip": "訂閱 Zoom Workplace 專業版年度方案可享 {discount}% 折扣優惠。優惠不得併用其他折扣券。",
    "billing.order_summary.expire_date": "於 {date}到期",
    "billing.address.street_address": "街道地址",
    "billing.essential_apps.dialog_desc": "使用會議記錄、互動式活動提升團隊參與感、提供見解以增進客戶對話，發展和管理您的業務。 您的計劃包含 1 年免費使用付費應用程式。",
    "billing.essential_app.legal_copy": "優惠僅適用於目前授權，即 2023 年 1 月 4 日當日或之後，透過 Zoom 的線上通路 zoom.us/buy 購買 Zoom One Pro、商業版或商業加強版訂閱者。 訂閱醫療保健、教育或政府帳戶的使用者，不符合本次優惠條件。  除了 Coda 以外，每一款應用程式自個別使用者啟用應用程式後 1 年到期，依此類推。 Coda 所有使用者皆使用相同 Zoom 帳戶，由相同 Zoom 帳戶內任何使用者第一次啟用 Coda 後開始計算，相同 Zoom 帳戶內所有使用者皆於該啟用後 1 年到期，無論後續相同 Zoom 帳戶內的使用者啟動的日期為何。對於所有應用程式，重新分配或取消使用者的合格授權或訂閱，無論 1 年使用期限是否尚未到期，都將終止該使用者的使用權限。啟用每一個應用程式時，都適用於自身的使用條款和隱私權政策。包含的應用程式目前僅支援英語。並非所有應用程式都適用於行動裝置。優惠無法以現金形式返回或退款。優惠僅適用於內含在 <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a> 中的必要應用程式所列的這些應用程式。 任何應用程式的現有訂閱使用者，皆不適用這些特定應用程式的本次優惠。Zoom 有權隨時修改或取消此優惠，且無須事先通知。",
    "billing.buyItNow.signup.zoom_phone_tos": "Zoom Phone由電信業者Zoom Voice Communications所提供。請參閱<a href=\"https://zoom.us/zh-tw/terms\" target=\"_blank\">服務條款</a>以取得適用於Zoom Phone之電信業者的相關資訊。",
    "billing.planform.pbx.auto_remove_unlimited_addons_info": "\u60A8\u5DF2\u522A\u9664\u81EA\u8EAB\u7121\u9650\u91CF\u570B\u969B\u901A\u8A71\u65B9\u6848\u7684\u6240\u6709\u9069\u7528\u65B9\u6848\uFF0C\u5C07\u5F9E\u8A02\u55AE\u79FB\u9664\u9019\u4E9B\u65B9\u6848\u4EE5\u7E7C\u7E8C\u3002",
    "billing.planform.pbx.auto_remove_unlimited_addons_title": "\u5C07\u6703\u79FB\u9664\u7121\u9650\u91CF\u570B\u969B\u901A\u8A71\u65B9\u6848",
    "billing.zoom_one_pro.desc": "用於會議、團體聊天、白板、電話等多功能的整合解決方案",
    "billing.terms.marketing_word": "I would like to receive marketing communication from Zoom. I understand that I can unsubscribe at anytime.",
    "billing.error.edu_invalid_emial_msg": "您的電子郵件地址不能用於註冊教育帳戶。請使用教育網域的電子郵件地址或<a href=\"/contactsales\" target=\"_blank\">聯絡銷售人員</a>以進行手動驗證。",
    "billing.pbx.additional_phone_numbers": "Additional Phone Numbers",
    "billing.pbx.additional_phone_numbers_desc": "Assign local phone lines for a regional presence to team members or departments, and manage all numbers from one account.",
    "billing.pbx.local_and_tf": "Local and Toll-free Numbers",
    "billing.pbx.additional_phone_numbers_config.desc": "Add local numbers to help create a regional presence or manage different departments. Each number is {amount}{unit}.",
    "billing.pbx.additional_phone_numbers_config.local_and_tf_desc": "Add local phone lines to establish a regional presence, or toll-free numbers so others can contact you free of charge.",
    "billing": {
      "invoice": {
        "invoice_tips": "您的未結清發票會反映您的帳單到期日（{0}）之前這段期間的費用，直到您因未付款而降級為免費方案。",
        "warning": "您需要將未結清發票連同新購買一起支付才能完成購買。",
        "cart": {
          "label": "未結清發票",
          "unit": "{0} 張發票",
          "with_credit_balance_desc": "今日總額包括過往訂閱的未支付發票，以及將 {0} 額度套用至未使用天數的發票總額。"
        }
      },
      "view_requirements": "檢視要求",
      "document_require_for_gs": "Documentation may be required for Global Select.",
      "gs_desc": "Choose unlimited regional calling with a local number for each user, or get Global Select with a local number and unlimited calling per user in eligible countries.",
      "gs_only_desc": "Global Select provides each user a phone number and unlimited calling within one of the available countries.",
      "select_an_upgrade_option": "Select an Upgrade Option",
      "pbx_to_props_desc": "You currently have a Zoom Phone plan. You can bundle it with Zoom Workplace Pro Plus to transfer your existing phone numbers and settings, or keep your current phone plan and add a new one. If you decide to upgrade your Zoom Phone plan, all Zoom Phone licenses in the same region(s) will be upgraded together.<br/><br/>Note: BYOC, 3rd party PBX, and VDI are not included with Zoom Phone in Zoom Workplace Pro Plus.",
      "add_a_new_plan": "Add a New Plan",
      "bundle_plans": "Bundle Plans",
      "bill_monthly": "按月結算",
      "bill_annually": "年度結算",
      "bill_quarterly": "按季結算",
      "bill_two_years": "每兩年結算一次",
      "bill_three_years": "每三年結算一次",
      "limited_features": "功能有限",
      "docs": {
        "docs": "Docs",
        "features_item1": "用於產生內容和翻譯的 AI Companion",
        "features_item2": "可與您的團隊無限分享的文件數量",
        "features_item3": "存取無限版本歷史紀錄",
        "comparison_table_tips": "將想法和資訊整理在採用 AI 技術的文件中，以適應不同的團隊和專案需求。"
      },
      "tasks": {
        "tasks": "Tasks",
        "features_item1": "發揮 AI Companion 的威力，從您的聊天、電子郵件、文件、白板和會議摘要中識別和建立任務",
        "features_item2": "輕鬆排序、篩選、分組和搜尋，以快速存取和收集任務的背景資訊",
        "tooltip": "AI 優先解決方案可根據 Zoom Workplace 中的對話和會議摘要提供任務建議，幫助您隨時掌握行動項目並按時加以完成。",
        "comparison_table_tips": "AI 優先解決方案可根據 Zoom Workplace 中的對話和會議摘要提供任務建議，幫助您隨時掌握行動項目並按時加以完成。"
      },
      "custom_avatars": {
        "title": "自訂虛擬頭像",
        "tooltip": "自訂虛擬頭像可為您打造栩栩如生的 AI 版本，具有聲音複製和多語溝通功能.",
        "comparison_table_tips": "自訂虛擬頭像可為您打造栩栩如生的 AI 版本，具有聲音複製和多語溝通功能.",
        "feature": "每月 3 分鐘",
        "basic_feature": "每人一生 1 分鐘",
        "features_item1": "每月最多可創造 3 個栩栩如生的數位虛擬人偶，複製您的外表和聲音，以進行簡報和示範",
        "features_item2": "透過 AI Companion，使用您的虛擬人偶提供最多 3 分鐘的講稿"
      },
      "zoom_docs": {
        "title": "Zoom Docs",
        "plan_details": {
          "desc2": "在單一文件中輕鬆編譯文字、圖像等內容",
          "desc3": "可透過任何裝置在會議期間和會議以外協作",
          "desc4": "輕鬆存取和恢復您的文件歷史紀錄"
        },
        "current_account_includes_zoom_docs": "您帳戶中每位已獲授權的使用者都能存取 Zoom Docs。如果您購買更多授權，可以將他們指派至帳戶中的任何基本版使用者。"
      },
      "workspace_reservation": {
        "title": "工作區預約",
        "plan_details": {
          "desc1": "透過 Zoom Workplace 應用程式、桌面或瀏覽器，存取工作區和飯店預訂",
          "desc2": "在 AI 的協助下，接收個人化的辦公桌建議",
          "desc3": "直接從 Google 日曆或 Outlook 預約工作區，兩者皆具備提醒和報到警示功能",
          "desc4": "使用路線指引功能前往預約的工作區"
        },
        "addon": {
          "desc": "使用 Zoom 整合裝置，輕鬆預約彈性工作區或預訂飯店房間，提前或現場預約都沒問題。"
        }
      },
      "modal": {
        "tips": "需要免稅驗證嗎？",
        "proceed_to_checkout": "前往結帳",
        "payment_not_support_modal_tips": "{0} 僅支援新的瀏覽器視窗，您需要重新輸入您的帳戶資訊。",
        "continue_with_paypal": "繼續以 Paypal 支付",
        "apple_pay_modal_tips": "{0} is only supported on eligible Apple devices running Safari browser, where you will need to re-enter your account information.",
        "continue_with_apple": "繼續以 Apple Pay 支付",
        "continue_with_google": "繼續以 Google Pay 支付",
        "your_account": "您的帳戶",
        "signed_in_as": "以 <b>{0}</b> 登入"
      },
      "comparison": {
        "required_in_most_plans": "大部分方案需要",
        "include_in_most_plans": "包含在大部分方案內",
        "30_hours": "30 小時",
        "hubSpot_integration": "HubSpot 整合",
        "salesforce_integration": "Salesforce 整合",
        "included_in_zoom_webinars_attendees": "包含在 Zoom Webinars 訂閱、單月，以及 20,000 至 100,000 名觀眾的單次方案內。",
        "in_webinar_chat_only": "僅限網路研討會中聊天",
        "compare_all_features": "比較所有功能",
        "footer_desc": {
          "feature": "對於沒有 Zoom One 付費方案的客戶，購買 Zoom Webinars 單次方案即可在購買後三個月內使用 Zoom One 專業版。",
          "event_attributes": "對於 Zoom Webinars 單次方案，超過三小時的網路研討會可能需要額外付費的諮詢服務。想了解更多資訊，<a href=\"https://explore.zoom.us/en/event-services/\">請與活動服務聯絡</a>",
          "audience_engagement": "單次方案是否適用 250,000 名以上觀眾的網路研討會功能，可能因諮詢服務支援範圍而異。",
          "integration": "不包含在 250,000 名以上觀眾的 Zoom Webinars 單次方案中。",
          "additional_features": "Zoom Webinars 單次方案內含 5 小時。"
        }
      },
      "message": {
        "billing_cycle_update_alert": "The billing cycle for the {0} plan has been updated to {1}, which is required for purchasing the {2} {3} subscription.",
        "undo_change": "Undo change"
      },
      "zcm": {
        "title": "由 Theta Lake 技術支援的 Zoom 合規管理工具",
        "description": "透過歸檔、電子蒐證 (e-Discovery) 和資料治理的專門解決方案，精簡法規遵循工作。",
        "select_license_tip": "在您的帳戶中，一個授權允許一位使用者使用。",
        "max_license": "上限為 {0} 個授權。",
        "license_count_tool_tip": "Zoom 合規管理工具之授權數量不可多於您的 {0} 使用者人數。您可在方案管理編輯您的 {0} 授權數量。",
        "plan_details": {
          "desc1": "簡化會議、網路研討會、團體聊天等的溝通與協作歸檔",
          "desc2": "利用電子蒐證 (eDiscovery) 的搜尋功能，輕鬆找到重要的通訊紀錄",
          "desc3": "可在 Zoom Web 入口網站內直接執行以簡化歸檔、電子蒐證 (eDiscovery) 和依法保留要求等作業",
          "desc4": "每個授權可存取 10 GB 儲存空間 (可視需求購買擴充空間)"
        }
      },
      "zcm_storage": {
        "title": "由 Theta Lake 技術支援的 Zoom 合規管理工具 - 額外儲存空間",
        "description": "您帳戶中 (每個授權) 有 {0} 儲存空間。新增更多儲存空間，分享給帳戶中所有已授權的使用者。"
      },
      "vat_SN_message": "若您已登記繳納加值稅 (VAT)，請輸入稅務識別碼，以作為發票開立資訊。",
      "vat_SN_placeholder": "稅務識別碼",
      "uin_placeholder": "Unique Identification Number",
      "empty_tin": "Tax number is required",
      "invalid_tin": "This tax number is not valid",
      "state_mismatch": "Your State/province under the Address field and the GST number are not aligned. Please verify and update the correct details in the State/province in the Address field and/or the GST number",
      "empty_uin": "Unique Identification Number is required",
      "invalid_uin": "or invalid Unique Identification Number. Please check and validate that both your TRN and UIN are valid.",
      "zone_pro_plus": {
        "title": "Zoom Workplace 專業加強版",
        "select_local_number_title": "選擇使用者人數",
        "select_local_number_desc": "每名使用者都將收到一個本地號碼，用於無限制區域通話。最少要有 1 位使用者。",
        "explore_other_plans_cta": "探索其他計畫",
        "pbx_base_title": "如何處理區域和國際費用？",
        "brief_title": "專業加強版",
        "max_user_tips": "最多 {0} 位使用者。",
        "pro_plus_phone_features": "Chat only"
      },
      "zoom_enterprise_named_host": {
        "title": "Zoom 企業版指定主機"
      },
      "zoom_one_pro": {
        "set_up_success_msg": "What's next? Set up your new plan to get your organization and team members up and running."
      },
      "zoom_one_biz": {
        "set_up_success_msg": "What's next? Set up your new business plan to get your organization and team members up and running.",
        "continue_with_lm": "想繼續主持超過 100 名與會者的會議嗎？使用<a href=\"#\">大型會議</a>提高會議容量",
        "unlock_license_limit": "您現在可以將使用者數量設定在 10 名以下。",
        "license_limit_with_lm": "Large Meeting 購買要求 Zoom Workplace Pro 的授權數量必須等於或大於目前指派給您帳戶中使用者 Zoom Workplace Business 的授權數量。"
      },
      "zoom_clips_plus": {
        "title": "Zoom Clips Plus",
        "easily_record_desc": "輕鬆錄製、編輯和分享短片",
        "unlimited_videos_desc": "無限制的影片和進階功能",
        "current_account_includes_zoom_clips": "您帳戶內的每名 Zoom One 授權使用者皆可使用 Zoom Clips。 如果您購買更多授權，您可以將他們指派至帳戶中的任何基礎版使用者。"
      },
      "trial": {
        "title": "\{0\} 試用版",
        "duration_desc_cart": "\{0\} 天免費試用",
        "start_date": "自 {0} 開始",
        "unit_suffix": "試用期結束後價格 \{0\}",
        "trial_charge_terms_desc": "您的 {0} 天免費試用將於 {1} 結束。 除非您在 {1} 前取消，否則您須就{3}週期性訂閱支付 {2} 與適用稅費。 從今起直到您取消之前，付費訂閱將會自動續訂。 在下一次續約日前，您可隨時前往 <a href=\"/billing\" target=\"_blank\">zoom.us/billing</a> 取消訂閱。",
        "trial_manually_title": "即將完成",
        "trial_manually_title2": "指派您的免費試用",
        "trial_manually_assign": "請選取使用者管理，確認免費試用是否自動指派給帳戶中正確的使用者。",
        "trial_manually_assign2": "您的免費試用已開始。 若要開始使用，請將授權指派給自己或您帳戶中的某位使用者。",
        "trial_manually_assign_btn": "指派給使用者",
        "trial_auto_assign_title": "您可以立即開始使用 \{0\} 免費試用",
        "trial_auto_assign_subtitle": "下一步是什麼？ 設定您的 \{0\}，充分利用您的免費試用體驗。",
        "start_free_trial_btn": "設定 \{0\}",
        "buy_trial_success": "您的免費試用已開始。 設定您的 \{0\}，充分利用您的免費試用體驗。",
        "upgrade_paid_success": "您的免費試用已升級為付費方案。",
        "upgrade_paid_success_desc": "此訂閱從 {0} 開始。 已向您計費 {1}。 此訂閱將於 {2} 自動續訂。",
        "ineligible_hint": "您的帳戶 {0} 不符合 {1} 的資格。 如需使用 {2}，請購買該方案。",
        "ineligible_hint_nn": "我們很遺憾您不符合免費試用 {0} 的資格。",
        "trial_days_free": "{0}-day free",
        "paid_plan_required_when_add_plans": "\{0\} requires a paid {1}, Your {2} will automatically convert to a paid subscription when you place the order.",
        "paid_plan_required_when_add_plans_confirm_title": "Confirm order to start paid subscription",
        "paid_plan_required_when_add_plans_confirm_content": "After placing the order, your {0} will be canceled, and you will be automatically enrolled into a paid subscription.",
        "saas": {
          "trial_success_desc": "在 Zoom Events 平台上使用隨選視訊、多種視訊版面及其他功能發布免費活動。",
          "trial_success_unlimited_desc": "在 Zoom Events 平台上發布無限制的免費活動、多樣化的視訊版本等。"
        },
        "webinar": {
          "back_to_webinar": "返回 webinars"
        },
        "try_for_n_days": "試用 {0} 天",
        "or_buy_now": "或立即購買",
        "free_trial": "免費試用"
      },
      "landing": {
        "zone": {
          "solution": {
            "title": "多功能解決方案的優勢",
            "audio": "透過 Zoom 特有的易用性體驗一流的視訊和音訊品質",
            "upvote": "透過全方位的溝通和協作工具增強員工和客戶關係",
            "computer_desk": "使用單一應用程式簡化工作流程、提高工作效率並降低應用程式疲勞",
            "v1": {
              "audio": "智慧協作工具可協助推動專案流程，且您可透過簡化的功能，從聊天開啟通話或在白板上協作。",
              "upvote": "濾鏡、表情、投票、舉手表決以及影音共享功能，增加虛擬會議樂趣和參與感。",
              "computer_desk": "操作簡易的平台，為您的行動裝置或桌上型電腦提供無縫、自動化的使用者體驗。"
            }
          },
          "question": {
            "title": "常見問題解答",
            "tools_introduce": {
              "title": "什麼是協作工具？",
              "desc": "協作工具提供團隊透過視訊、聊天、電話和白板分享資訊的方法。"
            },
            "tools_advantages": {
              "title": "使用線上協作工具有哪些優勢？",
              "desc": "線上協作工具讓分散的團隊無論身在何處，都能更輕鬆地集思廣益、分享資訊並完成工作。"
            },
            "tools_work": {
              "title": "協作工具如何運作？",
              "desc": "協作工具提供與企業內外部各方互動和通訊的不同方式，因此您可以輕鬆地分享檔案、想法、資訊更新等。"
            },
            "tools_type": {
              "title": "協作工具有哪些不同類型？",
              "desc": "協作工具提供用於撥打的電話、用於線上會議的視訊、用於一對一與團隊傳訊和檔案分享的聊天，以及用於腦力激盪的拖放式白板。"
            },
            "tools_effective": {
              "title": "線上協作是否有效？",
              "desc": "有效！ 線上協作非常有效，因為無論團隊位於何處或哪個時區，都可以輕鬆相互交談和協作。"
            },
            "tools_use": {
              "title": "我應該在哪裡使用協作工具？",
              "desc": "協作工具可以在任何地方使用：家中、辦公室、會議室、車上、飛機上等等！"
            }
          },
          "feature": {
            "elevate": {
              "title": "透過 Zoom One 讓您的工作流程更上一層樓",
              "subtitle": "體驗更順暢的溝通和無縫整合，這將改變您建立、協作和創新的方式。"
            },
            "ai_title": "智慧 AI 助理",
            "ai_desc": "透過我們 Zoom AI Companion 的摘要、撰寫等智慧功能，提高生產力並增進團隊效益。",
            "zwb_title": "數位白板",
            "zwb_desc": "使用我們持續的虛擬協作空間進行腦力激盪、規劃和學習。 Zoom Whiteboard 方便團隊隨時隨地透過便條紙、繪圖工具、評論等處輕鬆揮灑創意。",
            "mail_title": "郵件與日曆",
            "mail_desc": "透過我們支援 Microsoft 365、Google 或 Zoom Mail 和 Calendar 服務的電子郵件和日曆解決方案，將您的重要通訊整合於一處。",
            "clips_title": "視訊片段",
            "clips_desc": "使用 Zoom Clips 提升日常溝通效率。 錄製、編輯和分享高品質短片訊息，以節省相互聊天的時間並減少會議時間。",
            "meeting_title": "虛擬會議",
            "meeting_desc": "透過可靠的高解析音訊和視訊互動，將團隊聚集在一起。 Zoom Meetings 專為現代團隊打造，具有畫面分享、聊天和翻譯等協作和包容性功能。",
            "chat_title": "團體聊天",
            "chat_desc": "透過我們的持續性團隊協作解決方案 Zoom Team Chat，在聊天和頻道之間保持資訊流動且井然有序，該解決方案與 Zoom 產品和第三方應用程式緊密整合。",
            "phone_title": "電話系統",
            "phone_desc": "使用我們可靠且多功能的雲端電話系統，可在任何裝置上撥打和接聽電話，適合各種規模的企業。 Zoom Phone 很容易部署，專為現代協作時代而打造。",
            "scheduler_title": "排程器",
            "scheduler_desc": "使用 Zoom Scheduler 現場安排會議。 您可以刪除不必要的排程應用程式，進而節省時間和金錢。",
            "workspace_title": "工作區預約",
            "workspace_desc": "使用現代工作解決方案提升您的辦公室體驗。 使用 Zoom 工作區預約功能，您可以讓混合式會議更具包容性，並支援彈性的工作區。",
            "notes_title": "註釋",
            "notes_desc": "使用 Zoom Notes 更有效地進行協作，它是一款內建專屬筆記應用程式，可讓您快速擷取想法、行動項目等。",
            "cmr_title": "雲端錄製",
            "cmr_desc": "從 Zoom 雲端直接儲存、串流播放和下載視訊錄製檔案。",
            "scheduler_desc_v1": "輕鬆分享辦公時間、面試等會議時段。"
          }
        }
      },
      "video_sdk_uc": {
        "title": "Zoom SDK Universal Credit",
        "subtitle": "透過套裝產品和所有 SDK 服務方案的預付額度靈活性，大幅提高建置效果",
        "credit_rates_cta": "額度比率",
        "select_plan_title": "Select your plan",
        "feature_title": "包括 SDK，外加：",
        "credits_unit": "/month/{0} credits",
        "feature_bundle": {
          "title": "多功能綁約解決方案",
          "desc": "單一訂閱即可使用所有 SDK 服務方案"
        },
        "feature_flexible": {
          "title": "適用於任何 SDK 服務的彈性額度使用量",
          "desc": "額度適用於任何 SDK 服務，包括翻譯、QSS、雲端會議室連接器 (CRC) 等"
        },
        "feature_recommend": {
          "title": "使用 {0} 額度計畫省下更多費用",
          "desc": "每個月獲得更多額度，同時省下更多費用"
        },
        "feature_for_future": {
          "title": "將額度用於未來的 SDK 產品",
          "desc": "千萬別錯過使用即將推出的 SDK 服務的機會"
        },
        "feature_cobrowsing": {
          "title": "Cobrowse SDK",
          "desc": "Secure, real-time screen sharing with sensitive data masking"
        },
        "credit_rate_dialog": {
          "title": "Zoom SDK Universal Credit Value",
          "subtitle": "Usage from each product included will be converted into credits. For example, {amount} {currency} or {credit} credits for a Video SDK Session is worth {time} mins.",
          "desc": "*SDK 服務使用量是由每月會議會程分鐘數決定。 例如，5 名使用者參加一場 10 分鐘的會議，則共計為 50 分鐘。 不滿一分鐘以一分鐘計算。",
          "note1": "視訊 SDK 工作階段的使用將根據可歸因於客戶和/或客戶應用程式使用者發起的工作階段 (「工作階段分鐘數」)，每月使用的總工作階段分鐘數來測量。例如，如果有 5 個終端使用者透過客戶的應用程式參加 10 分鐘的工作階段，則使用的工作階段分鐘數共計 50 分鐘。不滿一分鐘以一分鐘計算。",
          "note2": "一分鐘的轉錄文字會消耗一個標準轉錄文字分鐘數。一個翻譯會消耗兩個標準轉錄文字分鐘數。",
          "note3": "雲端錄製分鐘數包括組合錄製和/或個別錄製。",
          "note3_1": "組合錄製包括單一視訊畫格中所有網格的與會者視訊。此錄製選項按每個工作階段持續時間，以每分鐘計算。",
          "note3_2": "個別錄製允許錄製所選的個別與會者，為每個與會者單獨錄製視訊。此錄製選項按個別饋送分鐘數錄製，以每分鐘計算。"
        },
        "table_column_label": {
          "service_plan": "Service Plan",
          "rate": "Rate",
          "see_rate_cta": "See rate"
        },
        "switch_desc": "Want to switch to the Pay As You Go plan for the flexibility to pay exclusively for the SDK service?",
        "switch_cta": "Switch now"
      },
      "zoom_united": {
        "pro": "Zoom\u878d\u5408\u5957\u9910\u5c08\u696d\u7248",
        "biz": "Zoom\u878d\u5408\u5957\u9910\u5546\u696d\u7248"
      },
      "toll_free": "\u514D\u8CBB\u96FB\u8A71\u865F\u78BC",
      "premium_call_in_numbers": "\u4ED8\u8CBB\u96FB\u8A71\u865F\u78BC",
      "call_out": "\u64A5\u51FA",
      "search_countries": "\u4F9D\u570B\u5BB6/\u5730\u5340\u641C\u5C0B",
      "countries_regions": "\u570B\u5BB6/\u5730\u5340",
      "tel": {
        "landline": "\u6709\u7DDA\u96FB\u8A71",
        "mobile": "\u884C\u52D5\u88DD\u7F6E"
      },
      "addAnother": {
        "large": "+ 新增其他大型會議方案",
        "webinar": "+ 新增其他網路研討會方案",
        "events": "+ 新增其他活動方案",
        "sessions": "+ 新增其他會議方案"
      },
      "zr": {
        "desc": "透過高品質的視訊會議和彈性的工作區解決方案，輕鬆連結實體與遠端團隊，只需一鍵即可完成。",
        "feature": {
          "wb": "包含 Zoom Whiteboard 加強版",
          "meeting_zr": "按一下即可加入會議室",
          "wireless": "一鍵無線近距離分享",
          "share": "無線多重分享"
        },
        "remove_assigned_license": "您目前擁有 {0} 個指派的會議室。 更新方案後，請透過 {2} 從 Zoom Rooms 管理移除 {1} 指派的會議室以完成降級。",
        "remember_remove_rooms": "於 Zoom Rooms 管理 {1} 之前請務必先移除 {0} 會議室。 <br/><br/>成功移除會議室後，才能進行降級。",
        "unassign_rooms": "未指派 Zoom Rooms",
        "max_license_alert": "如果您想要購買 {0} 個以上的會議室，請<a href=\"/contactsales\" target=\"_blank\" class=\"opc-zr-max-license-alert\">聯絡銷售人員</a>。",
        "license_unit": "Rooms"
      },
      "rc": {
        "desc": "憑藉無縫整合功能，任何使用者均可透過 Microsoft、Google 或標準式 SIP/H.323 視訊會議端點加入 Zoom Meetings。",
        "remove_assigned_license": "您目前擁有 {0} 個指派的連接埠。 更新方案後，請透過 {2} 從 Zoom Rooms 管理移除 {1} 指派的連接埠以完成降級。",
        "max_license_alert": "最多 {0} 個連接埠。",
        "license_unit": "連接埠",
        "license_tooltips": "每個連接埠訂閱一次可供一部裝置連線至您帳戶中的所有會議。"
      },
      "zobizplus": {
        "add_another": "+ 新增另一個地區",
        "unlimited_desc": "每名使用者都將收到一個本地號碼，用於無限制區域通話。",
        "unlimited_license_desc": "您需要至少 10 名使用者以完成購買。",
        "atlease_desc": "您需要至少 {0} 名使用者以完成購買。",
        "promo_biz_desc": "您可加購此方案，以滿足最低 10 名使用者的要求。",
        "promo_biz_title": "需要沒有 Zoom Phone 的使用者嗎？",
        "UC": "無限制通話",
        "required_license_warning": "您必須擁有至少 {0} 名 Zoom One 使用者。",
        "required_license_alert": "若要移除此方案的使用者，請返回方案管理並調整 Zoom One 使用者，以便您在整合兩個計畫時，可以滿足最低 {0} 名使用者的要求。 <a href=\"/billing\">返回方案管理</a>",
        "pending_change": "您已請求變更此方案。 如欲編輯此方案，請<a href=\"/billing\">返回方案管理</a>並移除您的請求。",
        "auto_add_message": "現已更新 {0} 使用者數量，以滿足最低 {1} 名使用者的要求。",
        "set_up_new_biz_plus_success_msg": "下一步是什麼？ 設定全新的商業加強版及電話系統，讓組織與團隊成員順利上工。",
        "subscription_cycle_same_as_other_plan": "The subscription cycle for {0} needs to be the same as {1}."
      },
      "got_it": "\u77AD\u89E3",
      "cancel_title_sorry_to_see_you_go": "\u5C0D\u65BC\u60A8\u9078\u64C7\u96E2\u53BB\uFF0C\u6211\u5011\u6DF1\u611F\u907A\u61BE\uFF01",
      "clips": "Clips",
      "clips_plus": "Clips Plus",
      "notes": "註釋",
      "ai_companion": "AI Companion",
      "events": {
        "choose_payment_option": "選擇付款方式",
        "compare_feature_title": "有何不同？",
        "onlyForAttendeesDesc": "僅適用於 {0} 觀眾",
        "requireTitle": "* 所有方案皆需要 Zoom One 授權",
        "capacityInfo": {
          "title": "{0} 的觀眾容量",
          "ppa": {
            "desc": "當您選擇依觀眾付費方案時，已購買的觀眾人數決定在購買後 12 個月內可參加您舉辦的所有活動的觀眾總人數。 <br/><br/>如果超過已購買的觀眾人數，將向您收取每名觀眾 {0} 的費用。"
          },
          "saas": {
            "desc": "當您選擇訂閱方案時，已購買的 {0} 授權數量將決定可參加您 {0} 中的每場會議會程或網路研討會會程的觀眾人數上限。"
          },
          "xx_license_amount": "{0} 授權數量",
          "max_allowed_in_webinar": "活動內每場網路研討會會程允許的觀眾人數上限",
          "max_allowed_in_meeting": "活動內每場會議會程允許的觀眾人數上限"
        },
        "eventSaas": {
          "desc": "主持更成功的混合式或虛擬活動。 使用網路功能、Expo 樓層等更多功能，提升觀眾參與度。"
        },
        "eventSaasCore": {
          "desc": "使用 Zoom Sessions 舉辦更具吸引力的活動。 取得使用付費活動功能，如進階品牌化和活動後分析工具。"
        },
        "saas": {
          "title": "訂閱",
          "tooltips": "<strong>訂閱</strong>可讓您根據所選的容量主持無限制的活動數量。",
          "capacityTips": "觀眾容量與購買的 {0} 授權相關，將決定每個活動允許的觀眾人數上限。",
          "freeTrialDescriptions": {
            "duration": "Zoom Sessions \{0\} 天免費存取",
            "capacity": "主持多達 \{0\} 名觀眾的單場活動 (無需付費入場)",
            "capacity_unlimited": "主持無限次免費活動，最多可容納 \{0\} 名觀眾",
            "publish": "發佈一支隨選視訊 (僅在 Zoom Events 中心)",
            "cancel": "可隨時取消",
            "requirement": "免費試用期間需要擁有使用中的網路研討會授權"
          }
        },
        "ppa": {
          "title": "按觀眾人數支付",
          "tooltips": "<strong>按觀眾人數支付</strong>授權決定在購買後 12 個月內可參加您帳戶舉辦的所有活動的觀眾總人數。",
          "attendeeTips": "購買的觀眾數量將決定購買後 12 個月內，可參加您舉辦的所有活動的觀眾人數。"
        },
        "webinarSetUp": {
          "title": "入口網站中的網路研討會設定"
        },
        "zoom_events_tooltip": "Since you've already added all available monthly subscriptions for {0}, you can only add annual subscriptions for {0}",
        "title_for_events": "Events",
        "title_for_sessions": "Sessions",
        "concurrentEvents": {
          "title": "同步活動",
          "tooltips": "<strong>訂閱</strong>方案一次支援一場直播活動，而<strong>按觀眾人數支付</strong>方案允許同步直播活動。"
        },
        "overages": {
          "title": "超額費用"
        },
        "eventsPlatformHubs": {
          "title": "活動平台中心",
          "saas": "每個授權 {0} 個中心",
          "ppa": "{0} 中心",
          "tooltips": "Zoom Events <strong>中心</strong>提供便利的活動組織，可讓主持人根據特定主題將相關活動設定群組。"
        },
        "eventsPlatformHosts": {
          "title": "活動平台主持人",
          "subTitle": "{0} 名以上觀眾",
          "saas": "{0} 中心主持人",
          "ppa": "{0} 中心主持人",
          "tooltips": "Zoom Events <strong>中心主持人</strong>能夠建立、編輯和發佈由中心擁有者所建立的活動。"
        },
        "attendees": "{0} 位觀眾",
        "plan_details": {
          "webinar_desc": "適用於超過 100 名互動嘉賓的大型網路研討會會程的簡易設定解決方案。",
          "events_desc": "進階活動平台，具有功能齊備的註冊和網路功能。 虛擬和混合式體驗的理想選擇。",
          "sessions_desc": "利用事件品牌、多名主持人協作和事件管理等功能簡化互動式單一會程活動。",
          "core_features": "核心功能"
        },
        "addon": {
          "ze_hub_hosts_title": "Zoom Events 額外的中心主持人",
          "zs_hub_hosts_title": "Zoom Sessions 額外的中心主持人",
          "ze_co_editors_title": "Zoom Events 額外的共同編輯者",
          "zs_co_editors_title": "Zoom Sessions 額外的共同編輯者",
          "hub_hosts_desc": "新增至相同組織內的中心主持人能夠建立、編輯和發佈由中心擁有者所建立的活動。",
          "co_editors_desc": "共同編輯者透過編輯或發佈活動等方式來與主持人協作和提供支援。",
          "hub_hosts_attendees_desc": "500 多名觀眾方案內含 4 名中心主持人，而 100 名觀眾方案內含 1 名中心主持人。",
          "hub_hosts_attendees_desc_new": "5 host seats (1 hub owner and 4 hub hosts) are included in the 500+ attendees plan, and 2 host seats (1 hub owner and 1 hub host) are included in the 100 attendees plan.",
          "co_editors_attendees_desc": "500 多名觀眾方案內含 3 名共同編輯者，而 100 名以下觀眾方案內含 1 名共同編輯者。",
          "hub_hosts": "中心主持人",
          "co_editors": "共同編輯者",
          "maximun_alert_message": "數量上限為 20 {0}。",
          "hub_hosts_unit": "中心主持人",
          "co_editors_unit": "共同編輯者",
          "monthly_hub_host": "/月/中心主持人",
          "annual_hub_host": "/年/中心主持人",
          "monthly_co_editor": "/month/co-editor",
          "annual_co_editor": "/year/co-editor",
          "monthly_host": "/month/host",
          "annual_host": "/year/host",
          "quarterly_hub_host": "/quarterly/hub host",
          "two_years_hub_host": "/two years/hub host",
          "three_years_hub_host": "/three years/hub host",
          "quarterly_host": "/quarterly/host",
          "two_years_host": "/two years/host",
          "three_years_host": "/three years/host",
          "quarterly_co_editor": "/quarterly/co-editor",
          "two_years_co_editor": "/two years/co-editor",
          "three_years_co_editor": "/three years/co-editor",
          "ze_hub_hosts_tips": "除了內含的主持人人數之外，您最多可以購買 20 名中心主持人名額並於 Zoom Events 平台使用。 您必須將您的主持人指派給 Zoom Events 平台中的使用者。",
          "zs_co_editors_tips": "除了您的授權內含的共同編輯者人數之外，您最多可以額外購買 20 名共同編輯者。 您必須將您的共同編輯者指派給 Zoom Events 平台中的使用者。",
          "hosts": "主持人"
        },
        "ppa_terms_condition_imme": "若您繼續套用此優惠券，任何 Zoom Events 和 Zoom Sessions 按每位觀眾支付的觀眾數將立即移除，恕不退款。",
        "ppa_terms_condition_pending": "若您繼續套用此折扣券，任何 Zoom Events 和 Zoom Sessions 按觀眾人數支付的觀眾數將於 {0} 移除，恕不退款。 在此日期之前，您仍可以將剩餘觀眾數用於已安排的活動和新活動。"
      },
      "company_organization_legal": "\u6CD5\u5B9A\u516C\u53F8\u540D\u7A31",
      "company_organization_learn_more": "The Legal Company Name will be the legal name displayed on invoices issued to you and where applicable, used for e-invoicing. No retrospective adjustments will be allowed to the Legal Company Name once an invoice has been issued.",
      "plan1_to_plan2": "{oldPlan} 變為 {newPlan}",
      "zone_ppm": {
        "title": "Zoom One 會議延長",
        "banner_tips": "在這場會議結束之前完成您的購買",
        "config_desc": "Zoom One 會議延長時段將套用至目前進行中的會議。 如果您在目前的會議結束後完成此購買，則此延長時段將儲存在您的帳戶中，適用於未來 30 天內的會議。",
        "bill_info": "正在進行的會議  •  最長持續時間：{extensionTime} 小時 •  {amount}",
        "one_time": "一次性",
        "comments": {
          "instant_extension": "立即延長",
          "instant_extension_desc": "結帳後會議立即延長",
          "one_time_purchase": "一次性購買",
          "one_time_purchase_desc": "無需訂閱"
        }
      },
      "tollfree": {
        "telephony": "Telephony",
        "desc": "會議擴充音訊功能解決方案，包括高品質 VoIP、付費撥號、全球免付費准入，和專屬撥號號碼。",
        "audio_conferencing": {
          "title": "語音會議",
          "desc": "音訊會議計畫在每個國家按通話收費。 每月會對超出的部分收取額外費用。 <a href=\"{0}\" class=\"zm-button zm-button--link\" target=\"_blank\">檢視音訊會議費率 <i class=\"zm-icon-window-new\"></i></a>",
          "montly_desc": "\u8a9e\u97f3\u65b9\u6848\u70ba{0}/\u6708\u8d77\uff0c\u4e26\u6703\u4f9d\u64da\u5404\u570b\u5bb6/\u5730\u5340\u7684\u901a\u6578\u8a08\u8cbb\u3002\u82e5\u60a8\u8d85\u51fa\u4e86{0}/\u6708\u7684\u9810\u4ed8\u901a\u6578\uff0c\u5c07\u6703\u4f9d\u64da\u6240\u5217\u51fa\u8cbb\u7387\u5411\u60a8\u6536\u53d6\u8d85\u984d\u7528\u91cf\u8cbb\u7528\u3002",
          "pay_you_go_desc": "\u6839\u64da\u4f7f\u7528\u7684\u5206\u9418\u6578\u53ca\u6bcf\u5206\u9418\u6a19\u6e96\u8cbb\u7387\u4f86\u8a08\u7b97\u8cbb\u7528\u3002"
        },
        "audio_us_ca": {
          "title": "\u7f8e\u570b\u8207\u52a0\u62ff\u5927Zoom\u8a9e\u97f3\u65b9\u6848",
          "desc": "方案包括了每月每主持人的無限量美國/加拿大受話方付費電話與外撥電話分鐘數"
        },
        "desc_for_sdk": "使用撥出功能透過電話呼叫其他人加入會程 (適用於特定國家/地區)，強化您的視訊會程體驗。",
        "need_beyound_us_ca": "\u9700\u8981\u7f8e\u570b\u8207\u52a0\u62ff\u5927\u4ee5\u5916\u7684\u570b\u5bb6/\u5730\u5340\uff1f",
        "view_rates_link": "<a href=\"{0}\" class=\"zm-button zm-button--link\" target=\"_blank\">\u6aa2\u8996\u8a9e\u97f3\u65b9\u6848\u8cbb\u7387</a>",
        "audio_conferencing_plan": "音訊會議計畫",
        "enable_countries_regions": "\u555f\u7528\u570b\u5bb6/\u5730\u5340\u64a5\u865f\u529f\u80fd",
        "enable_countries_regions_desc": "\u6240\u6709\u986f\u793a\u7684\u8cbb\u7387\u4f9d\u6bcf\u5206\u9418\u3001\u6bcf\u4f4d\u8207\u6703\u8005\u8a08\u7b97\u3002",
        "add_additional_countries_regions": "+ 新增其他國家/地區",
        "add_us_ca_audio": "+ 新增美國及加拿大 Zoom 音訊",
        "require_equal_number_for_audio_unlimited": "您必須擁有與購買的音訊會議授權數量相同的 Zoom One 商業版使用者",
        "require_equal_number_for_audio_unlimited_alert": {
          "meeting_only": "You must have an equal number of Zoom One users for each Audio Conferencing license purchase. If you’d like to have a different number of licenses, update your Zoom One plan in <a href=\"/billing\">Plan Management</a>",
          "meeting_and_rooms": "Your Audio Conferencing plan license number must equal the sum of your Zoom Rooms and Zoom One licenses. If you’d like to have a different number of licenses, update them in <a href=\"/billing\">Plan Management</a>"
        },
        "require_equal_number_tip": "You must have an equal number of Audio Conferencing license for each Zoom One license purchase",
        "require_equal_number_tip_for_zr": "Your US/CA Audio Plan license number should equal to the sum of your Zoom Rooms license and Zoom One license",
        "update_audio_license_tips": "The license quantity of {0} is now updated to match the license quantity of {1}.",
        "audio_addon_desc": "所有付費計畫均提供當地付費電話號碼，語音計畫可供您對於付費國家/地區新增撥出、全球免付費電話和當地撥入",
        "choose_one_option_tpc": "\u5728\u514D\u4ED8\u8CBB\u3001\u4ED8\u8CBB\u8207\u5916\u64A5\u96FB\u8A71\u7B49\u9078\u9805\u4E2D\u81F3\u5C11\u9078\u64C7\u4E00\u9805\u3002",
        "select_at_least_one_country": "Please select at least one country/region",
        "dedicated_dial_in_number": {
          "title": "專用撥入號碼",
          "desc": "專用撥入號碼可讓您的觀眾無需輸入會議ID，即可加入語音會議。",
          "exceed_tip": "The number of Dedicated Dial-In Numbers you have on your account cannot exceed the number of users on your Zoom One plan. Please either increase the number of Zoom One plan hosts in <a href=\"/billing\">Plan Management</a> or decrease the number of Dedicated Dial-In Numbers in your selection to continue. Have questions? <a href='/billing/contactus' target='_blank'>Contact us</a>"
        }
      },
      "annual_cost": "年度費用",
      "monthly_cost": "按月支付",
      "upfront": "定金",
      "prepaid": "已預付",
      "pay_you_go": "即付即用",
      "estimated_tax": "預估稅金",
      "credit_balance": "已使用的信用餘額",
      "see_more_details": "查看更多詳情",
      "your_products": "您的產品",
      "consumption_cancel": {
        "switch_to_monthly": "Switch to Monthly",
        "switch_to_monthly_questionmark": "Switch to Monthly?",
        "switch_to_annual": "Switch to Annual",
        "switch_to_annual_questionmark": "Switch to Annual?",
        "immediate_cancel": "Once you switch your {0} subscription to {1}, any remaining attendees from both Zoom Events Pay Per Attendee and Zoom Sessions Pay Per Attendee will be canceled immediately without refunds.",
        "pending_cancel": "Once you switch your {0} subscription to {1}, any remaining attendees from both Zoom Events Pay Per Attendee and Zoom Sessions Pay Per Attendee will be canceled without refunds. You can use your remaining attendees for scheduled and new events with overages until {2}.",
        "go_back": "Go Back"
      },
      "bank_transfer": {
        "message": "<div class=\"apm-furikomi-success\">請確保您在 {0} 天內按照銀行轉帳說明 (需要確切的金額) 透過 Furikomi 完成付款，以便保留您的有效訂閱。為完成銀行轉帳，部分付款資訊將與 SMBC 分享。收到付款後，我們將透過 {1} 通知您。Zoom 會傳送通知電子郵件以提醒您將來的付款。",
        "bank_information": "Bank information",
        "transfer_funds": "Transfer funds using the following bank information:",
        "bank_code": "Bank code",
        "bank_name": "Bank name",
        "branch_code": "Branch code",
        "branch_name": "Branch name",
        "account_type": "Account type",
        "account_number": "Account number",
        "account_holder": "Account holder",
        "powered_by": "Powered by",
        "stripe": "Stripe",
        "terms": "Terms",
        "privacy": "Privacy",
        "copied_to_clipboard": "Copied to clipboard."
      },
      "processing_payment": "\u6211\u5011\u6B63\u5728\u8655\u7406\u60A8\u7684\u4ED8\u6B3E\u3002",
      "notify_when_payment_received": "\u6536\u5230\u4ED8\u6B3E\u5F8C\uFF0C\u6211\u5011\u5C07\u65BC{0}\u901A\u77E5\u60A8\u8A02\u95B1\u8A73\u7D30\u8CC7\u8A0A\u3002",
      "checkout": "結帳",
      "continue": "繼續",
      "plan_details": "計畫詳情",
      "please_note": "請注意",
      "whiteboard": "白板",
      "whiteboard_basic": "基礎版白板",
      "team_chat": "團體聊天",
      "mail_calendar": "郵件與日曆",
      "essential_apps": "必要的應用程式",
      "extras": "贈品",
      "vat": {
        "pe_msg": "提供 RUC 即視同聲明您已登記繳納秘魯 VAT，且取得 Zoom 服務係為您在秘魯經營商業活動之目的 (而非基於私人或國內的用途)。",
        "pe_checkbox": "企業客戶",
        "pe_tooltip": "填寫核取方塊即視同證明我/我們已登記繳納秘魯 VAT，且取得 Zoom 服務係為您在秘魯經營商業活動之目的 (而非基於私人或國內的用途)。Zoom 免於承擔因 VAT 註冊披露不完整或不準確的任何責任。",
        "INR_tax_verified_tip": "I/we understand that Section 16 of the IGST Act 2017 provides that any supply of goods or services to Special Economic Zones (“SEZ”) shall be considered as a zero-rated supply only where such services are used for authorised operations of the SEZ. In this regard, we hereby confirm that the services being provided by ZVC India Private Limited are in relation to the authorised operations of {0}. I/we hereby declare that I/we have obtained GST registration for the SEZ unit(s), under a valid Letter of Approval (\"LoA\") issued by SEZ authorities. In case any fact or information is found to be incorrect or invalid at any given point of time or where the services are not being used for authorised operations of our unit, in addition to any other indemnities or obligations in the Agreement, I/we shall indemnify and hold ZVC India Private Limited harmless, from and against all liabilities of GST amount including interest and penalties, that may arise in addition to any other indemnities or obligations in the Agreement.",
        "msg_by": "如果您是企業客戶，請輸入您的稅務識別碼 (TIN)",
        "checkbox_by": "非企業客戶",
        "tooltip_by": "填寫此核取方塊時，我/我們證明我/我們不是白俄羅斯課稅目標的法人實體，並且我/我們對本聲明的準確性和完整性承擔全部責任。 Zoom 免於承擔因聲明不完整或不準確的任何責任。 此外，證明我/我們不是白俄羅斯課稅目標的企業客戶同時，我/我們接受並理解，除訂單摘要中列出的價格以外，Zoom 還將按適用稅率對所有應稅服務收取增值稅。",
        "msg_co": "如果您已註冊 VAT，請輸入您的稅務識別碼 (RUT)",
        "placeholder_co": "RUT",
        "tooltip_co": "In completing the checkbox I/we certify that the above named business is not 'Responsable de IVA' nor a VAT Collector and that I/we take full responsibility for the accuracy and completeness of this statement. Zoom waives any responsibility to accept liability due to either an incomplete or an inaccurate VAT registration disclosure. Furthermore, in certifying that the above named Business is not 'Responsable de IVA' nor a VAT Collector, I/we accept and understand that Zoom will charge VAT on all taxable services at the applicable rate in addition to the prices listed in Order Summary.",
        "tooltip_cl": "填寫核取方塊時，我/我們證明上述企業未註冊增值稅，並且我/我們對本聲明的準確性和完整性承擔全部責任。 Zoom 免於承擔因增值稅註冊披露不完整或不準確的任何責任。 此外，在證明上述企業未註冊增值稅時，我/我們接受並理解，除訂單摘要中列出的價格以外，Zoom 還將按適用稅率對所有應稅服務收取增值稅。",
        "tooltip_eg": "填寫核取方塊時，我/我們證明上述企業/個人未註冊增值稅，並且我/我們對本聲明的準確性和完整性承擔全部責任。 Zoom 免於承擔因增值稅註冊披露不完整或不準確的任何責任。 此外，在證明上述企業/個人未註冊增值稅時，我/我們接受並理解，除訂單摘要中列出的價格以外，Zoom 還將按適用稅率對所有應稅服務收取增值稅。",
        "tooltip_ic": "In completing the checkbox I/we certify that the above named business is not IGIC registered and that I/we take full responsibility for the accuracy and completeness of this statement. Zoom waives any responsibility to accept liability due to either an incomplete or an inaccurate IGIC registration disclosure. Furthermore, in certifying that the above named Business is not IGIC registered I/we accept and understand that Zoom will charge IGIC on all taxable services at the applicable rate in addition to the prices listed in Order Summary.",
        "msg_kr": "請輸入商業登記號碼",
        "msg_th": "如果您已註冊 VAT，請輸入您的 VAT 號碼",
        "msg_ic": "If you are IGIC registered in Canary Islands, enter NIF",
        "tax_promote_eg": "如果您已註冊 VAT，請輸入您的稅務登記號碼",
        "tax_registration_number": "稅務登記號碼",
        "tax_requirement": {
          "desc": "I acknowledge that, for the purposes of complying with Saudi tax law, Saudi customers are required to withhold taxes, remit the relevant amounts to the competent authorities, maintain records to prove the correctness of taxes withheld as well as provide Zoom with the respective withholding tax certificate(s). I am aware that failure to comply with such requirements may trigger the application of penalties according to Saudi legislation.<br /><br />Withholding Tax Certificates can be sent to: <a href=\"mailto:{email}\">{email}</a>",
          "invalid_msg": "Please check this box if you want to proceed"
        }
      },
      "buyItNow": {
        "please_note": "Please Note:",
        "cant_continue": "Unable to continue"
      },
      "update": {
        "download_the_zoom_app": "\u4E0B\u8F09Zoom App",
        "download_mac": "MAC",
        "download_mac_m1": "<span>Macs with </span><br />Apple Silicon chips",
        "download_windows": "WINDOWS PC",
        "download_windows_64": "<span>Windows</span><br /> 64-bit",
        "download_windows_arm": "<span>Windows</span><br /> ARM"
      },
      "license_limit_msg": "已選擇 {0} {1} 個授權 {2} 授權數不能超過 {3} 使用者人數。",
      "select_billing_cycle": "選擇訂閱週期",
      "select_calling_plan": "Select your calling plan",
      "add_participants_plan": "+ 新增 {0} 與會者計畫",
      "addon_license_limit_tips": "若要增加 {0} 的授權數量，您必須將您的 {1} 使用者人數調整為等於或大於 {0}。 <a href=\"/billing\">返回方案管理</a>",
      "addon_license_limit_tips_without_contact": "若要增加 {0} 的授權數量，您必須將您的 {1} 使用者人數調整為等於或大於 {0}。",
      "addon_toggle_more": "檢視更多產品",
      "addon_toggle_less": "檢視較少產品",
      "addon_auto_add_tips": "您現在正在編輯 {0} 和 {1}",
      "addon_auto_remove_tips": "您現在正在編輯 {0}。 {1} 已移除，因為您有足夠的使用者人數。",
      "add_attendees_plan": "+ 增加 {0} 名觀眾計畫",
      "licences_limit_tips": "{0} 授權數不能超過 {1} 授權數。",
      "licenses_assigned_limit_tips": "授權數量必須等於或大於目前指派給您帳戶中使用者的授權數量。",
      "license_sync_base": "已更新 {0} 的使用者人數以符合 {1} 的授權個數",
      "license_sync_addon": "已更新 {0} 的授權個數以符合 {1} 的使用者人數",
      "need_more_license": "至少需要 {0} 個授權？",
      "need_more_license_desc": "{0} 最多只能支援 {1} 位使用者和 {2} 個 {3} 授權。您需切換到 {4} 方案才可取得更多授權。",
      "switch_to": "切換到 {0} 方案",
      "billing": "結算",
      "storage": "儲存空間",
      "attendees": "觀眾",
      "participants": "\u53C3\u8207\u8005",
      "licenses": "Licenses",
      "license": "授權",
      "billing_cycle": {
        "monthly": "\u6BCF\u6708",
        "annual": "每年",
        "one_month": "一個月",
        "one_month_new": "單月",
        "pay_per_attendee": "按觀眾人數支付",
        "quarterly": "季付",
        "two_years": "兩年",
        "three_years": "三年",
        "one_time": "一次性",
        "subscription": "訂閱",
        "subscription_or_one_month": "訂閱或單月方案"
      },
      "annual_save": "每位使用者可節省的費用",
      "zone": {
        "meetings": "會議",
        "select_license": "選擇使用者人數",
        "attendee_info": "每個使用者皆享有無限制會議時間，召開最多 {0} 名與會者的會議。",
        "attendee_info_edit": "此處列出的授權數量，反映的是進行變更後您希望帳戶擁有的<b>總</b>授權數量。",
        "desc1": "{0} 使用者 •  {1}{2}",
        "desc1_monthly": "/月",
        "desc1_annual": "/年",
        "min_of_pro": "最少 1 位使用者。",
        "min_of_licenses": "最少 {0} 位使用者。",
        "max_of_licenses": "最多 {0} 名使用者。",
        "max_of_license_contact_us": "The maximum amount is {0} license. If you want to purchase more, please <a class=\"zm-button zm-button--link opc-link-btn\" href=\"/contactsales\" target=\"_blank\">Contact Sales</a>.",
        "max_of_pro": "最多 9 名使用者。",
        "max_of_pro_99": "最多 99 名使用者。",
        "min_of_biz": "最少 10 位使用者。",
        "min_of_biz_new": "此方案至少需要 {number} 名使用者。",
        "min_of_biz_1": "最少 1 位使用者。",
        "biz_combined_bizplus": "將此計畫與 Zoom One 商業加強版結合使用時，您總共需要 10 名使用者。",
        "promo_bizplus": "Suggested for you",
        "max_license_of_biz": "最多 {0} 名使用者。 如果您想要購買 {1} 個授權或更多，請<a href=\"/contactsales\" target=\"_blank\">聯絡銷售人員</a>。",
        "max_of_biz": "最多 99 名使用者。 如果您想要購買 100 個授權或更多，請<a href=\"/contactsales\" target=\"_blank\">聯絡銷售人員</a>。",
        "max_of_plans": "上限為 {0} 個授權。 如果您想要購買 {1} 個以上的授權，請<a href=\"/contactsales\" target=\"_blank\">聯絡銷售人員</a>。",
        "max_of_plans_user": "最多 {0} 名使用者。 如果您想要購買 {1} 個授權或更多，請<a href=\"/contactsales\" target=\"_blank\">聯絡銷售人員</a>。",
        "explore_other_plans": "探索其他計畫",
        "explore_other_plans_edit": "切換方案",
        "see_full_feature": "查看完整功能列表",
        "trial": {
          "desc1": "存取所有 Zoom Workplace 專業版功能",
          "desc2": "AI Companion",
          "desc3": "可隨時取消",
          "select_free_trial": "選取免費試用",
          "trial_charge_terms_desc": "如果您未在免費試用結束前取消，您的訂閱將自動續訂，且同時會自動向您資料中的付款方式收取每月訂閱費用 {0} 或年度訂閱費用 {1}。"
        },
        "learn_more_modal": {
          "feature_tip": "藉助採用 AI 技術的協作平台，重新塑造團隊工作方式。",
          "intro1": "可以無限制主持會議，每次會議最長 30 小時，與會者上限 100 名",
          "intro2": "最多可使用 3 個具有標準功能的可同時編輯白板",
          "intro3": "使用 Clips 加強版錄製、編輯和分享高品質的短片訊息",
          "intro4": "使用 Zoom AI Companion，以更高效率完成工作"
        },
        "host_need_adjust": {
          "title": "將調整您的 Zoom One、{0} 授權數",
          "content": "Zoom One Pro 的使用者人數上限為 {1} 名使用者。 {0} 授權數不能超過 Zoom One 授權數。"
        },
        "pro_details": {
          "row1": "可主持多達 100 位與會者的會議",
          "row2": "無限次數的會議，每次會議限時 30 小時",
          "row3": "5GB 雲端錄製儲存空間 (每個授權各 5GB)",
          "row4": "自動字幕",
          "row5": "3 個可編輯白板",
          "row6": "協作、檔案分享和更多功能的聊天室及頻道",
          "row7": "郵件與日曆用戶端和服務測試版",
          "row8": "1 年內免費使用付費應用程式 (適用條款)",
          "row9": "增強團隊的協作和生產力"
        },
        "biz_details": {
          "meetings": {
            "row1": "可主持多達 300 名與會者的會議",
            "row2": "無限次數的會議，每次會議限時 30 小時",
            "row3": "5GB 雲端錄製儲存空間 (每個授權各 5GB)",
            "row4": "自動字幕"
          },
          "whiteboard": {
            "row1": "無限制白板"
          },
          "team_chat": {
            "row1": "協作、檔案分享和更多功能的聊天室及頻道"
          },
          "mail_calendar": {
            "row1": "郵件與日曆用戶端和服務"
          },
          "essential_apps": {
            "row1": "1 年內免費使用付費應用程式 (適用條款)",
            "row2": "增強團隊的協作和生產力"
          },
          "extras": {
            "row1": "單一登入",
            "row2": "託管網域",
            "row3": "公司品牌化"
          },
          "clips": {
            "row1": "輕鬆錄製、編輯和分享短片",
            "row2": "無限制的影片和進階功能"
          },
          "ai_companion": {
            "row1": "使用 AI 助理在 Zoom 平台上自動執行關鍵任務",
            "row1_new": "使用您的智慧 AI 助理在 Zoom 平台上自動執行關鍵任務",
            "row2": "快速取得會議摘要，協助撰寫訊息草稿等更多內容"
          },
          "notes": {
            "row1": "在 Zoom 內建立和分享可編輯文件",
            "row2": "設有 RTF 編輯的個人及協作筆記"
          },
          "tips": "起售價為 10 個授權 {0} 美元/年。"
        },
        "alert_title": "每個 {0} 授權都至少需要一位 {1} 使用者",
        "edu": {
          "hd": "高畫質視訊和音訊",
          "attendees": "300 名觀眾",
          "wb": "白板",
          "team_chat": "團體聊天",
          "MC": "Mail 和 Calendar"
        },
        "edu_details": {
          "hd": "適用於實體和虛擬訓練",
          "meetings": "每次會議限時 30 小時",
          "attendees": "每次會議",
          "cloud_storage": "0.5GB",
          "tips": "起售價為 {0} 個授權 {1}/年"
        }
      },
      "large_meeting": {
        "title": "大型會議",
        "desc": "拓展您的影響力，提升會議人數上限達 1,000 名與會者。",
        "config_desc": "會議和網路研討會的容量最高可增加至 1000 名觀眾",
        "add_more_plan_link_capacity": "除了目前的授權之外，您若想新增不同容量的 {0} 方案而非變更目前的方案， <a href=\"{1}\">按一下此處</a>。",
        "promo": "需要主持超過 {100} 位與會者的會議？",
        "increase_with": "使用大型會議方案增加人數",
        "expandable_with": "可擴展用於大型會議"
      },
      "webinar": {
        "title": "Zoom Webinars",
        "desc": "允許最多 100 名嘉賓與最多 10,000 名觀眾互動",
        "config_desc": "選擇一個或多個計畫。 每個計畫最多支援 100 位互動視訊嘉賓。 僅限觀看的授權費用。 觀眾人數最少 {0} 位、最多 {1} 位。",
        "brief_title": "網路研討會",
        "config_desc_new": "透過 Zoom 的高品質視訊廣播吸引受眾並播放您的訊息。 最多 {0} 位觀眾與 {1} 位嘉賓。",
        "engage_your_audiences_desc": "透過 Zoom 的高品質視訊廣播吸引受眾並播放您的訊息。",
        "up_to_x_attendees_y_panelists": "最多 {0} 位觀眾與 {1} 位嘉賓。",
        "add_more_plan_link_capacity_new": "您是否要新增其他 {0} 方案？ <a href=\"{1}\">新增方案</a>",
        "upcoming_prompt": {
          "yes_place_order": "是的，我要下訂單",
          "no_go_back": "不，返回",
          "exit_checkout_cta": "退出結帳",
          "cancel_webinar_plan_cta": "取消 Webinar {0} 方案",
          "has_paid_event_block_title": "您已不適用此優惠",
          "has_paid_event_block_desc": "我們無法將您的 {0} 方案降級為 {1} 方案，因為您已安排一或多場即將舉行的付費網路研討會，且報名人數超過 {2}。",
          "has_free_event_soft_desc": "下訂單後，超出新觀眾容量 {0} 的其他觀眾將無法參加您的網路研討會。"
        },
        "trial": {
          "freeTrialDescriptions": {
            "duration": "\{0\} 天免費存取 Zoom Webinars",
            "capacity": "主持無次數限制的網路研討會，最多可容納 \{0\} 名觀眾",
            "cancel": "可隨時取消"
          },
          "requirement": "免費試用期間需要擁有使用中的 Zoom Workplace 方案",
          "assign_users": "下一步是什麼？將新的授權指派至您帳戶內的使用者。您需要先新增使用者，才能將授權指派給新的使用者。"
        }
      },
      "cmr": {
        "title": "雲端儲存",
        "desc": "為您的 {0}GB 雲端儲存新增更多容量",
        "config_desc": "每個付費計畫的每個授權最多有 {0} GB 的雲端錄製儲存空間。 選擇下方選項之一新增更多儲存空間",
        "add_desc": "新增更多儲存空間並分享給帳戶中所有已授權的使用者",
        "important_tips": "*超過儲存限制時會收取超額費用。 費用依據儲存計畫而有不同。",
        "usage_in_excess": "每 GB {0}",
        "cmr_free_upgrade": {
          "update_tip": "如果繼續，便會依照您目前計費週期的相同基礎價格，將目前的雲端錄製儲存空間更新為{0}。",
          "update_title": "即將更新您的方案"
        },
        "recommended": "推薦",
        "option_incur_overage": "此選項將會產生超額費用",
        "fees_vary_based_on_storage_plan": "費用依據儲存計畫而有不同。",
        "overage_fees_desc": "依據計費週期內的最高使用量，超過儲存限制時會收取超額費用。",
        "account_cloud_storage_include_desc": "您的帳戶包含 {0} 的雲端儲存空間。 您的雲端儲存已滿，因此無法錄製更多會議或網路研討會至雲端，除非您購買更多儲存空間或於<a href='/recording/management' target='_blank'>录制管理</a>中管理目前的檔案。",
        "selection_will_incur_overage_desc": "根據您目前的使用情況，您的選擇將產生至少 {0} 的預估超額費用。 為避免超額費用，您可以在<a href='/recording/management' target='_blank'>录制管理</a>中管理您的檔案，或在上方選擇更大的儲存計畫。",
        "account_cloud_storage_desc": "您的帳戶包含雲端儲存的 {0}。",
        "current_usage": "目前使用情況",
        "paywall_tip": "{0}為每位使用者提供 {1} GB 的雲端儲存空間。如果您想新增更多容量，可以從下面的附加元件部分新增{2}。"
      },
      "translation_caption": {
        "title": "已翻譯字幕",
        "desc": "可依您選擇的受支援語言自動翻譯並顯示字幕，強化全球協作能力",
        "config_desc": "可依您選擇的受支援語言自動翻譯並顯示字幕，強化全球協作能力。",
        "license_tooltip": "已翻譯字幕授權總數不能超過 Zoom One 授權數量。",
        "subtitle": "能夠將字幕翻譯成 Zoom Meetings 和網路研討會支援的另一種語言。 <a href=\"https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions\" target=\"_blank\">檢視支援的語言</a>"
      },
      "pbx": {
        "tollFree": {
          "unit": "toll-free number(s)"
        },
        "local_number": {
          "unit": "local number(s)"
        },
        "more_than_license": "如果您需要的線路多於 {0} 個，請<a href=\"{1}\" target=\"_blank\">聯絡銷售人員</a>",
        "intl_select_addon_countries": "\u7F8E\u570B\u3001\u52A0\u62FF\u5927\u3001\u82F1\u570B\u3001\u611B\u723E\u862D\u3001\u6FB3\u5927\u5229\u4E9E\u3001\u7D10\u897F\u862D\u3001\u5967\u5730\u5229\u3001\u4E39\u9EA5\u3001\u6CD5\u570B\u3001\u5FB7\u570B\u3001\u7FA9\u5927\u5229\u3001\u8461\u8404\u7259\u3001\u897F\u73ED\u7259\u3001\u745E\u5178\u3001\u6BD4\u5229\u6642\u3001\u8377\u862D\u3001\u745E\u58EB\u3001\u6CE2\u591A\u9ECE\u5404\u3001\u65E5\u672C\u3002",
        "pbx_comparison": "Zoom Phone 計畫比較",
        "comparison_desc": "您知道您可以自訂嗎？ <a href=\"{0}\" target=\"_blank\">聯絡銷售人員</a>混搭您的選項！",
        "see_supported_country": "參閱支援的 {0} 國家/地區名單",
        "how_many_number_need": "您需要多少個號碼？",
        "what_calling_plans": "您的使用者需要哪一種通話計畫？",
        "x_number_selected": "已選取 {0} 個號碼",
        "one_calling_plan": "1 通話計畫",
        "x_calling_plan": "{0} 通話計畫",
        "toll_free_numbers": "免付費號碼",
        "local_numbers": "當地號碼",
        "select_your_numbers": "選取您的號碼",
        "edit_numbers": "編輯號碼",
        "add_toll_free_numbers": "+ 新增免付費號碼",
        "ready_for_porting": "準備進行接入",
        "have_existing_number": "已有現有的號碼？",
        "valid_for_porting": "驗證號碼以進行接入",
        "valid_more_porting": "驗證更多號碼以進行接入",
        "port_number_desc": "您可以在結帳後的設定過程中開始進行接入程序。 在接入電話作業期間，您將會獲得暫用的號碼。",
        "number_tips_1": "您可以在結帳之後選取您的電話號碼。",
        "number_tips_2": "您目前只能編輯 10 個號碼。 如果您需要編輯更多的號碼，請等到結帳之後再進行編輯。",
        "tf_pricing_line": "(其他 {0})",
        "more_than_99_license": "如果您需要的線路多於 99 個，請<a href=\"{0}\" target=\"_blank\">聯絡銷售人員</a>",
        "calling_fee_tips": "選擇當您接到或撥打{0}以外地區的電話時，希望使用的支付方式。 <a href=\"/billing/pbx/rates\" target=\"_blank\">查看費率及涵蓋範圍</a>",
        "calling_fee_tips_new": "國內「隨用隨付」通話費率為每分鐘{0}起。國內「預付」費率為每分鐘{1}起。如果您超過預付方案，在該月剩餘時間您將恢復為「隨用隨付」費率。關於國際通話費率，<a href=\"/billing/pbx/rates\" target=\"_blank\">請見圖表</a>",
        "calling_plan_tips": "無限量方案提供給美國及加拿大無限量國內通話方案，但需支付固定費用。計量方案針對外撥通話採每分鐘費率計收。",
        "number_selected_tips": "在完成結帳之前，我們無法保證能夠保留您想要的電話號碼。",
        "calling_plan_selected_tips": "一旦您完成信用卡付款，您將可在設定帳戶時保留或接入電話號碼。",
        "zpa_cant_exceed_calling": "Zoom Phone Power Pack 使用者人數不得超過 Zoom Phone 通話計畫的總和。",
        "metered_calling_credits": "計量通話額度",
        "must_have_a_calling_plan": "In order to purchase, you must have a calling plan.",
        "calling_fee_name": {
          "pay_you_go": {
            "UC": "國際通話費",
            "MC": "區域和國際通話費"
          },
          "prepaid": {
            "UC": "預付國際通話費",
            "MC": "預付區域和國際通話費"
          }
        },
        "calling_fee_label": {
          "unlimited": "如何處理國際費用？",
          "metered": "如何處理區域和國際費用？"
        },
        "plan_desc": {
          "ZPI": "超過 15 個國家和地區的無限制國際通話。",
          "ZPA": "包括進階使用者桌面體驗，可簡化來電處理、強化即時分析與歷史報告。"
        },
        "cart_summary": {
          "local_line": "{0} 本地線路  •  {1}",
          "toll_free_line": "{0} 免付費線路  •  結算：{1}",
          "local_lines": "{0} 本地線路  •  {1}",
          "toll_free_lines": "{0} 免付費線路  •  結算：{1}",
          "pay_you_go_calling_fee": "即付即用 {0}",
          "add_on_lines": "{0} 授權 • {1}",
          "add_on_lines_2": "{0} user(s) • {1}"
        },
        "detail_dialog": {
          "unlimited": {
            "plan_name": "美國和加拿大 | 無限制區域"
          },
          "metered": {
            "plan_name": "美國及加拿大 | 計量"
          }
        },
        "regions": {
          "US": "美國及加拿大",
          "UK": "英國與愛爾蘭",
          "AUS": "澳大利亞及紐西蘭",
          "JP": "日本"
        },
        "divisions": {
          "CA": "公共區域電話",
          "PRO": "Phone 專業版"
        },
        "sub_types": {
          "UC": "無限制",
          "MC": "計量",
          "PN": "本地",
          "TF": "免付費"
        },
        "plan_name": {
          "ZVU": "美國與加拿大無限制",
          "ZVM": "美國及加拿大計量",
          "ZPI": "國際通話附加方案",
          "ZPA": "Zoom Phone Power Pack",
          "ZVT": "免付費號碼",
          "ZVP": "計量通話額度",
          "ZVC": "計量通話額度",
          "ZUU": "國內無限制通話計畫",
          "ZAU": "國內無限制通話計畫",
          "ZUM": "計量通話計畫",
          "ZUT": "英國與愛爾蘭免付費",
          "ZUD": "當地 (付費電話)",
          "ZAM": "計量通話計畫",
          "ZAT": "澳洲免付費",
          "ZNT": "紐西蘭免付費",
          "ZAD": "當地 (付費電話)",
          "ZVD": "當地 (付費電話)",
          "ZPD": "付費號碼",
          "ZJU": "日本无限时",
          "ZJM": "日本计时",
          "ZJD": "Local",
          "ZPP": "通話計畫",
          "ZCA": "通話計畫",
          "ZSU": "Global Select Unlimited",
          "ZSM": "全球精選方案 (依使用量計費)",
          "ZSD": "全球號碼",
          "ZGT": "全球免付費電話"
        },
        "cart_name": {
          "ZVU": "美國及加拿大無限制通話計畫",
          "ZVM": "美國及加拿大計量通話計畫",
          "ZPI": "國際通話附加方案",
          "ZPA": "Zoom Phone Power Pack",
          "ZVT": "美國及加拿大免付費電話號碼",
          "ZVP": "計量通話額度",
          "ZVC": "計量通話額度",
          "ZUU": "英國與愛爾蘭無限制通話計畫",
          "ZAU": "澳大利亞及紐西蘭無限制通話計畫",
          "ZUM": "英國與愛爾蘭計量通話計畫",
          "ZUT": "英國與愛爾蘭免付費電話號碼",
          "ZUD": "英國與愛爾蘭額外電話號碼",
          "ZAM": "澳大利亞及紐西蘭計量通話計畫",
          "ZAT": "澳大利亞免付費電話號碼",
          "ZNT": "紐西蘭免付費電話號碼",
          "ZAD": "澳大利亞及紐西蘭額外電話號碼",
          "ZVD": "美國及加拿大額外電話號碼",
          "ZPD": "付費電話號碼",
          "ZJU": "日本無限制通話計畫",
          "ZJM": "日本計量通話計畫",
          "ZJD": "日本額外電話號碼",
          "ZPP": "Zoom Phone 專業版",
          "ZCA": "公共區域電話",
          "ZSU": "Zoom Phone 專業版全球精選無限制方案",
          "ZSM": "Zoom Phone 全球精選方案 (依使用量計費)",
          "ZSD": "Zoom Phone 全球號碼",
          "ZGT": "Zoom Phone 全球免付費電話號碼"
        },
        "to_verify_notice": "\u70BA\u4E86\u78BA\u4FDD\u6211\u5011\u5DF2\u6210\u529F\u52A0\u5BC6\u60A8\u7684\u96FB\u8A71\u865F\u78BC\uFF0C\u8ACB\u8A2D\u5B9A\u60A8\u7684\u5E33\u6236\u3002",
        "pbx_specialist": "\u6709\u8208\u8DA3\u5B89\u6392\u4E00\u5834\u8207\u5C08\u54E1\u9032\u884C\u768460\u5206\u9418\u6703\u8B70\u4EE5\u958B\u59CB\u914D\u7F6E\u60A8\u7684\u96FB\u8A71\u7CFB\u7D71\u55CE\uFF1F \u6309\u4E00\u4E0B\u4E0B\u65B9\u4EE5\u5B89\u6392\u6642\u9593\u3002 \u82E5\u8981\u6AA2\u95B1\u60A8\u7684\u65B9\u6848\uFF0C\u8ACB<a href=\"/billing\" target=\"_blank\" data-link-prod=\"User Management\" data-link-term=\"Phone Welcome Page Click\" data-link-label=\"Click Here - Review Plan\">\u6309\u4E00\u4E0B\u9019\u88E1</a>\u3002",
        "pbx_specialist_new": "是否想預約專家的即時會議，開始配置您的電話系統？請點選下方選項預約時間。",
        "book_specialist_button": "\u9810\u7D04\u5C08\u54E1",
        "setup_zoom_phone_button": "\u8A2D\u5B9AZoom Phone",
        "search_area_code": "根據區碼搜尋",
        "search_area_code_length": "請輸入 3 位數區碼",
        "refresh": "重新整理結果",
        "checked_number_title": "已選取 {0} 個號碼",
        "max_phone_number_desc": "您於結帳時最多只能挑選 {0} 個號碼。 如果您需要超過 {0}，可於結帳後進行設定。",
        "local": {
          "title": "本地"
        },
        "toll_free": {
          "title": "免付費",
          "search_tips": {
            "monthly": "每個免付費號碼需額外支付 {0}/月",
            "annual": "每個免付費號碼需額外支付 {0}/年"
          },
          "popover_tips": "包含一個美國或加拿大的免付費號碼。 所有撥入的分鐘數將以計量方式計算費率。 撥出分鐘數計費將視通話計畫而定。"
        },
        "port_number": {
          "placeholder": "輸入或貼上電話號碼",
          "required": "需要連接埠號碼",
          "must_10_digits": "請輸入有效的電話號碼。",
          "not_valid": "此號碼無法轉移。 請使用不同號碼再次嘗試。",
          "repeat": "此號碼已經過驗證。 請使用不同號碼再次嘗試。",
          "title": "驗證號碼以進行接入",
          "add_number": "新增號碼",
          "verify_successful": "大功告成！ 您的號碼可以轉移。 美國及加拿大無限制通話計畫將新增至您的購物車。 結帳後啟動號碼轉移流程之前，您將收到臨時號碼。",
          "verify_fail": "請使用不同號碼再次嘗試，或聯絡我們的銷售代表取得協助。 <a class=\"port-number-verify-fail\" href=\"{0}\" target=\"_blank\">聯絡銷售人員</a>",
          "max_licenses_check": "如果您需要的線路多於 99 個，請<a href=\"/contactsales\" target=\"_blank\" class=\"port-number-max-licenses-check\">聯絡銷售人員</a>",
          "guarantee_tips": "在完成結帳之前，我們無法保證能夠保留您想要的電話號碼。 所有免付費號碼皆可轉移。",
          "validated_numbers_desc": "{0} 驗證號碼",
          "verify_successful_metered": "Success! Your numbers are portable. An US & Canada Metered calling plan will be added to your cart. You'll receive temporary numbers until you initiate the porting process after checkout.",
          "validated_numbers_desc_v1": "{0} validated number(s)"
        },
        "search_number_title": "選取新的號碼",
        "phone_number_guarantee_tips": "在完成結帳之前，我們無法保證能夠保留您想要的電話號碼。 一旦您完成信用卡付款，您將可在設定帳戶時保留或接入電話號碼。",
        "search_vanity_length": "請輸入 4 到 7 位數字或字母",
        "no_results": "未搜尋到結果。 請再試一次。",
        "calling_plans": "通話計畫",
        "calling_plans_AUS_NZ": "每一個通話計畫都包含澳洲或紐西蘭的當地電話號碼",
        "calling_plans_UK_Ireland": "每一個通話計畫都包含英國或愛爾蘭的當地電話號碼",
        "calling_plans_US_Canada": "每一個通話計畫都包含美國或加拿大的當地電話號碼",
        "calling_plans_JP": "每个通话套餐都包含日本的本地电话号码",
        "calling_plans_Global_Select": "每筆通話方案的每份授權包含一個特定國家/地區境內的一組號碼。",
        "add_another_calling_plan": "+ 新增其他通話計畫",
        "add_additional_numbers": "+ 新增額外電話號碼",
        "add_additional_numbers_tips": "為公司其他辦公室分配其他號碼，做為直撥號碼、或個人直撥專線，或 Zoom Room 號碼。",
        "additional_numbers": "額外電話號碼",
        "additional_numbers_desc": "為公司其他辦公室分配其他號碼，做為直撥號碼、或個人直撥專線，或 Zoom Room 號碼。",
        "subscription_billing_cycle": "訂閱計費週期",
        "phone_features": "電話功能",
        "bring_your_own_carrier": "如欲接入您的專用營運商，請<a href=\"{0}\" target=\"_blank\">聯絡銷售人員</a>。",
        "validate_your_0ABJ_address_instantly": "Need a Japanese number? <a href=\"javascript:void(0);\">Validate your address</a>",
        "do_not_provide_service_for_0ABJ_number": "We currently do not provide service for 0ABJ numbers in this area. Please contact sales if you would like to request 0ABJ service to this address. You can purchase a 050 number at checkout, or try a different address.",
        "your_address_is_eligible": "Success! Your address is eligible for a 0ABJ phone number.",
        "this_address_does_not_qualify_for_0ABJ_number": "This address does not qualify for a 0ABJ number. You can purchase a 050 number at checkout by continuing, or validate a different address.",
        "postal_code": "Postal Code",
        "prefecture": "Prefecture",
        "city_town": "City/Town",
        "sub_municipality": "Sub-municipality",
        "land": "Land",
        "validate_address": "Validate Address",
        "required_field": "Required field",
        "postal_code_must_be_7_digits": "Postal code must be 7 digits",
        "validate": "Validate",
        "invalid_postal_code": "Invalid postal code",
        "contact_us_if_you_like_change": "您目前需支付 <b>{0}</b> 和 <b>{1}</b> 的使用費，若您希望變更，請<a href=\"{2}\" target=\"_blank\">聯絡我們</a>。",
        "plan_details": {
          "view_more": "檢視更多"
        },
        "calling_regions": "Calling Regions",
        "user_number": "User Number",
        "uk_ir_tollfree_tips": "包含一個英國或愛爾蘭的免付費號碼。 所有撥入的分鐘數將以計量方式計算費率。 撥出分鐘數計費將視通話計畫而定。",
        "AU_tollfree_tips": "包含一個澳洲的免付費號碼。 所有撥入的分鐘數將以計量方式計算費率。 撥出分鐘數計費將視通話計畫而定。",
        "NZ_tollfree_tips": "包含一個紐西蘭的免付費號碼。 所有撥入的分鐘數將以計量方式計算費率。 撥出分鐘數計費將視通話計畫而定。",
        "US_tollfree_tips": "包含一個美國或加拿大的免付費號碼。 所有撥入的分鐘數將以計量方式計算費率。 撥出分鐘數計費將視通話計畫而定。",
        "UK_tollfree_tips": "包含一個英國或愛爾蘭的免付費號碼。 所有撥入的分鐘數將以計量方式計算費率。 撥出分鐘數計費將視通話計畫而定。",
        "GS_tollfree_tips": "United States, Canada, United Kingdom, Ireland, Australia, New Zealand, Austria, Denmark, Spain, Sweden, Netherlands, Switzerland, Argentina, Brazil, Mexico, Croatia, Czechia, Cyprus, Finland, Greece, Hungary, Latvia, Lithuania, Luxembourg, Poland, Romania, Slovakia, Slovenia, Israel",
        "calling_plans_metered_tips": "所有撥出分鐘數將以計量方式計算費率。 請參閱<a href=\"/billing/pbx/rates\" target=\"_blank\">計量費率</a>。",
        "more_than_numbers": "如果您需要的號碼多於 {0} 個，請<a href=\"{1}\" target=\"_blank\">聯絡銷售人員</a>",
        "phone_support_24_7_live_chat": "全天候線上聊天和電話支援",
        "phone_support_24_7_live_chat_tip": "適用於所有電話獨立客戶。 與會議計畫配對時，支援計畫會有所不同。",
        "multi_language": "多種語言",
        "auto_remove_unlimited_addons_info": "\u60A8\u5DF2\u522A\u9664\u81EA\u8EAB\u7121\u9650\u91CF\u570B\u969B\u901A\u8A71\u65B9\u6848\u7684\u6240\u6709\u9069\u7528\u65B9\u6848\uFF0C\u5C07\u5F9E\u8A02\u55AE\u79FB\u9664\u9019\u4E9B\u65B9\u6848\u4EE5\u7E7C\u7E8C\u3002",
        "auto_remove_unlimited_addons_title": "\u5C07\u6703\u79FB\u9664\u7121\u9650\u91CF\u570B\u969B\u901A\u8A71\u65B9\u6848",
        "proceed": "繼續",
        "add_on_cant_exceed_pbx_sum": "Zoom Phone Power Pack 使用者人數不得超過 Zoom Phone 通話計畫的總和。",
        "select_disabled_tips": "This plan is pending cancellation. To edit, go back to Plan Management and Reactivate.",
        "global_select": "全球計畫"
      },
      "cmr_ldk": {
        "desc": "Additional storage to store, stream, share, and download meetings",
        "intro": "Enhance your storage capabilities with additional monthly storage to store, stream, share, and download meetings from the Zoom Cloud.",
        "tips_base": "Recording minute is calculated by session minutes recorded multiplied by the number of recording files processed/generated in a session.",
        "tips": "Excess fees are charged when storage limits ({0}/month) and/or recording minute limits ({1} recording minutes/month) are exceeded. Fees are as below and will be charged monthly to your account should you exceed storage and/or Recording minute limits：",
        "tips_2": "Storage overage：{0} per GB",
        "tips_3": "Recording minute overage：{0} per recording minute",
        "tips_tb_2": "– {0}：{1}/GB；{2}/錄製分鐘"
      },
      "video_sdk": {
        "subscription_video_sdk_msg": "\u8ACB\u6AA2\u67E5\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u4EE5\u9032\u884C\u78BA\u8A8D\uFF0C\u5176\u4E2D\u5305\u542B\u60A8\u7684\u91D1\u9470\u3001\u5BC6\u78BC\uFF0C\u4EE5\u53CA\u53EF\u4F9B\u958B\u59CB\u4F7F\u7528\u7684\u6240\u6709\u8CC7\u6E90\u3002",
        "desc": "Zoom 領先業界的視訊優先通訊平台，可加快開發作業並且打造出以視訊技術為基礎的自訂應用程式。",
        "free_min": "每個月內含免費 {0} 分鐘數",
        "switch_now": "Switch now",
        "switch_plan_to_universal": "Want to switch to the Zoom SDK Universal Credit plan and enjoy access to all Video SDK services?",
        "use_case": "Development Use Case",
        "use_case_other": "If Other, Please Specify",
        "unit": "minute thereafter",
        "plan_details": {
          "cloud_based": "以雲端為基礎的架構",
          "customizable": "可自訂視訊組合",
          "hd": "高畫質視訊和音訊",
          "flexible": "彈性費率",
          "cloud_based_desc": "專為視訊設計，工程設計極為可靠並且非常適合擴充",
          "customizable_desc": "最多支援 {0} 名與會者、第三方現場直播、會議內聊天和更多功能",
          "hd_desc": "適用於虛擬會議的高解析度視訊會議",
          "flexible_desc": "每月包括免費 {0} 分鐘數，超過的分鐘數將以 {1} 計費",
          "unit_tooltip": "SDK 服務使用量是由每月會議會程分鐘數決定。 例如，5 名使用者參加一場 10 分鐘的會議，則共計為 50 分鐘。 不滿一分鐘以一分鐘計算。"
        },
        "ldp": {
          "minute": "Video SDK Session"
        },
        "cmr": {
          "minute": "Video SDK Cloud Recording Minutes",
          "storage": "Video SDK Cloud Recording Storage"
        },
        "zvdktt": {
          "minute": "Video SDK Translation and Transcription"
        },
        "zvdcrcp": {
          "minute": "Video SDK Cloud Room Connector"
        },
        "adp": {
          "minute": "Audio Conferencing"
        },
        "zvsdkqss": {
          "minute": "Quality of Service Subscription"
        },
        "zvsdkcbwp": {
          "minute": "Cobrowse SDK"
        }
      },
      "zoom_whiteboard": {
        "plan_comparision_title": "Whiteboard",
        "title": "Zoom Whiteboard",
        "desc": "使用具有進階文件控制項的無限制白板進行協作，包括同步編輯和標準白板功能。",
        "concurrent_editable_boards_owned": "擁有可同時編輯的白板",
        "zoom_cloud_storage": "Zoom 雲端儲存",
        "maximum_size": "最大白板尺寸",
        "google_drive_doc_int": "Google Drive 和 OneDrive 文件整合",
        "unsigned_links": "具有評論和編輯權限的未簽署訪客連結",
        "personal_libraries": "個人自訂形狀資源庫",
        "private_editing_mode": "私人編輯模式",
        "pin_whiteboard": "Pin Whiteboard to Zoom Chats and Channels",
        "include_in_chat": "Include Shared whiteboards in Chat and channel Resource page",
        "open_in_chat": "Open and Edit whiteboard while in Chat and Channels",
        "add_to_events": "Add Whiteboard to events in Zoom Calendar",
        "create_in_doc": "Create and embed whiteboard in Zoom Doc",
        "quick_share": "Quick share whiteboard to Zoom Rooms",
        "embed_clips": "Embed Zoom Clips",
        "shared_projects": "共享的專案",
        "stickers_reactions_gif_libraries": "貼紙、回應和 gif 資源庫",
        "embed_live_whiteboards": "在 Coda 和 Confluence 中嵌入即時白板",
        "tags_notes_cards": "筆記和卡片上的標籤",
        "miro_importer": "Miro 匯入者",
        "zoom_ai_companion": "使用 Zoom AI Companion 創作和修改內容",
        "zoom_ai_companion_desc": "需要專業版、商業版或企業版帳戶",
        "teams_gc_int": "Microsoft Outlook 和 Google 日曆整合",
        "teams_gc_int_desc": "需要 Zoom Outlook 或 Google 日曆附加元件",
        "unsigned_links_access": "具有檢視權限的未簽署訪客連結",
        "unlimited_canvas_with_up_to_12_pages": "高達 12 頁的無限制畫布",
        "pen_and_highlighter_annotations": "筆和螢光筆註記",
        "shapes_lines_connectors_and_quick_diagraming": "形狀、線條、連接符號和快速圖表",
        "rich_text_urls_notes_and_reactions": "RTF 文字、URL、便利貼和回應",
        "image_and_pdf_embed_and_cropping": "嵌入和裁切的影像和 PDF",
        "tables_mind_maps_kanbans_and_cards": "表格、心智圖、圖表、看板和卡片",
        "comments_mentions_and_notifications": "評論、@ 提及和通知",
        "align_distribute_rotate_group_and_lock_content": "對齊、分散、旋轉、分組、篩選和鎖定內容",
        "presence_cursors_live_editing_and_follow_along": "顯示游標、即時編輯和掌握狀況",
        "frames_and_presentation_mode": "排版和簡報模式",
        "timer": "計時器、投票、雷射筆",
        "export_to_high_resolution_image_pdf_and_csv": "匯出高解析度影像、PDF 和 CSV",
        "guest_collaboration": "來賓檢視、評論和編輯存取權",
        "guest_collaboration_desc": "訪客使用者需要基本版 Zoom 帳戶才能在會議外進行存取",
        "sharing_roles_and_permission_management": "分享、角色和權限管理",
        "microsoft_teams_and_slack_integration": "Microsoft Teams 和 Slack 整合",
        "requires_zoom_app_installation": "要求安裝 Zoom 機器人，允許聊天中分享和存取 Zoom Whiteboard",
        "templates": "範本",
        "temporarily_lock_whiteboard_access": "暫時鎖定白板",
        "version_history_and_activity_log": "版本歷史記錄和活動記錄",
        "shared_folders_personal_labels": "共用資料夾和個人標籤",
        "jira_cloud_cards": "Jira、Asana 和 Azure DevOps 卡片",
        "personal_templates": "Personal and Organizational Custom Templates",
        "organizational_templates": "組織範本",
        "also_supports_create_and_share_whiteboards": "還支援使用 Slack 和 Microsoft Teams 聊天和頻道來創作和分享白板",
        "included_in_zoom_one_basic_and_zoom_one_pro": "包含在 Zoom One 基礎版和 Zoom One 專業版內",
        "unlimited_concurrently_editable_whiteboards": "無限制且可同時編輯的白板",
        "unlimited_concurrently_editable_whiteboards_and_cloud_storage": "無限制且可同時編輯的白板和雲端儲存",
        "one_gb_cloud_storage_capacity": "1 GB 雲端儲存容量"
      },
      "zoom_whiteboard_plus": {
        "plan_comparision_title": "Whiteboard 加強版",
        "title": "Zoom Whiteboard 加強版",
        "desc": "透過進階功能和整合最佳化工作流程。 取得完整的白板附加套件、自訂範本和第三方整合。",
        "add_on_desc": "Access the complete Whiteboard add-on package, featuring advanced tools, unlimited boards, customizable templates, and 3rd-party integrations.",
        "already_include_in_workplace": "This is already included with Zoom Workplace. You can purchase more licenses and assign them to Basic or Pro users, or <a class=\"opc-wb-2-plus\" href=\"javascript:void(0);\">switch to Zoom Whiteboard Plus</a> to provide Business users with more whiteboard features.",
        "already_include_in_biz": "This is already included with Zoom Workplace Business. You can purchase more licenses and assign them to Basic or Pro users, or <a class=\"opc-wb-2-plus\" href=\"javascript:void(0);\">switch to Zoom Whiteboard Plus</a> to provide Business users with more whiteboard features.",
        "already_include_in_biz_plus": "This is already included with Zoom Workplace Business Plus. You can purchase more licenses and assign them to Basic or Pro users, or <a class=\"opc-wb-2-plus\" href=\"javascript:void(0);\">switch to Zoom Whiteboard Plus</a> to provide Business Plus users with more whiteboard features.",
        "already_include_in_edu": "This is already included with Zoom Workplace for School and Campus. You can purchase more licenses and assign them to Basic users, or <a class=\"opc-wb-2-plus\" href=\"javascript:void(0);\">switch to Zoom Whiteboard Plus</a> to provide School and Campus users with more whiteboard features.",
        "already_include_in_edu_plus": "This is already included with Zoom Workplace for School and Campus Plus. You can purchase more licenses and assign them to Basic users, or <a class=\"opc-wb-2-plus\" href=\"javascript:void(0);\">switch to Zoom Whiteboard Plus</a> to provide School and Campus Plus users with more whiteboard features.",
        "already_include_in_meeting_edu": "This is already included with Zoom Meetings Education. You can purchase more licenses and assign them to Basic users, or <a class=\"opc-wb-2-plus\" href=\"javascript:void(0);\">switch to Zoom Whiteboard Plus</a> to Education users with more whiteboard features."
      },
      "zoom_whiteboard_basic": {
        "title": "Whiteboard 基本版"
      },
      "zone_edu_sch": {
        "title": "Zoom One 教育解決方案學校與校園版",
        "brief_title": "學校與校園",
        "switch_info": "Switching to {0} will cancel your {1} plan. Your new plan will activate right after purchase."
      },
      "zone_edu_plus": {
        "title": "Zoom One 教育解決方案學校與校園加強版",
        "brief_title": "學校與校園加強版",
        "at_least_desc": "您需要至少 {0} 名使用者以完成購買。"
      },
      "zoom_whiteboard_plan_comparsion": "Zoom Whiteboard 方案比較",
      "meeting_license_decrease_tips_need_decrease_addon": "To decrease the number of users for Zoom One, you need to adjust the add-on {product} license quantity to be equal to or less than Zoom One. <a href=\"/billing\">Return to Plan Management</a>",
      "cancel_disable_contact_us": "If you would like to request to cancel this plan, please <a href=\"{url}\" target=\"_blank\">contact us</a>",
      "unit": {
        "license": "{0} 授權",
        "attendee": "{0} 觀眾"
      },
      "pro": "Pro",
      "business": "\u5546\u696D",
      "first_name": "\u540D\u5B57",
      "last_name": "\u59D3\u6C0F",
      "email": "\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
      "required": "\u5FC5\u586B",
      "require_first_name": "\u5FC5\u9808\u63D0\u4F9B\u540D\u5B57",
      "require_last_name": "\u5FC5\u9808\u63D0\u4F9B\u59D3\u6C0F",
      "require_email_address": "\u5FC5\u9808\u63D0\u4F9B\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
      "billing_contact": "\u4ED8\u6B3E\u806F\u7D61\u4EBA",
      "sold_to_contact": "\u8CFC\u8CB7\u806F\u7D61\u4EBA",
      "email_address": "\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
      "confirm_email_label": "\u78BA\u8A8D\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
      "company_organization_optional": "\u516C\u53F8/\u7D44\u7E54\u540D\u7A31\uFF08\u9078\u586B\uFF09",
      "employee_count": "\u54E1\u5DE5\u6578",
      "address": "\u5730\u5740",
      "apt_suite_optional": "\u516C\u5BD3/\u5957\u623F\uFF08\u9078\u586B\uFF09",
      "city": "\u5E02/\u93AE",
      "state": "\u5DDE/\u7701",
      "zip_postal": "\u90F5\u905E\u5340\u865F",
      "country_region": "\u570B\u5BB6/\u5730\u5340",
      "business_name": "Business Name",
      "business_country": "Business Headquaters Country",
      "business_size": "Business Size",
      "billing_contact_subtitle": "\u9019\u662F\u63A5\u6536\u767C\u7968\u6216\u4EFB\u4F55\u5E33\u52D9\u901A\u8A0A\u7684\u806F\u7D61\u4EBA\u6216\u90E8\u9580",
      "select_country": "\u9078\u53D6\u570B\u5BB6/\u5730\u5340",
      "select_total_employee_count": "\u9078\u53D6\u54E1\u5DE5\u7E3D\u6578",
      "just_me": "\u53EA\u6709\u6211",
      "same_as_bill_contact": "\u8207\u4ED8\u6B3E\u806F\u7D61\u4EBA\u76F8\u540C",
      "invalid_zip": "\u8ACB\u8F38\u5165 5 \u4F4D\u6578\u7684\u7F8E\u570B\u90F5\u905E\u5340\u865F",
      "invalid": "\u7121\u6548",
      "transaction_declined": "\u4EA4\u6613\u88AB\u62D2\u7D55",
      "accept_terms_of_service": "\u8ACB\u63A5\u53D7\u670D\u52D9\u689D\u6B3E\u3002",
      "unknown_error_try_again": "\u8655\u7406\u4EA4\u6613\u6642\u767C\u751F\u672A\u77E5\u932F\u8AA4\u3002\u8ACB\u7A0D\u5F8C\u91CD\u8A66\u3002",
      "invalid_quantity": "\u7121\u6548\u7684\u6578\u91CF",
      "invalid_jp_zip": "\u90F5\u905E\u5340\u865F\u50C5\u53EF\u5305\u542B\u6578\u503C",
      "invalid_in_zip": "請輸入 6 位數印度郵遞區號",
      "expirationDate": "\u5230\u671F\u65E5\u671F",
      "plan": "方案",
      "plan_feature": {
        "workflow": {
          "title": "Workflow Automation",
          "desc_ai": "Organize AI Companion-generated meeting summaries in a Zoom Doc and share it through Team Chat",
          "desc_doc": "Ask AI Companion to summarize daily conversations from Team Chat into a dedicated channel or Zoom Doc",
          "tip": "Zoom Workflow Automation streamlines work, integrates with third-party apps, and leverages AI Companion to provide actionable insights. Enjoy unlimited runs for a limited time—pricing and terms are subject to change after the promotional period.",
          "label": "Complimentary access"
        }
      },
      "cvv": "CVV",
      "credit_card_number": "\u4FE1\u7528\u5361\u5361\u865F",
      "card_hold_name": "\u6301\u5361\u4EBA\u59D3\u540D",
      "unknown_error": "\u672A\u77E5\u932F\u8AA4\uFF01",
      "pop_up_blocked": "\u5FEB\u986F\u8996\u7A97\u5DF2\u88AB\u5C01\u9396\uFF0C\u8ACB\u5141\u8A31\u5FEB\u986F\u8996\u7A97\u4E26\u91CD\u8A66\u3002",
      "select_state": "\u9078\u53D6\u5DDE/\u7701",
      "currencies": {
        "aud": "\u6FB3\u5143",
        "cad": "\u52A0\u62FF\u5927\u5143",
        "cny": "\u4EBA\u6C11\u5E01",
        "eur": "\u6B50\u5143",
        "gbp": "\u82F1\u938A",
        "inr": "\u5370\u5EA6\u76E7\u6BD4",
        "jpy": "\u65E5\u5713",
        "usd": "\u7F8E\u5143",
        "php": "\u83F2\u5F8B\u5BBE\u6BD4\u7D22",
        "krw": "\u5357\u97D3\u571C",
        "mxn": "\u58A8\u897F\u54E5\u62AB\u7D22",
        "brl": "\u5DF4\u897F\u96F7\u4E9E\u723E",
        "zar": "\u5357\u975E\u862D\u7279",
        "ils": "\u4EE5\u8272\u5217\u65B0\u8B1D\u514B\u723E",
        "chf": "\u745E\u58EB\u6CD5\u90CE",
        "sgd": "\u65B0\u52A0\u5761\u5143",
        "try": "\u571F\u8033\u5176\u91CC\u62C9",
        "pen": "\u79D8\u9B6F\u65B0\u7D22\u723E",
        "sek": "\u745E\u5178\u514B\u6717",
        "hkd": "\u6E2F\u5E63",
        "clp": "\u667A\u5229\u62AB\u7D22",
        "cop": "\u54E5\u502B\u6BD4\u4E9E\u62AB\u7D22",
        "ars": "\u963F\u6839\u5EF7\u62AB\u7D22",
        "nzd": "\u7D10\u897F\u862D\u5143",
        "pln": "\u6CE2\u862D\u8332\u7F85\u63D0",
        "dkk": "\u4E39\u9EA5\u514B\u6717",
        "nkk": "\u632A\u5A01\u514B\u6717",
        "vnd": "\u8D8A\u5357\u76FE"
      },
      "coupon": {
        "support_coupon": {
          "offer_desc": "You have a {0}% coupon offer from Zoom Support",
          "redeem_btn": "Redeem now"
        },
        "downsell_edit_reason": "A minimum of {0} user(s) is required when switching to annual and claiming this offer.",
        "distribute": {
          "discount": {
            "page_title": "\u54E1\u5DE5\u53CA\u5176\u89AA\u53CB\u5C08\u5C6CZoom\u6298\u6263",
            "content_line1": "\u91CD\u5927\u6D88\u606F-Zoom\u512A\u60E0\u5238\u4EE3\u78BC\u73FE\u5DF2\u958B\u653E\u7D66\u54E1\u5DE5\u53CA\u5176\u89AA\u53CB\u4F7F\u7528\uFF01",
            "content_line2": "\u4E00\u7D93\u6309\u4E0B\u63D0\u4EA4\uFF0C\u6211\u5011\u4FBF\u6703\u900F\u904E\u96FB\u5B50\u90F5\u4EF6\u5C0710\u7D44\u5C08\u5C6C\u4E00\u6B21\u6027\u4F7F\u7528\u512A\u60E0\u5238\u4EE3\u78BC\u5BC4\u9001\u7D66\u60A8\u3002\u60A8\u53EF\u4EE5\u4F7F\u7528\u6B64\u512A\u60E0\u5238\u4EE3\u78BC\u8CFC\u8CB7Zoom\u5E33\u6236\uFF08\u5C08\u696D\u7248\uFF09\u4F9B\u81EA\u7528\uFF0C\u6216\u8207\u6700\u591A10\u4F4D\u89AA\u670B\u597D\u53CB\u5206\u4EAB\u3002",
            "content_line3": "\u9019\u662F\u9069\u7528\u65BC\u5C0F\u578B\u4F01\u696D\u4E3B\uFF0C\u4EE5\u53CA\u9700\u5B9A\u671F\u8207\u5BA2\u6236\u958B\u6703\u4E4B\u5C08\u696D\u4EBA\u58EB\u7684\u7406\u60F3\u5E33\u6236\u985E\u578B\u3002",
            "detail_title": "\u8A73\u7D30\u8CC7\u8A0A\uFF1A",
            "detail_line1": "\u7D66\u4E88\u65B0\u4F7F\u7528\u8005Zoom\u6703\u8B70\u8A02\u95B115%\u6298\u6263\u512A\u60E0\u3002",
            "detail_line2": "\u81EA\u8CFC\u8CB7\u65E5\u8D77\uFF0C15%\u6298\u6263\u512A\u60E0\u6709\u6548\u671F\u70BA1\u5E74\u3002",
            "detail_line3": "\u6BCF\u4F4D\u5168\u8077\u54E1\u5DE5\u6700\u591A\u53EF\u4F7F\u7528/\u5206\u4EAB\u672C\u512A\u60E0\u523810\u6B21\uFF08\u7D04\u8058\u54E1\u5DE5\u53CA\u81E8\u6642\u54E1\u5DE5\u5247\u4E0D\u7B26\u8CC7\u683C\uFF09\u3002",
            "detail_line4": "\u5982\u679C\u60A8\u5DF2\u4E0D\u518D\u662F\u5168\u8077\u54E1\u5DE5\uFF0C\u60A8\u5E33\u6236\u5167\u4EFB\u4F55\u672A\u4F7F\u7528\u7684\u4EE3\u78BC\u5C07\u518D\u4E5F\u7121\u6CD5\u4F7F\u7528\u3002",
            "detail_line5": "\u60A8\u5FC5\u9808\u5C07\u6B64\u512A\u60E0\u5238\u7528\u65BC\u65B0\u5E33\u6236\uFF0C\u5176\u7121\u6CD5\u5728\u73FE\u6709\u5E33\u6236\u4E0A\u4F7F\u7528\u3002",
            "detail_line6": "\u6B64\u512A\u60E0\u9069\u7528\u65BC\u6A19\u6E96\u5C08\u696D\u7248\u5E74\u5EA6\u6216\u6A19\u6E96\u5546\u696D\u7248\u5E74\u5EA6\u7DDA\u4E0A\u8CFC\u8CB7\u9805\u76EE\u3002\u6BCF\u6B21\u8CFC\u8CB7\u6700\u591A20\u500B\u6388\u6B0A\u3002\u8ACB\u6CE8\u610F\uFF0C\u6B64\u512A\u60E0\u4E0D\u9069\u7528\u65BC\u5DF2\u4EAB\u6709\u65E2\u6709\u6298\u6263\u7684\u5BA2\u6236\u3002",
            "detail_line7": "\u6B64\u512A\u60E0\u5238\u4E26\u7121\u73FE\u91D1\u50F9\u503C\u4E14\u50C5\u53EF\u7528\u65BC\u6A19\u6E96\u5C08\u696D\u7248\u5E74\u5EA6\u6216\u6A19\u6E96\u5546\u696D\u7248\u9805\u76EE\u3002\u512A\u60E0\u5238\u5FC5\u9808\u5728\u60A8\u4ECD\u70BA\u5728\u8077\u54E1\u5DE5\u8EAB\u5206\u624D\u80FD\u514C\u63DB\uFF0C\u800C\u4E14\u53EA\u8981\u60A8\u7684\u5E33\u6236\u70BA\u6709\u6548\u72C0\u614B\uFF0C\u512A\u60E0\u5238\u5C31\u6709\u6548\u3002\u6B64\u512A\u60E0\u5238\u4E0D\u5F97\u5408\u4F75\u3001\u4EA4\u6613\u6216\u8207\u4EFB\u4F55\u5176\u4ED6\u512A\u60E0\u540C\u6642\u4F7F\u7528\u3002",
            "submit_desc": "\u7576\u6309\u4E0B\u63D0\u4EA4\u6642\uFF0C\u6211\u5011\u6703\u900F\u904E\u96FB\u5B50\u90F5\u4EF6\u5C07\u4EE3\u78BC\u5BC4\u9001\u5230\uFF1A",
            "validation_title": "Zoom Discount for Employees",
            "success_content": "We have sent a confirmation email to your Zoom email address with your coupon codes and details on how to use them. Please check your email for next steps."
          }
        },
        "not_switch_plan_pending_plans": "此項變更無法與此優惠券合用。",
        "not_eligible_dialog_title": "Coupon not eligible",
        "coupon_input_placeholder": "折扣券代碼",
        "invalid_code_tips": "錯誤：無效的折扣券代碼",
        "reach_limit": "錯誤：此折扣券已達兌換限制",
        "invalid_code_default": "錯誤：此折扣碼不適用於任何您已選取的方案。",
        "success_tips": "折扣僅適用於符合資格的項目。",
        "terms_and_conditions": "\u689D\u6B3E\u548C\u689D\u4EF6",
        "add_coupon_code": "新增折扣券代碼",
        "pending_coupon_desc": "\u5F85\u8655\u7406\u7684\u6298\u6263\u5238\u5728 {0} \u4E0A\u751F\u6548\u524D\uFF0C\u60A8\u7121\u6CD5\u4FEE\u6539\u65B9\u6848\uFF0C\u60A8\u53EF\u4EE5\u53D6\u6D88\u5F85\u8655\u7406\u7684\u6298\u6263\u5238\u4E26\u91CD\u8A66\uFF0C\u4EE5\u7ACB\u5373\u751F\u6548\u3002",
        "error": {
          "invalid": "您輸入的折扣券代碼無效。 請檢查您的拼寫或輸入不同的代碼。",
          "ineligible": "抱歉，您不符合使用此折扣券的資格。",
          "inactive": "此折扣券已不再有效。",
          "maximum_times": "此折扣券已達到最大使用次數，不再有效。",
          "maximum_licence": "此折扣券僅限用於最多 {0} 個授權。 請調整數量選擇後再試一次。",
          "maximum_licences": "此折扣券僅限用於最多 {0} 個授權。 請調整數量選擇後再試一次。",
          "with_new_subscription": "此折扣券僅適用於新的訂閱。",
          "with_replace_subscription": "此折扣券僅適用於目前已參加訂閱方案的使用者。",
          "pre_existing": "您有一張目前有效的既有折扣券。 一次只能使用一張折扣券。",
          "same_coupon_code": "我們的記錄顯示您已在此方案使用過相同的折扣券。",
          "currency": "此折扣券僅適用於特定貨幣。 請切換為其他貨幣後再試一次。",
          "not_match_mandatory_plan": "此優惠券需要將 {0} 新增至您的購物車。",
          "with_billing_cycle": "此折扣券只能用於 {0} 訂閱週期。",
          "with_pending_downsell": "由於有待處理的降價，因此您無法兌換此折扣券，您可以「撤銷」降價並立即兌換，或是待降價生效後再兌換。",
          "maximum_coupon_count": "您有 2 張目前有效的既有折扣券。 目前最多只能使用 2 張折扣券。",
          "pending_renewal_apply": "如果您想要新增折扣券，請先從您的帳戶取消待處理的折扣券。",
          "with_pending_downgrade": "\u5728 {0} \u53D6\u6D88\u751F\u6548\u4E4B\u524D\uFF0C\u60A8\u7121\u6CD5\u514C\u63DB\u6B64\u6298\u6263\u5238\u3002 \u5B8C\u6210\u5F8C\uFF0C\u8ACB\u91CD\u65B0\u5617\u8A66\u514C\u63DB\u6298\u6263\u5238\u3002",
          "with_partner": "We're sorry, you are currently not eligible for the {0} promotion.",
          "country": "您目前所在的位置，並不符合使用此折扣券的資格。",
          "redeemed": "此折扣券已被使用過，不再有效。"
        },
        "discount": "折扣",
        "expiresDesc": "於 {0} 截止"
      },
      "common": {
        "cart_bag": {
          "continue_shopping_btn": "瀏覽更多產品",
          "cart_title": "您的購物車"
        },
        "optional": "選用",
        "require_field_indicate": "必填欄位",
        "before_taxes": "稅前",
        "learn_more_about_edu": "深入瞭解關於 <a href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0057649\" target=\"_blank\">Zoom 教育解決方案的使用資格要求<i class=\"zm-icon-window-new\"></i></a>",
        "max_license_exceed_contact_us": "\u5982\u9700\u8CFC\u8CB7\u8D85\u904E {0} \u500B\u6388\u6B0A\uFF0C\u8ACB<a href=\"https://zoom.us/phonesystem#signup-phone\" target=\"_blank\">\u806F\u7D61\u696D\u52D9\u4EBA\u54E1</a>\u3002",
        "max_exceed_contact_us": "\u5982\u9700\u8CFC\u8CB7\u8D85\u904E99\u500B\u6388\u6B0A\uFF0C\u8ACB<a href=\"https://zoom.us/phonesystem#signup-phone\" target=\"_blank\">\u806F\u7D61\u696D\u52D9\u4EBA\u54E1</a>\u3002",
        "apply": "\u5957\u7528",
        "cancel": "\u53D6\u6D88",
        "add": "新增",
        "remove": "\u79FB\u9664",
        "edit": "\u7DE8\u8F2F",
        "view": "檢視",
        "edit_plan": "編輯方案",
        "place_order": "下訂單",
        "submit": "提交",
        "place_order_and_confirm_payment": "下單並確認付款",
        "proceed_to_payment": "繼續付款",
        "reject": "拒絕",
        "accept": "接受",
        "expire_brief": "到期",
        "per_billing_cycle_number": {
          "monthly": "/month/number",
          "annual": "/year/number",
          "one_month": "/number",
          "quarterly": "/quarter/number",
          "two_years": "/two years/number",
          "three_years": "/three years/number"
        },
        "per_billing_cycle_space": {
          "monthly": "/月/空間",
          "annual": "/年/空間"
        },
        "per_billing_cycle_line": {
          "monthly": "/月/線路",
          "annual": "/年/線路"
        },
        "per_billing_cycle_license": {
          "monthly": "/月/授權",
          "annual": "/年/授權",
          "one_month": "/授權",
          "quarterly": "/季度/授權",
          "two_years": "/兩年/授權",
          "three_years": "/三年/授權",
          "price_monthly": "{price}/月/使用者",
          "price_annual": "{price}/月/使用者，按年計費"
        },
        "per_billing_cycle_user": {
          "monthly": "/月/使用者",
          "annual": "/年/使用者",
          "one_month": "/使用者",
          "quarterly": "/季度/使用者",
          "two_years": "/兩年/使用者",
          "three_years": "/三年/使用者"
        },
        "per_billing_cycle_room": {
          "monthly": "/月/room",
          "annual": "/年/room",
          "one_month": "/會議室",
          "quarterly": "/季度/會議室",
          "two_years": "/兩年/會議室",
          "three_years": "/三年/會議室"
        },
        "per_billing_cycle_port": {
          "monthly": "/月/連接埠",
          "annual": "/年/連接埠",
          "one_month": "/連接埠",
          "quarterly": "/季度/連接埠",
          "two_years": "/兩年/連接埠",
          "three_years": "/三年/連接埠"
        },
        "per_billing_cycle": {
          "monthly": "/月",
          "annual": "/年",
          "one_month": "/月",
          "quarterly": "/季度",
          "two_years": "/兩年",
          "three_years": "/三年"
        },
        "per_billing_cycle_attendee": {
          "monthly": "觀眾/月",
          "annual": "名觀眾/年",
          "one_month": "觀眾"
        },
        "from": "\u5F9E",
        "learn_more": "深入瞭解",
        "Learn_more": "深入瞭解",
        "Learn_More": "深入瞭解",
        "new": "新功能",
        "popular": "熱門",
        "beta": "測試版",
        "select": "特選",
        "contact_sales": "聯絡銷售人員",
        "legacy_limit_dialog_title": "很抱歉...",
        "legacy_limit_dialog_content": "{0} 無法購買。 請聯繫我們的銷售團隊以了解詳情。",
        "confirm": "確認",
        "company_organization": "\u516C\u53F8/\u7D44\u7E54\u540D\u7A31",
        "update_plan": "更新方案",
        "update_plan_error": "您的方案無法更新。 請再試一次。",
        "limit_block": "請等待請求處理並稍後再試。",
        "checkout": "結帳",
        "search": "搜尋",
        "or": "或",
        "validate": "驗證",
        "can_not_continue": "無法繼續",
        "billing_cycle_auto_update_desc": "{0} 的訂閱週期現在已更新為符合 {1} 的訂閱週期。",
        "license_equal_to_base": "每次購買 {1} 授權都需要有相同數量的 {0} 使用者",
        "license_equal_to_base_for_webinar": "每次購買 {1} 授權 (不包括一次性方案) 時，需要有相同數量的 {0} 付費使用者。",
        "consumption_equal_to_base": "{0} 需要付費 {1} 訂閱",
        "billing_cycle_current": "目前",
        "billing_cycle": {
          "monthly": "\u6708\u4ED8",
          "yearly": "\u6309\u5E74"
        },
        "per_billing_cycle_one_month": {
          "one_month": "/單月"
        },
        "return_to_plan_management": "返回方案管理",
        "order_confirmation_send_to": "Your order confirmation will be sent to {0}",
        "auto_remove_notification": "{0} have been removed from your cart due to purchase restrictions."
      },
      "payment": {
        "paypal": "PayPal",
        "credit": "信用卡或簽帳卡",
        "backup_apm_desc": "您將前往 {0} 以授權同意結算。 請確保允許彈出視窗。 這將成為您資料中的付款方式。",
        "apple_pay": "Apple Pay",
        "google_pay": "Google Pay",
        "credit_name": "\u4FE1\u7528\u5361",
        "change_payment": "變更付款方式",
        "apple_pay_desc": "按一下下方的按鈕，以從您的 Apple Pay 錢包中選取付款方式。 在您完成購買前，仍能檢視您的訂單。",
        "apple_pay_not_supported": "Apple Pay 付款選項僅支援執行 Safari 瀏覽器的合格 Apple 裝置。",
        "google_pay_desc": "按一下下方的按鈕，以從您的 Google Pay 錢包中選取付款方式。 在您完成購買前，仍能檢視您的訂單。",
        "google_pay_not_supported": "您的裝置或網頁瀏覽器不支援 Google Pay 付款選項。",
        "payment_title": "\u652F\u4ED8\u65B9\u5F0F",
        "payment_upi_title": "請輸入您的統一支付介面 (UPI) 付款資訊",
        "paypal_pending_desc": "您將前往 PayPal 以授權同意結算。 請確保允許彈出視窗。 我們此時不會向您收取費用。",
        "sofort": "Sofort",
        "sofort_sepa": "SOFORT/SEPA",
        "sofort_desc": "\u7CFB\u7D71\u5C07\u5E36\u9818\u60A8\u524D\u5F80SOFORT\u4EE5\u6388\u6B0A\u8A08\u8CBB\u5408\u7D04\u3002\u8ACB\u78BA\u4FDD\u5141\u8A31\u5F48\u51FA\u8996\u7A97\u3002\u9019\u5C07\u6210\u70BA\u60A8\u5B58\u6A94\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "sofort_upgrade_message": "SOFORT/SEPA\u7121\u6CD5\u7528\u65BC\u5347\u7D1A\u3002\u8ACB\u6309\u4E00\u4E0B\u300C\u7DE8\u8F2F\u300D\u9023\u7D50\u4EE5\u8B8A\u66F4\u60A8\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "apm_option_no_longer_supported": "不再支援 {0}。請變更您的付款方式。",
        "customer_balance": "\u632f\u8fbc",
        "furikomi": "Furikomi",
        "customer_balance_desc": "\u7CFB\u7D71\u5C07\u5E36\u9818\u60A8\u524D\u5F80Furikomi\u4EE5\u6388\u6B0A\u8A08\u8CBB\u5408\u7D04\u3002\u8ACB\u78BA\u4FDD\u5141\u8A31\u5F48\u51FA\u8996\u7A97\u3002\u9019\u5C07\u6210\u70BA\u60A8\u5B58\u6A94\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "customer_balance_upgrade_message": "Furikomi 不能用於升級。 請按一下「編輯」連結以變更您的付款方式。",
        "ideal": "iDEAL",
        "ideal_desc": "\u7CFB\u7D71\u5C07\u5E36\u9818\u60A8\u524D\u5F80iDEAL\u4EE5\u6388\u6B0A\u8A08\u8CBB\u5408\u7D04\u3002\u8ACB\u78BA\u4FDD\u5141\u8A31\u5F48\u51FA\u8996\u7A97\u3002\u9019\u5C07\u6210\u70BA\u60A8\u5B58\u6A94\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "ideal_upgrade_message": "iDEAL/SEPA\u7121\u6CD5\u7528\u65BC\u5347\u7D1A\u3002\u8ACB\u6309\u4E00\u4E0B\u300C\u7DE8\u8F2F\u300D\u9023\u7D50\u4EE5\u8B8A\u66F4\u60A8\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "us_bank_account": "US ACH \u76f4\u63a5\u6263\u6b3e",
        "us_ach_direct_debit": "US ACH Direct Debit",
        "us_bank_account_desc": "\u60a8\u5c07\u524d\u5f80\u300c\u9280\u884c\u5e33\u6236\u8f49\u5e33\u300d\u4ee5\u6388\u6b0a\u540c\u610f\u7d50\u7b97\u3002\u8acb\u78ba\u4fdd\u672a\u963b\u64cb\u5f48\u51fa\u8996\u7a97\u3002\u9019\u5c07\u6210\u70ba\u60a8\u5efa\u6a94\u7684\u4ed8\u6b3e\u65b9\u5f0f\u3002\u8acb\u6ce8\u610f\uff1a\u6240\u8acb\u6c42\u7684\u5e33\u6236\u8b8a\u66f4\u53ef\u80fd\u56e0\u9280\u884c\u8f49\u5e33\u4f5c\u696d\u6642\u9593\u800c\u5ef6\u9072\u3002\u5982\u6709\u6025\u9700\uff0c\u8acb\u9078\u64c7\u5237\u5361\u4ed8\u6b3e\u3002",
        "us_bank_account_upgrade_message": "ACH \u9280\u884c\u8f49\u5e33\u4e0d\u80fd\u7528\u65bc\u5347\u7d1a\u3002 \u8acb\u6309\u4e00\u4e0b\u300c\u7de8\u8f2f\u300d\u9023\u7d50 \u4ee5\u8b8a\u66f4\u60a8\u7684\u4ed8\u6b3e\u65b9\u5f0f\u3002",
        "klarna": "Klarna",
        "klarna_de_se": "立即購買，稍後支付",
        "klarna_desc": "您將前往 Klarna 以授權結算同意書。 請確保允許彈出視窗。 這將成為您資料中的付款方式。",
        "klarna_upgrade_message": "Klarna 不能用於升級。請按一下「編輯」連結以變更您的付款方式。",
        "klarna_billing_cycle_message": "Klarna 只能用於相同訂閱週期 (例如，全部皆為按年或全部皆為按月) 的產品。請更新您的訂閱週期以使其相符，或選取「編輯」以變更您的付款方式。",
        "klarna_payment_catgory": {
          "pay_in_installments": "分期付款",
          "pay_later": "稍後支付",
          "pay_now": "立刻支付",
          "pay_with_financing": "融資"
        },
        "p24": "Przelewy24",
        "p24_desc": "您將前往 Przelewy24 以授權同意結算。 請確保允許彈出視窗。 這將成為您資料中的付款方式。",
        "p24_upgrade_message": "Przelewy24 不能用於升級。 請按一下「編輯」連結以變更您的付款方式。",
        "p24_upgrade_payment_due": "您的付款到期。",
        "p24_upgrade_future_payments": "Zoom 會傳送電子郵件通知提醒您將來的付款。",
        "p24_upgrade_complete_payment": "已更新您的訂閱。請點擊以下連結完成付款。",
        "p24_upgrade_pay_now": "立刻支付",
        "view_payment_history": "檢視付款歷史記錄",
        "action_needed_to_complete_payment": "完成付款所需的操作",
        "issue_completing_payment_visit_payment_history": "發生問題，無法完成付款。您的訂單確認後，請前往您的付款歷史記錄頁面完成付款。",
        "banktransfer": "銀行轉帳 +",
        "sepa": "SEPA",
        "wise_plus_banktransfer": "Wise + 銀行轉帳",
        "trustly": "Trustly +",
        "wise_plus_trustly": "Wise + Trustly",
        "interac": "Interac +",
        "wise_plus_interac": "Wise + Interac",
        "payid": "PayID +",
        "wise_plus_payid": "Wise + PayID",
        "fpx": "FPX +",
        "wise_plus_fpx": "Wise + FPX",
        "poli": "POLI +",
        "wise_plus_poli": "Wise + POLI",
        "paynow": "PayNow +",
        "wise_plus_paynow": "Wise + PayNow",
        "bacs": "BACS +",
        "wise_plus_bacs": "Wise + BACS",
        "fps": "FPS +",
        "wise_plus_fps": "Wise + FPS",
        "openbanking": "Open Banking +",
        "wise_plus_openbanking": "Wise + Open Banking",
        "pix": "PIX +",
        "wise_plus_pix": "Wise + PIX",
        "boleto": "Boleto +",
        "wise_plus_boleto": "Wise + Boleto",
        "dana": "Dana +",
        "wise_plus_dana": "Wise + Dana",
        "ovo": "ovo +",
        "wise_plus_ovo": "Wise + ovo",
        "wise": "Wise",
        "wise_upgrade_message": "Wise cannot be used for upgrades. Please click on the \"Edit\" link to change your Payment method.",
        "wise_business_account_message": "不支援 Wise 商業版帳戶。登入 Wise 後請選擇個人帳戶。",
        "wise_desc": "您將前往 WISE 以授權同意結算。 請確保允許彈出視窗。 這將成為您資料中的付款方式。",
        "pay_with": "支付方式",
        "bill_same_as_contact": "帳單地址同聯絡人地址",
        "waiting_auth_pay_method_title": "授權您的付款方式",
        "waiting_auth_pay_method_desc": "請勿關閉此頁面或點擊返回鈕。 前往彈出視窗以完成授權。",
        "waiting_updating_pay_method_title": "更新付款方式",
        "waiting_updating_pay_method_desc": "請勿關閉此頁面。",
        "waiting_check_title": "請稍候，您的訂單正在處理中...",
        "waiting_check_desc": "在回到上一頁或關閉瀏覽器之前，請稍候以完成確認。",
        "update_pay_method_tips": "請更新或取消您對付款方式的變更",
        "ach": {
          "name": "ACH",
          "verify_failed": "您的付款方式驗證失敗。 請導覽至<a href=\"/billing/payment\">帳單資訊</a>以更新您的付款方式。",
          "verify_pending_error": "由於您的付款方式正在等待驗證，因此您無法完成此付款。 請前往<a href=\"/billing/payment\">帳單資訊</a>並完成驗證，然後重新嘗試。"
        },
        "cash": "Cash",
        "check": "Check",
        "bank_transfer": "Bank Transfer",
        "wire_transfer": "Wire Transfer",
        "others": "其他",
        "pay_with_international_card": "使用可用於國際購買的信用卡或簽帳卡支付。 向您的銀行確認可用性以及使用信用卡的任何費用",
        "apm_payment_error": "請嘗試其他付款方式。",
        "apm_exceed_limitation_error": "您已超出輸入付款方式的嘗試次數上限，請稍後重試或<a target=\"_blank\" href=\"https://support.zoom.us/hc/en-us/articles/201362003\">聯絡支援人員</a>",
        "apm_flow_lost_message": "我們似乎無法順利進行。 請再試一次，使用 {0} 完成付款。",
        "upi": "Unified Payments Interface",
        "upi_one_time_payment": "針對所有週期性方案，當您每個計費期間的付款到期時，我們會通知您。您每次都需要透過 <a href=\"/paynow\" target=\"_blank\">zoom.us/paynow</a> 進行手動付款。",
        "recurring_apm_payment_warning": {
          "ideal": "透過此方式進行未來週期性付款，最多可能需要 5 個工作天處理。這段期間，您的訂閱依然有效，但您將無法編輯帳戶或進行購買。",
          "customer_balance": "想維持訂閱效力，您需要在 5 個工作天內透過 Furikomi 完成付款。在那之前，您將無法編輯帳戶或進行購買。",
          "p24": "透過此方式進行未來週期性付款，必須在付款記錄頁面使用手動付款。每次續訂日期後，您將無法編輯您的帳戶或進行購買，直到完成付款為止。",
          "us_bank_account": "透過此方式進行付款，最多可能需要 5 個工作天處理。這段期間，您的訂閱依然有效，但您將無法編輯帳戶或進行購買。"
        },
        "continue_down_payment": "Continue down the page to finalize your payment.",
        "recapcha": "Zoom\u53D7\u5230reCAPTCHA\u4FDD\u8B77\uFF0C\u4E26\u4E14\u9069\u7528Google<a href=\"https://policies.google.com/privacy\" target=\"_blank\">\u300A\u96B1\u79C1\u6B0A\u653F\u7B56\u300B</a>\u53CA<a href=\"https://policies.google.com/terms\"  target=\"_blank\">\u300A\u670D\u52D9\u689D\u6B3E\u300B</a>\u3002"
      },
      "addr": {
        "enter_tip": {
          "first_name": "輸入您的名字",
          "last_name": "輸入您的姓氏",
          "email": "輸入您的電子郵件地址",
          "address": "輸入您的地址",
          "city": "輸入您的城市",
          "phone": "輸入您的電話號碼",
          "zip_postal": "輸入您的郵遞區號",
          "company_organization_legal": "輸入您的法定公司名稱",
          "org_name": "輸入您的組織名稱",
          "password": "輸入您的密碼"
        },
        "select_tip": {
          "age": "選取您的年齡",
          "business_size": "選取您的公司規模",
          "account_type": "選取您的帳戶類型",
          "biz_org_type": "選取您的業務/組織類型",
          "state": "選取您的州/省",
          "country_region": "選取您的國家/地區",
          "hq": "選取您的公司總部國家/地區",
          "org_size": "選取您的組織規模",
          "use_case": "選取您的開發使用案例"
        },
        "state": {
          "AU": {
            "act": "\u6FB3\u6D32\u9996\u90FD\u9818\u5730",
            "nsw": "\u65B0\u5357\u5A01\u723E\u65AF\u5DDE",
            "nt": "\u5317\u9818\u5730",
            "ql": "\u6606\u58EB\u862D\u7701",
            "sa": "\u5357\u6FB3\u5927\u5229\u4E9E\u5DDE",
            "ta": "\u5854\u65AF\u99AC\u5C3C\u4E9E\u5DDE",
            "va": "\u7DAD\u591A\u5229\u4E9E",
            "wa": "\u897F\u6FB3\u5927\u5229\u4E9E\u5DDE"
          },
          "AE": {
            "ad": "\u963F\u5E03\u624E\u6BD4",
            "an": "\u963F\u6CBB\u66FC",
            "di": "\u675C\u62DC",
            "fh": "\u5BCC\u5409\u62C9",
            "rak": "Ras Al Khaimah",
            "sh": "\u6C99\u52A0",
            "eouaq": "Emirate of Umm Al Quwain"
          }
        },
        "account_type": "帳戶類型",
        "biz_account": "企業帳戶",
        "personal_account": "個人帳戶",
        "country_not_match": "Unfortunately, your country or region is not eligible for this purchase. If you need assistance, please <a href=\"/contactsales\" target=\"_blank\">contact sales</a>",
        "update_address_tips": "請更新或取消對地址的變更",
        "street_info": "街道地址資訊將做為「購買人」地址，以確定可能適用的任何稅款與費用。",
        "update_btn": "更新地址資訊",
        "continue_btn": "繼續付款",
        "line_2": "地址行 2",
        "biz_info": "這是公司地址",
        "hq": "公司總部國家/地區",
        "business_name": "公司名稱",
        "doing_biz_as": "業務內容",
        "doing_biz_as_name": "\u4EE5\u516C\u53F8\u540D\u7A31\u8655\u7406\u696D\u52D9",
        "doing_biz_as_name_tips": "\u5982\u516C\u53F8\u5728\u71DF\u904B\u696D\u52D9\u6642\u4F7F\u7528\u7684\u540D\u7A31\u8207\u516C\u53F8\u64C1\u6709\u8005\u7684\u540D\u7A31\u6216\u6CD5\u5B9A\u540D\u7A31\u4E0D\u540C\uFF0C\u53EF\u9069\u7528\u6B64\u529F\u80FD\u3002",
        "business_size": "公司規模",
        "org_name": "組織名稱",
        "org_size": "組織規模",
        "for_edu": {
          "tip": "此帳戶適用於有 18 歲以下兒童的學校或其他組織",
          "select_apply": "該組織為哪個年齡層的人提供服務？ (請選取所有適用的選項)*",
          "under_13": "13 歲以下",
          "required_tip": "請至少選擇 1 個年齡層",
          "range_n_m": "{0} 至 {1} 歲"
        }
      },
      "usecase": {
        "gaming": "Gaming",
        "retail": "Retail",
        "social": "Social",
        "wellness": "Wellness",
        "e_learning": "E-Learning",
        "telehealth": "Telehealth",
        "fintech": "FinTech",
        "legal": "Legal",
        "hr_staffing": "HR/Staffing",
        "fitness": "Fitness",
        "events": "Events",
        "other": "Others"
      },
      "tax_exemption": {
        "ttr": {
          "tax_status_label": "稅務狀態：{0}",
          "link": "驗證免稅狀態",
          "link_desc": "請確保允許彈出視窗，以便將您引導至 ECMS 並驗證您的免稅狀態。",
          "in_progress_title": "進行免稅驗證中",
          "in_progress_desc": "請在我們的合作夥伴網頁上完成您的免稅驗證。 當您完成稅務狀態驗證後，您將返回此頁面以完成訂單。<br/><br/>請勿變更或關閉此頁面，直到驗證完成。 如果您不再需要進行免稅，您可以關閉並繼續下單。",
          "in_progress_close_button": "關閉",
          "quit_progress_title": "您確定嗎？",
          "quit_progress_desc": "您確定要放棄免稅驗證並以納稅資格繼續嗎？",
          "quit_progress_confirm": "是，放棄",
          "quit_progress_cancel": "否，繼續",
          "status_exempt": "免稅",
          "status_pending": "待公布",
          "status_retrieving": "擷取中…",
          "status_nonexempt": "非免稅",
          "status_pending_desc": "您的免稅狀態目前尚在審核。 下單後將向您收取稅費，若審核通過，我們將向帳戶貸記任何收取的稅金。",
          "status_retrieving_desc": "我們正在擷取您的免稅狀態，請稍候。",
          "status_incomplete": "驗證未完成，如果您希望申請免稅請再按一下",
          "verify_now_title": "有免稅資格嗎？",
          "verify_now_btn": "立即驗證",
          "verify_checkout_notice": "作為選項，此步驟可以在結帳後完成。",
          "status_title": "免稅狀態",
          "status_rejected_desc": "提交的文件已被確定不符合您的司法管轄區要求。",
          "status_approved_text": "已核准",
          "status_pending_text": "待公布",
          "status_rejected_text": "未通過",
          "abandon_new_tax_dialog": {
            "title": "要放棄免稅驗證嗎？",
            "content": "若放棄驗證，您可能需要支付適用的稅金/費用。購買後，您仍可以在「帳單管理」區段提交免稅文件供 Zoom 審查和核准。驗證有效後，將會退還任何已收取的稅款。",
            "cancel_btn": "返回",
            "confirm_btn": "放棄驗證"
          },
          "ios_lower_version_dialog": {
            "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
            "step": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
          }
        }
      },
      "success": {
        "download_app": "Download Zoom for {0}",
        "launch_meeting": "Launch Meeting",
        "ppm": {
          "extension_purchased": "已購買會議延長時段",
          "extension_desc": "此延長時段效期至會議結束為止。 如果本次會議已經結束，我們會儲存您的延長時段供日後使用。",
          "download_desc": "為獲得最佳體驗和最新功能，請於我們的 <a href=\"{downloadUrl}\" target=\"_blank\">Download Center</a> 下載用戶端版本 {version} 或更高版本"
        },
        "title": "感謝您選擇 Zoom",
        "btn": "檢視我的帳戶",
        "subtitle": "您將在 24 小時內收到確認電子郵件",
        "start_time_new": "\u60A8\u7684\u8A02\u95B1\u5DF2\u65BC{0}\u555F\u7528\uFF0C\u4E14\u5DF2\u65BC{1}{2}\u958B\u59CB\u8A08\u8CBB\u3002",
        "auto_renew_time": "\u60A8\u7684\u8A02\u95B1\u5C07\u5728 {0}\u81EA\u52D5\u7E8C\u8A02\u3002",
        "receive_email_with_inr_invoice_processing": "\u5728\u60A8\u63D0\u4F9B\u96FB\u5B50\u7C3D\u540D\u5F8C\uFF0C\u60A8\u5C07\u572824\u5C0F\u6642\u5167\u6536\u5230\u4E00\u5C01\u78BA\u8A8D\u8A72\u8B8A\u66F4\u7684\u96FB\u5B50\u90F5\u4EF6\u3002",
        "download_the_zoom_app": "\u4E0B\u8F09Zoom App",
        "download_mac_brief": "MAC",
        "download_mac": "<span>\u642D\u8F09</span><br />Apple Silicon\u6676\u7247\u7684Mac\u8A2D\u5099",
        "download_windows": "Windows\u96FB\u8166",
        "download_windows_64": "<span>Windows</span><br /> 64\u4F4D\u5143",
        "download_windows_arm": "<span>Windows</span><br /> ARM",
        "book_specialist_button": "\u9810\u7D04\u5C08\u54E1",
        "get_started": "開始使用",
        "view_doc": "查看開發人員文件",
        "need_help_getting_started": "需要協助開始使用嗎？",
        "start_your_meeting_now": "\u7ACB\u5373\u53EC\u958B\u60A8\u7684\u6703\u8B70",
        "go_to_user_management": "\u79FB\u81F3\u4F7F\u7528\u8005\u7BA1\u7406",
        "review_your_subscription": "\u5BE9\u6838\u60A8\u7684\u8A02\u95B1",
        "view_phia_agreement_canada": "\u82E5\u8981\u67E5\u770B\u60A8\u7684\u300A\u53D7\u4FDD\u8B77\u5065\u5EB7\u8CC7\u8A0A\u9644\u4EF6\u300B\u526F\u672C\uFF0C\u8ACB\u9020\u8A2A\u60A8\u7684<a href=\"/billing\">\u8A08\u8CBB\u5165\u53E3\u7DB2\u7AD9</a>\u3002",
        "view_hipaa_agreement_us": "\u82E5\u8981\u67E5\u770B\u60A8\u7684\u300C\u5546\u696D\u5925\u4F34\u5354\u5B9A\u300D\u526F\u672C\uFF0C\u8ACB\u9020\u8A2A\u60A8\u7684<a href=\"/billing\">\u8A08\u8CBB\u5165\u53E3\u7DB2\u7AD9</a>\u3002",
        "success_unassigned_licenses": "\u70BA\u80FD\u6709\u6548\u5229\u7528\u60A8\u7684\u65B0\u65B9\u6848\u548C/\u6216\u9644\u52A0\u5143\u4EF6\uFF0C\u60A8\u5C07\u9700\u6307\u6D3E\u529F\u80FD\u7D66\u4F7F\u7528\u8005\u3002",
        "coppa": {
          "tip": "\u82E5\u7D93\u8A8D\u5B9A\u662F\u5411\u672A\u6EFF13\u6B72\u4E4B\u672A\u6210\u5E74\u4EBA\u58EB\u63D0\u4F9B\u6559\u80B2\u670D\u52D9\u7684\u6A5F\u69CB\uFF0C\u60A8\u5C07\u6703\u88AB\u8981\u6C42\u63D0\u4F9B\u6240\u5C6C\u7D44\u7E54\u8CC7\u8A0A\u53CA\u8868\u793A\u540C\u610F\uFF0C\u6216\u662F\u63D0\u4F9B\u6709\u6B0A\u540C\u610F\u6559\u80B2\u8CC7\u6599\u6536\u96C6\u6163\u4F8B\u4E4B\u500B\u4EBA\u7684\u806F\u7D61\u8CC7\u8A0A\u3002\u5B8C\u6210\u6B64\u7A0B\u5E8F\u5F8C\uFF0C\u60A8\u4FBF\u53EF\u958B\u59CB\u4F7F\u7528Zoom\u670D\u52D9\u3002",
          "coppa_desc": "身為學校或其他向兒童提供教育服務的組織，您必須提供額外資訊才能繼續使用 Zoom 服務。",
          "click_to_proceed": "\u6309\u4E00\u4E0B\u4EE5\u7E7C\u7E8C",
          "data_collection_practice": "Zoom\u7684\u6559\u80B2\u8CC7\u6599\u6536\u96C6\u6163\u4F8B",
          "your_org_info": "\u8CB4\u7D44\u7E54\u8CC7\u8A0A",
          "org_website": "\u7D44\u7E54\u9996\u9801\u7DB2\u7AD9\u4F4D\u5740\uFF08\u9078\u7528\uFF09",
          "your_role_in_org": "\u60A8\u5728\u7D44\u7E54\u4E2D\u7684\u89D2\u8272",
          "superintendent": "\u6559\u80B2\u7E3D\u76E3/\u6821\u9577/\u884C\u653F\u4EBA\u54E1",
          "teacher": "\u6559\u5E2B",
          "other": "\u5176\u4ED6",
          "name_of_superintendent": "\u5C07\u540C\u610F\u7D44\u7E54\u4E4B\u6559\u80B2\u8CC7\u6599\u6536\u96C6\u6163\u4F8B\u7684\u6559\u80B2\u7E3D\u76E3/\u6821\u9577/\u884C\u653F\u4EBA\u54E1/\u6559\u5E2B\u7684\u59D3\u540D",
          "email_of_above": "\u4EE5\u4E0A\u6240\u5217\u4E4B\u500B\u4EBA\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740"
        },
        "setup_zoom_account": "設定 Zoom 帳戶",
        "setup_zoom_one_pro": "設定 Zoom One 專業版",
        "setup_zoom_one_biz": "設定 Zoom One 商業版",
        "setup_zoom_one_biz_plus": "設定 Zoom Workplace 商業加強版",
        "setup_zoom_one_pro_plus": "設定 Zoom Workplace 專業加強版",
        "what_is_next": "下一步是什麼？",
        "update_success": "您的帳戶已更新",
        "review_plan": "檢視您的方案",
        "email_confirm": "您將在 24 小時內收到確認電子郵件。",
        "print_invoice": "列印發票",
        "update_success_plan": "您的方案已更新",
        "downgrade_txt": "您的變更將於您目前的計費期間結束時生效。",
        "downgrade_unassign_licenses": "請在 {1} 之前在「使用者管理」中取消指派 {0} 使用者，否則將不會處理降級。",
        "downgrade_unassign_workspaces": "請在 {1} 之前在工作區管理中取消指派 {0} 空間，否則無法處理降級。",
        "downgrade_unassign_licenses_zs2ze": "請在 {2} 之前取消指派 {1} 位使用者中的 {0}，否則將不會處理方案變更。",
        "unassign_users": "取消指派使用者",
        "unassign_licenses": "未指派的授權",
        "seat_management": "座位管理",
        "downgrade_seat_licenses_hub": "進行 {1} 之前，請務必於座位管理內移除 {0} 額外的主持人",
        "downgrade_seat_licenses_co": "進行 {1} 之前，請務必於座位管理內移除 {0} 額外的共同編輯者",
        "downgrade_seat_co_process": "成功移除額外的共同編輯者後，才能進行降級。",
        "downgrade_seat_hub_process": "成功移除額外的主持人後，才能進行降級。",
        "downgrade_title": "我們正在處理您的請求。",
        "sdk_para_1": "Starting on {0}, your subscription is active, and you have been charged {1}. It will automatically renew on {2}.",
        "sdk_para_2": "Be sure to check your email for a confirmation that provides you with all the resources you need to get started.",
        "sdk_btn": "Start Building Your App",
        "sdk_title": "Thanks for your order!",
        "subscription_activated": "您的訂閱已啟動。",
        "subscription_upgraded": "您的訂閱已升級。",
        "process_payment_once_verified": "我們將在驗證後處理您的付款，並且在收到款項後透過 {0} 通知您。",
        "basic_plus_client_verison_required": "需要 5.15.5 或更高版本的用戶端。 請造訪我們的<a href='https://zoom.us/download#client_4meeting' target='_blank'>下載中心</a>進行更新。",
        "confirmation": {
          "view_my_plan": "檢視我的計畫",
          "thank_you_for_choosing_zoom": "感謝您選擇 Zoom！",
          "thank_you_for_choosing_zoom_with_user_name": "感謝您選擇Zoom，{0}！",
          "receive_a_confirmation_email": "不久後，您的 {0} 會收到一封包含訂單詳細資訊的確認電子郵件。",
          "experience_with_zoom": "您今天使用 Zoom 的體驗如何？",
          "show_full_order_details": "顯示訂單摘要",
          "show_less": "顯示較少",
          "download_zoom": "下載 Zoom",
          "continue_shopping": "透過附加元件充分利用您的計畫",
          "tax_title": "稅",
          "tax_desc": "依據您提供的帳單資訊，您的購買可能需要繳納地方稅。",
          "set_up_desc": "下一步是什麼？設定您的計畫讓組織與團隊成員順利上工。",
          "set_up_zp_desc": "下一步是什麼？設定您的 Zoom Phone，將其啟用並獲得主要功能。",
          "user_assign_desc": "下一步是什麼？將新的授權指派至您帳戶內的使用者。您需要先新增使用者，才能將授權指派給新的使用者。",
          "user_cta": "將授權指派給使用者",
          "workspace_assign_desc": "下一步是什麼？將新的空間指派給您帳戶內的使用者。您需要先新增使用者，才能將空間指派給新的使用者。",
          "workspace_cta": "將空間指派給使用者"
        },
        "complete_payment_once_received_notice": "請完成付款讓訂閱保持有效。我們收到您的付款後，會透過 {0} 通知您。Zoom 也會傳送提醒電子郵件提醒您將來的付款。"
      },
      "marketing": {
        "currency": {
          "aud": "\u6FB3\u5143 $",
          "cad": "\u52A0\u62FF\u5927\u5143\uFF08$\uFF09",
          "cny": "\u4EBA\u6C11\u5E63\uFFE5",
          "eur": "\u6B50\u5143 \u20AC",
          "gbp": "\u82F1\u938A \uFFE1",
          "inr": "\u5370\u5EA6\u76E7\u6BD4 \u20B9",
          "jpy": "\u65E5\u5713\uFFE5",
          "usd": "\u7F8E\u5143 $",
          "php": "\u83F2\u5F8B\u8CD3\u62AB\u7D22\u20B1",
          "krw": "\u97D3\u5143 \u20A9",
          "mxn": "\u58A8\u897F\u54E5\u6BD4\u7D22 $",
          "brl": "\u5DF4\u897F\u96F7\u4E9E\u723E $",
          "zar": "\u5357\u975E\u862D\u7279 R",
          "ils": "\u4EE5\u8272\u5217\u932B\u514B\u723E \u20AA",
          "chf": "\u745E\u58EB\u6CD5\u90CE",
          "sgd": "\u65B0\u52A0\u5761\u5143 $",
          "try": "\u571F\u8033\u5176\u91CC\u62C9 \u20BA",
          "pen": "\u79D8\u9B6F\u7D22\u723E S",
          "sek": "\u745E\u5178\u514B\u6717 kr",
          "hkd": "\u6E2F\u5143 $",
          "clp": "\u667A\u5229\u6BD4\u7D22 $",
          "cop": "\u54E5\u502B\u6BD4\u4E9E\u6BD4\u7D22 $",
          "ars": "\u963F\u6839\u5EF7\u6BD4\u7D22 $",
          "nzd": "\u7D10\u897F\u862D\u5143 $",
          "pln": "\u6CE2\u862D\u8332\u7F85\u63D0 z\u0142",
          "dkk": "\u4E39\u9EA5\u514B\u6717 Kr",
          "nkk": "\u632A\u5A01\u514B\u6717 Kr",
          "vnd": "\u8D8A\u5357\u76FE (\u20AB)",
          "myr": "\u99AC\u4F86\u897F\u4E9E\u6797\u5409\u7279 (RM)",
          "idr": "\u5370\u5C3C\u76E7\u6BD4 (Rp)"
        }
      },
      "terms": {
        "privacy_desc_proceeding": "繼續操作即代表我同意 <a href=\"https://explore.zoom.us/zh-tw/privacy/\" target=\"_blank\">Zoom 的《隱私權聲明》</a>及<a href=\"https://explore.zoom.us/zh-tw/terms/\" target=\"_blank\">《服務條款》</a>。",
        "unchecked_alert_message": "您必須閱讀並同意條款和隱私權政策才能繼續",
        "unchecked_alert_message_eu": "您必須同意此條款才能繼續",
        "eu_14loss": "購買本方案即表示您明確同意在猶豫期結束之前開始履行服務，並確認喪失 14 天猶豫期的權利。",
        "tos_14loss": "\u8CFC\u8CB7\u5E74\u5EA6\u65B9\u6848\u5373\u8868\u793A\u60A8\u540C\u610FZoom\u7684<a target=\"_blank\" href=\"/terms\">\u300A\u670D\u52D9\u689D\u6B3E\u300B</a>\u3001<a target=\"_blank\" href=\"/privacy\">\u300A\u96B1\u79C1\u6B0A\u8072\u660E\u300B</a>\u548C<a target=\"_blank\" href=\"https://explore.zoom.us/en/cookie-policy/\">Cookie\u653F\u7B56</a>\u3002 \u8CFC\u8CB7\u672C\u65B9\u6848\u5373\u8868\u793A\u60A8\u660E\u78BA\u540C\u610F\u5728\u7336\u8C6B\u671F\u7D50\u675F\u4E4B\u524D\u958B\u59CB\u5C65\u884C\u670D\u52D9\uFF0C\u4E26\u78BA\u8A8D\u55AA\u593114\u5929\u7336\u8C6B\u671F\u7684\u6B0A\u5229\u3002",
        "tos_14loss_desc": "\u60A8\u7279\u6B64\u78BA\u8A8D\uFF0C\u5728\u4E00\u500B\u65E5\u66C6\u5E74\u7684\u521D\u59CB\u5408\u7D04\u671F\u9593\u7D50\u675F\u6642\uFF0C\u5018\u82E5\u672A\u53D6\u6D88\u6216\u7E7C\u7E8C\u65B0\u7684\u5408\u7D04\u671F\u9593\uFF0C\u5373\u6388\u6B0AZoom\u7121\u9650\u671F\u7E7C\u7E8C\u60A8\u7684\u670D\u52D9\uFF0C\u4E26\u5728\u4E4B\u5F8C\u6BCF\u6708\u6536\u53D6{0}{1}\u7684\u6708\u8CBB\uFF08\u542B\u589E\u503C\u7A05\uFF09\u3002",
        "privacy_desc": "按一下「{0}」，即代表我同意 <a class=\"opc-terms-link\" href=\"/terms\" target=\"_blank\">Zoom 的服務條款</a>和<a class=\"opc-terms-privacy-link\" href=\"/privacy\" target=\"_blank\">隱私權聲明</a>。",
        "privacy_desc_confirm": "按一下「{0}」，即代表我同意 <a class=\"opc-terms-link\" href=\"/terms\" target=\"_blank\">Zoom 的服務條款</a>和<a class=\"opc-terms-privacy-link\" href=\"/privacy\" target=\"_blank\">隱私權聲明</a>。",
        "privacy_desc_inr": "繼續操作即代表我同意 <a class=\"opc-terms-privacy-link\" href=\"/privacy\" target=\"_blank\">Zoom 的隱私權聲明</a>和<a class=\"opc-terms-link\" href=\"/terms\" target=\"_blank\">服務條款</a>",
        "recurring_charge_desc": "週期性計畫會利用您今日使用的付款方式自動續約，而您可以從 <a href=\"/billing\" target=\"_blank\">zoom.us/billing</a> 存取及更新信用卡資訊。 每個續訂期間都會向您收取費用，直到您取消此計畫為止。 您可以瀏覽 <a href=\"/billing\" target=\"_blank\">zoom.us/billing</a> 並按一下「取消訂閱」來取消計畫。 您可能需要於下一次自動續約日之前取消，以確保取消生效。",
        "recurring_charge_desc_append": "如果在發票到期日之前未收到付款，服務可能會暫停而不另行通知。",
        "recurring_charge_desc_inr": "定期計畫將如上所述自動續約。每個續約期都會向您收取費用，直到您取消為止。您可以瀏覽 <a href=\"/billing\" target=\"_blank\">zoom.us/billing</a> 並選擇「取消訂閱」來取消。您可以在自動續約生效的前一天之前要求取消訂閱。",
        "recurring_charge_desc_inr_upi_one_time_payment": "每個續訂期間都會向您收取費用，直到您取消此方案為止。您可以瀏覽 <a href=\"/billing\" target=\"_blank\">zoom.us/billing</a>，並選取「取消訂閱」進行取消。您可能需要於下一次自動續約日之前取消，以確保取消生效。",
        "india_emandate_registering_mandate_with_card": "為了向您的發卡機構註冊 eMandate，您在此授權 {companyName} 從您的卡片中扣除您所購買服務的訂閱費用，如以下 eMandate 詳細資訊所示：",
        "india_emandate_registering_mandate_with_bank": "為了向您的銀行註冊 eMandate，您在此授權 {companyName} 從您的銀行帳戶中扣除您所購買服務的訂閱費用，如以下 eMandate 詳細資訊所示：",
        "india_emandate_start_date": "eMandate 開始日期：{0}",
        "india_emandate_end_date": "eMandate 結束日期：{0}",
        "india_emandate_amount_up_to": "金額：最高 {0} (Zoom 只會依據應付總金額收取費用)",
        "india_emandate_confirm_declaration_carefully_read_card": "這是為了確認您已仔細閱讀和理解該聲明。您瞭解此 eMandate 的註冊需要依據發卡機構的正當程序進行額外的身分驗證因素，並且您可以隨時撤回、檢視或修改此 eMandate。",
        "india_emandate_confirm_declaration_carefully_read_bank": "這是為了確認您已仔細閱讀和理解該聲明。您瞭解此 eMandate 的註冊需要依據銀行的正當程序進行額外的身分驗證因素，並且您可以隨時撤回、檢視或修改此 eMandate。",
        "india_emandate_how_recurring_charges_processed": "經常性費用如何處理？",
        "india_emandate_agreement": "eMandate 協議",
        "india_emandate_charge_amount": "收費金額",
        "india_emandate_action": "動作",
        "india_emandate_charge_amount_up_to": "最高 15,000 印度盧比",
        "india_emandate_process_payments_through_autopay": "我們將依據以下 eMandate 協議，透過 AutoPay 處理您在每個計費期間內的付款。",
        "india_emandate_charge_amount_more_than": "超過 15,000 印度盧比",
        "india_emandate_manual_payment_through_pay_now": "當您每個計費期間的付款到期時，我們會通知您。您每次都需要透過 <a href=\"/paynow\" target=\"_blank\">zoom.us/paynow</a> 進行手動付款。",
        "consent_tokenization_of_card": "您同意我們授權的第三方權杖服務供應商對您的卡片資料標記化，以讓我們儲存您偏好的付款方式並將其用於經常性費用。",
        "consent_tokenization_of_bank": "您同意我們授權的第三方權杖服務供應商對您的銀行帳戶資料標記化，以讓我們儲存您偏好的付款方式並將其用於經常性費用。",
        "rosca_desc": "週期性計畫會利用您檔案中的今日使用的付款方式自動續約，而您可以從 <a href=\"/billing\" target=\"_blank\">zoom.us/billing</a> 存取及更新。 每個續訂期間都會向您收取費用，直到您取消此計畫為止。",
        "zoom_events": "我已閱讀並同意遵守 <a href=\"https://explore.zoom.us/docs/en-us/zoom_events_host_tou.html\" target=\"_blank\">Zoom Events 主持人使用條款</a>和<a href=\"https://explore.zoom.us/docs/en-us/zoom_events_privacy.html\" target=\"_blank\">Zoom Events 隱私權聲明</a>。",
        "zoom_events_ppa": "您的依觀眾付費方案決定在購買後 12 個月內您所有活動的觀眾總人數。 如有任何觀眾超額都將依據額外的觀眾人數向您開立發票。 訂閱期間結束時到期的任何未使用的觀眾額度不可退款。",
        "video_sdk": "本人已閱讀並同意",
        "video_sdk_term_1": "視訊SDK服務條款",
        "video_sdk_term_2": "其他視訊SDK條款",
        "and": "和",
        "pay_you_go": {
          "p1": "SDK 服務的使用將根據可歸因為客戶和/或客戶應用程式的使用者發起的會議會程 (「會議會程分鐘數」)，每月使用的總會議會程分鐘數來測量。 例如，如果有 5 個終端使用者透過客戶的應用程式參加 10 分鐘的會議會程，則使用的會議會程分鐘數共計 50 分鐘。 不滿一分鐘以一分鐘計算。",
          "p2": "即付即用 (「PAYG」) 是 SDK 服務的單月制訂閱。 每個日曆月中，PAYG 內含免費 10,000 會議會程分鐘數。",
          "p3": "當月未使用的會議會程分鐘數，不會累積至次月。 如果客戶在該月份用完所有免費的會議會程分鐘數 (如適用)，則將按照訂單檢視頁面上的說明收取費用。 超額費用及每次使用會議會程分鐘數的費用，將會按月收費。",
          "p4": "費用 - 如有任何 SDK 服務的費用，將說明於訂單檢視頁面上。",
          "p5": "SDK 服務的發票起算日，從客戶可以使用 SDK 服務的第一天開始，之後於訂閱期間內按月計費。",
          "p6": "州稅和/或地方稅務可能適用於 Zoom 服務。"
        }
      },
      "signup": {
        "agreements": {
          "collection": "我同意 <a id=\"opc-signup-policy-dc-a\" target=\"_blank\" href=\"https://explore.zoom.us/docs/ko-ko/data-collection-notice.html\">Zoom 的資料收集與使用同意</a>。",
          "reviewAgreement": "我願意接收 Zoom 的產品、服務和產業趨勢相關行銷通訊。 我了解我可以隨時取消訂閱。",
          "terms": "我同意 <a id=\"opc-signup-policy-a\" target=\"_blank\" href=\"https://zoom.us/privacy\">Zoom 的《隱私權聲明》</a>及<a id=\"opc-signup-terms-a\" target=\"_blank\" href=\"https://zoom.us/terms\">《服務條款》</a>。",
          "title": "請同意必要項目以繼續。 若您不同意，您將無法於 Zoom 註冊。 <span class=\"opc-signup-terms__item__important\">*</span> 標記為必要項目。",
          "zoom_phone_tos_new": "Zoom Voice Communications 是美國 Zoom Phone 的供應商。Zoom 是美國境外 Zoom Phone 的供應商。更多詳細資訊，請參閱<a href=\"https://explore.zoom.us/en/services-description/\" target=\"_blank\"> Zoom 服務說明</a> (Zoom Phone)。"
        }
      },
      "soldtowarn": "\u60A8\u7684\u8CB7\u65B9\u570B\u5BB6/\u5730\u5340\u4E0D\u9069\u7528\u65BC\u6B64\u8CA8\u5E63",
      "scheduler": {
        "short_title": "排程器",
        "title": "Zoom Scheduler",
        "desc": "搭配 Google 日曆和 Microsoft 365 一起使用，輕鬆分享和預約會議時段",
        "more_than_99_users": "如果您需要超過 {0} 名使用者，<a href=\"{1}\" target=\"_blank\">請聯絡銷售人員</a>",
        "exceed_assigned_licenses": "您目前有 {0} 份已指派的授權。 為了處理降級，必須在 {2} 之前取消指派 {1} 份授權，否則無法處理降級。",
        "feature_tooltip": "Zoom Scheduler 透過向其他人分享您方便的可用時間以供預約，將排程體驗最佳化。 無縫搭配您的 Zoom Meetings、Zoom Mail 和 Calendar 一起使用，還可與 Google 和 Microsoft 365 整合。",
        "feature_details": {
          "item1": "輕鬆分享會議時段，以供會議預約",
          "item2": "搭配 Zoom Meetings、Zoom Mail 和 Calendar、Google 及 Microsoft 365 一起使用"
        },
        "plan_details": {
          "simplify_bookings": "彈性的有空選項加上可自訂的時段，簡化預約流程",
          "host_one_on_one": "主持一對一或小組會議，單一連結方便分享",
          "customize_reminders": "自訂電子郵件/簡訊提醒，避免錯過預約",
          "sync_calendars": "整合 Google、Microsoft 365 和 Zoom，無縫同步行事曆",
          "calender_integration": "<span class=\"{0}\">日曆整合</span> <span class=\"{1}\"> Google、Microsoft 365 等</span>",
          "recurring_availability": "<span class=\"{0}\">週期性可用時間</span> <span class=\"{1}\">分享可預約的時段</span>",
          "scalable_meeting": "<span class=\"{0}\">可擴充的會議</span> <span class=\"{1}\">一名或多名觀眾的專屬會議 (基本版方案每場會議長達 40 分鐘)/span>",
          "customizable_notifications": "<span class=\"{0}\">可自訂的通知</span> <span class=\"{1}\">自動傳送電子郵件或 SMS 提醒和確認</span>"
        },
        "free_trial_descriptions": {
          "duration": "一名使用者可享 {0} 天的 Zoom Scheduler 免費試用期",
          "sharelink": "透過單一連結分享可用時間",
          "customizable": "傳送可自訂的確認和提醒通知。",
          "cancel": "可隨時取消"
        },
        "free_trial_footer": "需要為超過一位使用者提供 Zoom Scheduler 嗎？ <a href=\"{0}\">立即購買</a>",
        "biz_include_tip": "您帳戶內的每個 Zoom Workplace 商業版或商業版 Plus 使用者皆可以存取 Zoom Scheduler。如果您購買更多授權，可以將他們指派至帳戶中的任何基本版使用者。",
        "basic_include_tip": "Scheduler 包含在商業版和商業版 Plus 方案之內。使用基本版方案，您每次的會議時間限時 40 分鐘。",
        "remove_in_biz_message": "Workplace 商業版方案內含 Scheduler，已自您的購物車移除。"
      },
      "planform": {
        "zoom_meeting": {
          "less_than_assigned_number_tips": "您目前有{0}個免費試用使用者，您需要為這些現有使用者購買授權。<br/>或是<a href=\"/account/user\" target=\"_blank\">前往「使用者管理」</a>，至少取消指派{1}個授權。",
          "less_than_assigned_number_tips_no_br": "您目前有{0}個免費試用使用者，您需要為這些現有使用者購買授權。或是<a href=\"/account/user\" target=\"_blank\">「使用者管理」</a>，至少取消指派{1}個授權。",
          "less_than_assigned_number_tips_for_expire": "You currently have {0} user(s) with free trials, you will need to purchase licenses for those existing user(s)."
        },
        "unit": {
          "number": "號碼",
          "user": "\u4f7f\u7528\u8005",
          "license": "授權",
          "room": "Room(s)",
          "host": "Host(s)",
          "port": "\u9023\u63A5\u57E0",
          "account": "Account(s)",
          "membership": "Membership(s)",
          "credits": "額度",
          "space": "空間"
        },
        "singular_unit": {
          "number": "號碼"
        },
        "can_not_select_monthly": "如果您想購買 {0} 月度訂閱，必須先將您的 {1} 方案更新為月度訂閱。  <a href=\"/billing\">返回方案管理</a>",
        "can_not_select_with_special_addon": "如果您想購買 {0} {2}訂閱，必須先將您的 {1} 方案更新為{2}訂閱。  <a href=\"/billing\">返回方案管理</a>",
        "can_not_select_monthly_with_base": "如果您想購買月度訂閱，必須先將您的 {1} 方案更新為月度訂閱。 <a href=\"/billing\">返回方案管理</a>",
        "can_not_select_annual_with_base": "如果您想購買年度訂閱，必須先將您的 {0} 方案更新為年度訂閱。 <a href=\"/billing\">返回方案管理</a>",
        "can_not_select_annual_with_base_without_link": "如果您想購買年度訂閱，必須先將您的 {0} 方案更新為年度訂閱。",
        "can_not_select_monthly_with_annual_addon": "由於您的基礎方案已為 {0} 選取年度計費，因此您無法為 {1} 選取每月計費。",
        "monthly_base_disable_tooltip": "根據 {0} 的訂閱週期，您只能為 Zoom One 選擇按年付款選項。 如果您想按月支付，請將您的附加訂閱轉換為月付方案。",
        "monthly_as_base_disable_tooltip": "Based on your subscription cycle for {0}, you can only select the annual payment option for {1}. Switch your add-on subscriptions to monthly plans if you want to pay monthly.",
        "annual_addon_disable_tooltip": "根據您的 {0} 訂閱週期，您只能為 {1} 選擇按月付款選項。 如果您想按年支付，請將您的 {0} 訂閱轉換為年付方案。",
        "annual_addon_disable_alert": "如果您想購買不同容量或 {0} 年度訂閱，必須先將您的 {1} 方案更新為年度訂閱。 <a href=\"/billing\">返回方案管理</a>",
        "up_to": "最多 {0}",
        "large_meeting": {
          "capacity_intro": "The Large Meeting add-on increases limits of your other licenses:"
        },
        "introduction": {
          "participant": {
            "panelists": "嘉賓",
            "share_screen": "Share Screen",
            "audio": "Audio",
            "video": "Video",
            "panelist_desc": "Speakers and people helping to run your event (moderators, interpreters, etc.)",
            "attendees": "Attendees",
            "attendees_desc": "Joined people",
            "listen_only": "Listen-Only",
            "view_only": "View-Only",
            "remark_1": "Your panelists and participants can join your webinars with <strong>no need</strong> to purchase or download Zoom.",
            "remark_2": "A participant can be promoted to a panelists by the host or co-host of the webinar."
          }
        },
        "title": {
          "webinar": "Zoom Webinars",
          "zoomroom": "Zoom Rooms",
          "zoomphone": "Zoom Phone",
          "zoom_contact_center": "Zoom Contact Center",
          "phone_number": "Phone Number",
          "rc": "Conference Room Connector",
          "large_meeting": "Large Meeting",
          "tollfree": "Audio Conferencing",
          "cmr": "Cloud Recording Storage",
          "zoom_meeting": "Zoom Meetings",
          "zoom_meeting_zoomonenew": "Zoom One",
          "pro": "Pro",
          "biz": "Business",
          "zoom_workplace_for_edu": "Zoom Workplace for Education",
          "zoom_one_education": "Zoom Meetings 教育版",
          "zo_edu_sch_cmp": "Zoom One 教育解決方案學校與校園版",
          "education": "education",
          "biz_inr": "Business India",
          "zoom_united": "Zoom United",
          "bundle": "企業版",
          "video_sdk": "Video SDK",
          "zoom_hardware": "Zoom Hardware",
          "hipaa_compliance": "Business Associate Agreement (US Only)",
          "phia_compliance": "Protected Health Information Annex (Canada Only)",
          "paid_developer": "Premier Developer Support",
          "zoom_events": "Zoom Events",
          "quality_streaming_service": "Quality Streaming Service",
          "zoom_node": "Zoom Node",
          "mio": "Mio Chat Interoperability (US Only)",
          "zoom_iq": "Zoom IQ for Sales",
          "zoom_whiteboard": "Zoom Whiteboard",
          "zoom_whiteboard_plus": "Zoom Whiteboard Plus",
          "zwbbasic": "Zoom Whiteboard",
          "zwbplus": "Zoom Whiteboard Plus",
          "zoom_one": "Zoom One",
          "zoom_one_pro": "Zoom One 專業版",
          "zoom_one_ent": "Zoom One Enterprise",
          "zoom_one_ent_plus": "Zoom One Enterprise Plus",
          "zoom_one_plus": "Zoom One Plus",
          "zoom_one_biz": "Zoom One 商業版",
          "zoom_one_biz_plus": "Zoom One Business Plus",
          "zoom_one_enterprise": "Zoom One Enterprise",
          "zoom_one_ent_essentials": "Zoom One Enterprise Essentials",
          "biz_plus": "Business Plus",
          "translation": "Zoom Translated Captions",
          "video_sdk_translation": "Video SDK transcription and translation",
          "workspace_reservation": "Workspace Reservation",
          "cmk": "Zoom Customer Managed Key",
          "ldk_cmr": "Zoom Video SDK Recording",
          "whiteboard_subtitle": "You can purchase both Whiteboard and Whiteboard Plus license and assign to different users.",
          "zoom_mesh": "Zoom Mesh",
          "zva": "Zoom Virtual Agent",
          "additional_host": "Additional Host",
          "additional_co_editor": "Additional Co-Editor",
          "eventsaascore": "Zoom Sessions",
          "eventsaascore_consumption": "Zoom Sessions Pay Per Attendee",
          "eventsaas_consumption": "Zoom Events Pay Per Attendee",
          "api_csp": "Integration Meeting Plan",
          "video_sdk_crc": "Video SDK Cloud Room Connector",
          "zsu": "Zoom Phone",
          "zoom_revenue_accelerator": "Zoom Revenue Accelerator"
        }
      },
      "error": {
        "field_required": "\u8A72\u6B04\u4F4D\u70BA\u5FC5\u586B\u6B04\u4F4D\u3002",
        "email_invalid_address": "\u7121\u6548\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
        "email_address_incorrect": "請輸入有效的電子郵件地址",
        "edu_email_address_tip": "您的電子郵件地址結尾必須是「.edu」才能購買此產品",
        "confirm_email_address_no_match": "電子郵件地址與確認電子郵件地址不符",
        "invalid_url": "\u7121\u6548\u7684 URL",
        "has_pending_plans_change_tips": "\u60A8\u7121\u6CD5\u5C0D\u6B64\u65B9\u6848\u9032\u884C\u8B8A\u66F4\uFF0C\u56E0\u70BA\u6709\u53EF\u80FD\u6703\u5F71\u97FF\u9019\u4E9B\u8B8A\u66F4\u7684\u64F1\u7F6E\u4E2D\u65B9\u6848\u5B58\u5728\u3002\u8ACB<a href='/contactsales' target='_blank'>\u806F\u7D61\u696D\u52D9\u4EBA\u54E1</a>\u70BA\u60A8\u76EE\u524D\u6216\u64F1\u7F6E\u4E2D\u7684\u65B9\u6848\u9032\u884C\u8B8A\u66F4\u3002",
        "has_time_based_discount_change_tips": "\u60A8\u76EE\u524D\u7684\u65B9\u6848\u5DF2\u4EAB\u6709\u6298\u6263\u81F3{0}\u3002\u82E5\u60A8\u60F3\u8981\u7ACB\u5373\u5347\u7D1A\uFF0C\u5C07\u6703\u55AA\u5931\u76EE\u524D\u65B9\u6848\u6240\u4EAB\u6709\u7684\u6298\u6263\u3002\u60A8\u4E5F\u53EF\u4EE5\u7B49\u5230\u6298\u6263\u904E\u671F\u6642\u518D\u9032\u884C\u5347\u7D1A\u3002",
        "can_not_bought_plan_tips": "您無法對您的帳戶進行此變更。 當您<a target=\"_blank\" href=\"/contactsales\">提交此表單</a>時，我們的團隊可以為您解答任何問題。",
        "downgrade_alert_info": "若要進行降級，請在 {1} 之前取消指派 {0} 使用者。 否則將不會處理降級。",
        "downgrade_alert_info_in_plan_change": "若要變更方案，請在 {1} 之前取消指派 {0}。 否則將不會處理方案變更。",
        "downgrade_alert_info_workspace_reservation_change": "您已指定 {assignedCount} 個空間。若要處理降級，請至少在 {expiredDate} 以前前取消指定 <a href=\"{link}\" target=\"_blank\">Workspace Management</a> 中的 {needAssignQuantity}，否則無法處理降級。",
        "downgrade_alert_info_license": "To proceed with the downgrade, unassign {0} license(s) by {1}. Otherwise, downgrade will not be processed.",
        "downgrade_alert_info_no_date": "若要進行降級，請在下一個結算日期之前取消指派 {0} 使用者。 否則將不會處理降級。",
        "downgrade_alert_info_no_date_license": "To proceed with the downgrade, unassign {0} license(s) by before your next billing date. Otherwise, downgrade will not be processed.",
        "buld_acount_license": "您的帳戶有大量授權，無法線上變更。 若要對您的帳戶進行變更，請<a href='/billing/contactus' target='_blank'>聯絡我們</a>。",
        "downsell_desc_title": "您是否確定要將您的方案降級？",
        "downsell_desc_tips": "您對此方案減少授權的變更將於 {0} 生效，您將會在下一張發票看到此變化。",
        "downsell_desc_tips_common": "您對此方案的變更將於 {0} 生效，您將會在下一張發票看到此變化。",
        "downsell_desc_tips_common_generic": "If you’d like to proceed with the downgrade, changes for each plan will take effect at the end of their current billing term.",
        "one_month_error_tips": "由於這些變更會在下一個計費週期生效，因此您無法變更此方案，而且此一個月方案會在其一個月期限結束後到期。",
        "annual_addon_disable_tooltip": "\u60a8\u7121\u6cd5\u70ba{0}\u9078\u7528\u5e74\u5ea6\u8a08\u8cbb\uff0c\u56e0\u70ba\u60a8\u7684\u57fa\u790e\u65b9\u6848{1}\u63a1\u7528\u4e86\u6708\u5ea6\u8a08\u8cbb\u9031\u671f\u3002\u82e5\u60a8\u60f3\u8981\u70ba\u6b64\u65b9\u6848\u9078\u7528\u5e74\u5ea6\u8a08\u8cbb\uff0c\u8acb\u5c07{1}\u7684\u8a08\u8cbb\u9031\u671f\u8b8a\u66f4\u70ba\u5e74\u5ea6\u3002",
        "downgrade_alert_for_ze_addon": "若要繼續降級，請透過 {2} 於座位管理內取消指派 {0} {1}，否則將無法處理降級。",
        "downgrade_pre_confirm_for_ze_addon": "您需要透過 {2} 於座位管理內移除 {0} 額外的 {1}，否則將無法處理您帳戶內的降級。",
        "existing_plan_msg": "Your account {0} already has {1}. Manage your existing plan or <a href='/billing'>click here</a> to view our other offers.",
        "smb_plan_billing_cycle_change_title": "確定要變更您的訂閱週期嗎？",
        "smb_plan_billing_cycle_change_content": "您目前處於自訂訂閱週期。一旦變更為標準版方案，您將無法恢復到此自訂方案。",
        "smb_plan_billing_cycle_change_yes": "是的，下訂單",
        "smb_plan_billing_cycle_change_no": "不要，返回",
        "upi": {
          "invalid_request": "因付款方式有不明問題，我們無法處理此付款。 請嘗試使用不同付款方式。 如果問題持續發生，請聯絡您的銀行。"
        },
        "cant_add_100": "每次交易最多 99 名使用者。",
        "email_cant_use_confirm": {
          "title": "Email address cannot be used",
          "message": "You’re currently signed in with a non-education email address. To purchase an education plan, please sign out and then sign in with an email from an educational domain. If you need assistance, <a href=\"/contactsales\" target=\"_blank\">contact sales</a> for manual verification.",
          "confirm_text": "Sign out",
          "cancel_text": "View my current plan"
        },
        "form_with_error_fields": "請修正以上所有亮顯欄位以繼續。",
        "zuora_required_cc": "請輸入完整的信用卡號碼。",
        "zuora_invalid_cc": "請輸入正確的信用卡號碼。",
        "zuora_required_cvv": "請輸入正確的 CVV。",
        "zuora_required_expiration_date": "請選取到期日。",
        "zuora_required_card_holder_name": "請輸入持卡人姓名。",
        "zuora_required_state": "請輸入州或省。"
      },
      "rps_no_purchase": "\u5F88\u907A\u61BE\uFF0C\u7531\u65BC\u76E3\u7BA1\u539F\u56E0\uFF0C\u6211\u5011\u7121\u6CD5\u5B8C\u6210\u6B64\u6B21\u8CFC\u8CB7\u3002 \u975E\u5E38\u62B1\u6B49\u9020\u6210\u60A8\u7684\u4E0D\u4FBF\uFF0C\u4F46\u662F\u60A8\u7121\u6CD5\u8CFC\u8CB7 Zoom \u7522\u54C1\u3002 \u5982\u679C\u60A8\u8A8D\u70BA\u6B64\u7D50\u679C\u6709\u8AA4\uFF0C\u60A8\u53EF\u4F7F\u7528\u9019\u4EFD<a href=\"/compliance-appeals?zan={0}\" target=\"_blank\">\u8868\u683C</a>\u63D0\u4EA4\u8981\u6C42\u3002",
      "rps_no_purchase_product": "Unfortunately, due to regulatory reasons, we are not able to complete your request. We apologize for any inconvenience, but you will not be able to make the requested change. If you think this is an error, you can submit a request using this <a href=\"/compliance-appeals?zan={0}\" target=\"_blank\">form</a>.",
      "rps_still_processing": "\u6211\u5011\u4ECD\u5728\u8655\u7406\u60A8\u7684\u4EA4\u6613\u3002 \u60A8\u5C07\u65BC 1-2 \u500B\u5DE5\u4F5C\u5929\u5167\uFF0C\u6536\u5230\u4E00\u5C01\u5305\u542B\u66F4\u591A\u66F4\u65B0\u8CC7\u8A0A\u7684\u96FB\u5B50\u90F5\u4EF6\u3002 \u8ACB\u52FF\u518D\u6B21\u5617\u8A66\u8CFC\u8CB7\uFF0C\u56E0\u53EF\u80FD\u6703\u7522\u751F\u591A\u7B46\u8CBB\u7528\u3002",
      "rps_still_processing_product": "We are still working on processing your request. You will receive an email with more information within 1-2 business days with an update. Please do not attempt this change again, as it may result in errors.",
      "rps_block_new_pending": "\u5F88\u907A\u61BE\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u7B46\u65B0\u7684\u4EA4\u6613\u3002 \u6211\u5011\u4ECD\u5728\u8655\u7406\u60A8\u7684\u7B2C\u4E00\u7B46\u4EA4\u6613\u3002 \u60A8\u5C07\u65BC 1-2 \u500B\u5DE5\u4F5C\u5929\u5167\uFF0C\u6536\u5230\u4E00\u5C01\u5305\u542B\u66F4\u591A\u7B2C\u4E00\u7B46\u4EA4\u6613\u66F4\u65B0\u8CC7\u8A0A\u7684\u96FB\u5B50\u90F5\u4EF6\u3002 \u7B2C\u4E00\u7B46\u4EA4\u6613\u8655\u7406\u5B8C\u6210\u4EE5\u524D\uFF0C\u60A8\u7121\u6CD5\u9032\u884C\u65B0\u7684\u4EA4\u6613\u3002",
      "return_home": "返回首頁",
      "rps_no_update": "\u60A8\u76EE\u524D\u7121\u6CD5\u66F4\u65B0\u6B64\u8CC7\u8A0A\u3002 \u8ACB\u65BC 1-2 \u500B\u5DE5\u4F5C\u5929\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
      "pro2biz": {
        "title": "從專業版到商業版"
      },
      "cycle": {
        "monthly": "\u6BCF\u6708",
        "annual": "\u5E74\u4ED8",
        "one_month": "一個月",
        "quarterly": "季付",
        "two_years": "兩年",
        "three_years": "三年"
      },
      "partner": {
        "landing": {
          "dropbox": {
            "essentials": "Dropbox Essentials",
            "professional": "Dropbox Professional",
            "plus": "Dropbox Plus",
            "title": "享受 {1} {0}% 折扣優惠，同時提高生產力",
            "desc_01": "Dropbox 新客戶購買 Zoom Workplace 年度方案即可享有 {1} {0}% 的折扣。",
            "desc_02": "{0} 包含一名使用者 3 TB 儲存空間、無限制簽章請求、最多 100 GB 檔案分享，以及進階分享分析工具。",
            "get_offer": "獲得優惠",
            "terms": "Zoom 可能會與 Dropbox 分享我的電子郵件，以驗證我是否有資格參加此促銷活動",
            "feature_title": "大幅提升效率並最佳化您的聯繫交流",
            "feature_desc01": "使用 Dropbox Sign 傳送無限制的簽章請求",
            "feature_desc02": "使用 Zoom AI Companion 重新定義團隊合作與協作體驗",
            "feature_desc03": "透過 Zoom Clips 錄製短影片，並在 Dropbox 上進行標記、評論和定稿。",
            "error": {
              "title": "您目前不適用此優惠方案",
              "upgrade_now": "立即升級",
              "defaultCase": {
                "message": "感謝您對 Dropbox 優惠有興趣。此優惠不適用於使用年度方案的 Zoom 客戶或現有 Dropbox 客戶。您可能會符合其他 Zoom 合作夥伴提供的優惠。請查看我們的客戶優惠頁面以取得詳細資訊。",
                "action_btn": "參閱客戶優惠方案"
              },
              "freeExist": {
                "message": "您仍可升級至 Zoom Workplace 專業版。Zoom Workplace 協作平台增添 AI Companion 功能，為您帶來全新的通訊體驗。探索一系列先進的功能，包括無限制會議、生產力應用程式等。"
              },
              "monthlyExist": {
                "message": "感謝您對 Dropbox 優惠有興趣。此優惠不適用於現有 Dropbox 客戶。您仍可升級至 {0}年度方案，節省高達 16% 的費用。"
              },
              "dropboxApiUnavailable": {
                "title": "Oops! Something went wrong",
                "message": "\u7CFB\u7D71\u76EE\u524D\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8981\u6C42\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66\u4E00\u6B21\u3002"
              }
            }
          }
        },
        "disabled_4_monthly": "此來自 {0} 的優惠僅適用於年度訂閱。",
        "offer_detail_title": "優惠詳細內容",
        "offer_detail_cta": "優惠詳細內容",
        "special_offer": "特殊優惠",
        "offer_no_longer_applies_title": "優惠已不再適用",
        "proceed_without_offer": "不使用優惠而繼續",
        "unsupport_device_tips": "很抱歉！ 此優惠目前不適用於行動裝置。 若要繼續，請在桌面裝置上兌換此優惠。",
        "exclusive_discount": {
          "subtitle": "Zoom Customer Discount"
        },
        "special_promo": {
          "title": "Special Promotion",
          "limit_time": "LIMITED TIME"
        },
        "masterclass": {
          "title": "MasterClass",
          "display_title": "MasterClass - Individual ({0}-months)",
          "license_tooltip": "The Masterclass user count cannot exceed Zoom One license count.",
          "license_alert": "The {0} membership count must be equal to or less than the {1} user count.",
          "cycle_amount": "{0} for {1} months",
          "desc": "Gain access to 185+ classes and original series led by industry experts while discovering new classes every month.",
          "unit_tips": "The MasterClass Membership is a non-recurring plan.  At the end of the 12 months, you may purchase a membership renewal directly from MasterClass.",
          "cart_cycle_desc": "{0} Months (One-Time Payment)",
          "provide_tips": "*Service is provided by MasterClass",
          "cart_title": "MasterClass - Individual",
          "goto_billing_page_tips": "To increase the number of membership for {addon}, you need to adjust your {base} user quantity to equal to or more than {addon}. <a href=\"/billing\">Return to Plan Management</a>"
        },
        "error": {
          "expire_partner": "We're sorry, the {0} promotion has ended on {1}."
        }
      },
      "export_control": {
        "biz_org_type": "\u696D\u52D9/\u7D44\u7E54\u985E\u578B",
        "biz": "零售/批發",
        "fin": "\u9280\u884C\u6216\u5176\u4ED6\u91D1\u878D\u6A5F\u69CB",
        "edu": "幼稚園至高中教育",
        "med": "\u516C\u5171\u885B\u751F\u6216\u91AB\u7642\u6A5F\u69CB",
        "util": "\u516C\u7528\u4E8B\u696D",
        "telcomm": "\u570B\u5BB6\u96FB\u4FE1\u516C\u53F8",
        "edu_high": "\u5927\u5B78/\u9AD8\u7B49\u6559\u80B2",
        "sci_tech_inst": "\u79D1\u6280\u7814\u7A76\u9662\u6216\u570B\u5BB6\u5BE6\u9A57\u5BA4",
        "gov": "\u570B\u5BB6\u3001\u7701/\u5DDE\u653F\u5E9C\uFF0C\u6216\u5730\u65B9\u653F\u5E9C\u6A5F\u69CB\u3001\u8FA6\u516C\u5BA4\u3001\u6216\u90E8",
        "other": "\u5176\u4ED6",
        "input_placeholder": "\u8F38\u5165\u696D\u52D9/\u7D44\u7E54\u985E\u578B",
        "adv": "廣告",
        "mfg": "製造與工業",
        "ps": "專業服務和管理顧問",
        "bp": "生技/製藥",
        "cnstr": "建築",
        "ent": "娛樂",
        "lgl": "法律",
        "hpy": "旅宿",
        "np": "非營利組織",
        "tech": "科技",
        "trans": "運輸",
        "re": "房地產"
      },
      "visitor_management": {
        "title": "訪客管理",
        "desc": "利用自訂邀請、簡單方便的 Kiosk 報到、報告和指標，簡化訪客報到程序。",
        "more_users_tip": "如果您需要超過 {quantity} 名使用者，<a href=\"{url}\" target=\"_blank\">請聯絡銷售人員</a>",
        "plan_details": {
          "desc1": "在 Zoom 入口網站管理邀請、訪客位置和造訪歷史記錄",
          "desc2": "建立、追蹤、重新傳送和刪除邀請，同時接收訪客抵達通知",
          "desc3": "透過 Kiosk 填寫表格、獲取路線指示和報到，提供順暢的訪客體驗",
          "desc4": "在熟悉的 Zoom 入口網站中存取所有功能，實現輕鬆管理"
        }
      },
      "config": {
        "select_number_license": "選擇授權數量",
        "select_number_users": "選擇使用者人數",
        "select_number_spaces": "選取空間數量"
      },
      "zoom_revenue_accelerator": {
        "tooltip": "{0} 授權數不能超過 {1} 使用者人數。"
      },
      "zoom_session": {
        "select_label": "Zoom sessions select number of attendees"
      },
      "zoom_events": {
        "select_label": "Zoom events select number of attendees",
        "upgrade": {
          "prompt_title": "您確定要下單嗎？",
          "ppa_lose_prompt_desc": "您將永久失去任何來自目前的  {0}  方案的剩餘觀眾，且您將不會收到給他們的退款。",
          "saas_has_free_event_desc": "一旦此方案的變更於  {1}  生效，超過您的  {0}  新觀眾容量的觀眾將無法參加。",
          "saas_has_paid_event_desc": "您擁有至少一場即將舉行的已付費活動，其觀眾容量高於  {0} 。 若要繼續使用方案變更，請讓授權擁有者降低活動的觀眾容量，或在  {1}  之前取消活動。",
          "saas_has_free_and_paid_event_desc": "若要繼續使用方案變更，請務必讓授權擁有者把即將舉行的已付費活動觀眾容量降低至 {0} 人，或在 {1}之前取消活動。<br/><br/>此外，{1}之後，沒有任何免費活動的觀眾可超過 {0} 人。"
        }
      },
      "concurrent_meeting_basic": {
        "title": "同步會議基本版",
        "select_license_tip": "一部已授權的主機上最多可同時進行四場會議。"
      },
      "concurrent_meeting_plus": {
        "title": "Concurrent Meeting Plus"
      },
      "delta": {
        "new_licenses": "新授權",
        "buy_more_licenses": "購買更多授權",
        "cur_users_modal_single": "您目前的方案擁有 {1} 個專業版授權。取得更多授權，並指派給使用者。",
        "cur_users_modal_multiple": "您目前的方案擁有 {X} 個專業版授權。取得更多授權，並指派給使用者。",
        "add_user": "新增更多使用者至目前的方案",
        "cur_users": "您目前的方案擁有 {X} 位使用者。",
        "cur_plan_details": "目前方案詳情",
        "cur_plan_detail": "檢視目前方案的詳細資訊",
        "not_eligible_for_offer": "很遺憾，您不符合此優惠的資格",
        "offer_exclusive_to": "此優惠僅限提供給 {0} 位使用者。",
        "new_users": "新使用者"
      },
      "prorated": {
        "cur_users": "您目前的方案擁有 {0} 個 {1}。",
        "prorated_period_tooltip": "這個比例費用是根據您從今天開始到下一個收費日的新訂閱方案計算。",
        "charge_tooltip": "今日費用是根據您目前訂閱的剩餘天數以及新增的使用者，加上適用的按比例的稅金計算的。",
        "xx_new_unit": "{0} 新的 {1}",
        "transaction_credit_applied": "已使用的額度",
        "transaction_credit_tip": "今天您將會收到現有方案未使用天數產生的額度{0}。",
        "existing_credit_applied": "已使用的現有信用餘額",
        "remaining_credit": "今天購買後，您的信用餘額將為 {0}。",
        "refund_credit_usage": "剩餘的額度將用於未來購買。",
        "current_summary": "目前方案摘要",
        "updated_summary": "已更新的方案摘要",
        "charged_period": "按比例收取 {0} 費用"
      },
      "healthcare": {
        "title": "Zoom 健康照護解決方案",
        "desc": "美國健康照護客戶需要 BAA (商業夥伴協定) 以符合 HIPAA 法規遵循，而加拿大客戶要求 PHIA 協議。",
        "business_country_select": {
          "label": "選取商業版國家/地區",
          "option_label": {
            "united_states": "美國協議 (BAA (商業夥伴協定))",
            "canada": "加拿大協議 (PHIA)",
            "other": "其他"
          }
        },
        "read_agreement": "閱讀協議",
        "baa_accepted": "接受商業夥伴協定",
        "phia_accepted": "接受受保護的健康資訊附件",
        "not_eligible_tip": "根據您的選擇，BAA (商業夥伴協定) 或 PHIA 無法啟用。您可以繼續購買 {0}，而不啟用 Zoom 健康照護解決方案，或是由此 <a class=\"zm-button zm-button--link opc-link-btn\" href=\"/contactsales\" target=\"_blank\">Contact Sales</a> 聯絡銷售人員。",
        "agreement_dialog": {
          "guide_to_accept_tip": "接受之前，請完整閱讀協議。",
          "accept": "我接受"
        },
        "switch_plan_confirm": {
          "title": "計畫不符合 BAA (商業夥伴協定) 或 PHIA 資格",
          "desc": "BAA (商業夥伴協定) 或 PHIA 法規遵循僅包括在專業版計畫內。切換至商業版計畫，將從您的購物車移除此法規遵循。<br /><br />如需詳細資訊，請由此 <a class=\"zm-button zm-button--link opc-link-btn\" href=\"/contactsales\" target=\"_blank\">Contact Sales</a> 聯絡銷售人員。"
        },
        "address": {
          "not_eligible_tip": "根據您的國家或地區，BAA (商業夥伴協定) 或 PHIA 協議無法啟用，若您繼續操作，將移除該協議。您可以繼續購買 {0}，而不啟用 Zoom 健康照護解決方案，或是由此 <a class=\"zm-button zm-button--link opc-link-btn\" href=\"/contactsales\" target=\"_blank\">Contact Sales</a> 聯絡銷售人員。"
        }
      },
      "license_assigned_limit_toolips": "授權數量必須等於目前指派給您帳戶中使用者的網路研討會授權數量。",
      "zuoraoutage": {
        "terms": "今天，您只需支付第一 {0} 的費用。您可以導覽至 <a href=\"https://zoom.us/billing\" target=\"_blank\">zoom.us/billing</a> 續訂或取消方案。",
        "payment_warning": "很抱歉，我們的付款系統目前出現延誤，我們正在努力解決此問題。如果您使用簽帳卡或信用卡下訂單，您將可立即存取 Zoom 基本版功能，您的付款將在幾個小時內自動處理完成。",
        "payment_blocking_warning": "很抱歉，我們的付款系統目前出現延誤，我們正在努力解決此問題。請於幾小時後再試。感謝您耐心等候。",
        "expire_date": "於 {0} 截止",
        "confirmation_warning": "我們已收到您的訂單，但很抱歉，我們的付款系統目前出現延誤，我們正在努力解決此問題。您將可存取 Zoom 基本版功能，直到您的訂單在幾個小時內自動處理完成。",
        "success_title": "您的方案很快將會就緒",
        "success_subtitle": "一旦完成處理訂單，您會透過 {0} 收到一封包含訂單詳細資訊的確認電子郵件。",
        "view_my_plan_status": "檢視我的方案狀態",
        "payment_processing": "付款處理",
        "zoom_workplace_basic_title": "Zoom Workplace 基本版",
        "zoom_workplace_basic_introduction_1": "40 分鐘會議，每場會議最多 100 名與會者",
        "zoom_workplace_basic_introduction_2": "3 個可編輯白板",
        "zoom_workplace_basic_introduction_3": "將已錄製的會議儲存於本機裝置",
        "zoom_workplace_basic_introduction_4": "團體聊天"
      },
      "event_services": {
        "title": "Webinars 的活動服務諮詢",
        "desc": "與 Zoom 專家合作，讓您的一次性網路研討會發揮最大效益。這包括一小時規劃、一小時活動前技術檢查，以及最多三小時事件監控。平日和週末都提供支援。",
        "view_terms": "檢視條款",
        "hide_terms": "隱藏條款",
        "terms_content": "一次性網路研討會訂閱和 Webinars 的活動服務諮詢必須在購買日起三個月內使用，如果客戶未在三個月內使用，則將自動過期。<br /><br />\n\n 本服務包含在客戶的一次性網路研討會訂閱中，Zoom 向客戶提供下列額外活動技術支援服務：<br /><br />\n\n 活動顧問提供 1 小時通話，協助您計畫、檢視設定和功能，並討論議程和活動角色；活動前與演講者進行 1 小時音訊和視訊技術檢查；最多 3 小時直播活動支援，Zoom 將主動監控演講者連線並提供會議內技術支援。超過 3 小時的網路研討會可能需要額外付費的諮詢服務。對於擁有 25 萬名以上觀眾的一次性網路研討會訂閱客戶，Zoom 將提供一名製作專家以取代活動顧問，為影音製作提供技術支援 (即「Webinars 的活動服務諮詢」)。所有 Webinars 的活動服務諮詢均由 Zoom 以遠端方式提供。Webinars 的活動服務諮詢僅限於上述特定技術支援服務，為明確說明，不包括但不限於以下服務：第三方供應商的支援或管理、影音製作服務、影音硬體、疑難排解或更換、內容創作服務、宣傳、行銷或註冊服務、報告和資料分析、隨時支援以及自訂製作工具的持續技術支援。<br /><br />\n\n 如果網路研討會的觀眾高達 10 萬名，必須在購買後至少 48 小時安排。如果網路研討會有 25 萬名至 1 百萬名觀眾，必須在初次諮詢我們的活動服務團隊後至少 7 天安排活動。Zoom 將傳送一封電子郵件，確認議定的日期和時間。客戶可提出變更活動日期的一次性要求，但這需要 Zoom 事先核准並受 Zoom 可用性的限制，以便提供 Webinars 的活動服務諮詢。",
        "unit": {
          "million_1": "100 萬",
          "million_1_uppercase": "100 萬"
        },
        "price_included": "已包含",
        "x_hours_per_license": "每份授權 5 小時"
      },
      "single_use_webinar": {
        "notification": "如果網路研討會的觀眾高達 10 萬名，必須在購買後至少 48 小時安排。如果網路研討會有 25 萬名至 1 百萬名觀眾，必須在初次諮詢我們的活動服務團隊後至少 7 天安排活動。活動服務專家將在 48 小時內與您聯絡，協助您規劃活動。在聯絡您之前，您可以測試並主持最多 10 名觀眾的網路研討會。超過 3 小時的網路研討會可能需要額外付費的諮詢服務。",
        "terms": "必須在購買日起三個月內主持您的一次性網路研討會。任何未使用的一次性網路研討會和諮詢服務將自購買日起三個月後到期。此購買無法退款。",
        "success_thanks": "您將透過 <b style='font-weight: 600'>{email}</b> 收到一封包含訂單詳細資訊的電子郵件確認信，我們的活動服務諮詢團隊將在 48 小時內與您聯絡。如有緊急要求，請透過 <a href='javascript:void(0);'>eventservices+customer@zoom.us</a> 聯絡我們。"
      },
      "single_use_meeting": {
        "desc": "享受無限制會議、雲端錄製、AI Companion 等！",
        "expire_desc_for_pro": "三個月內到期",
        "within_three_months": "三個月內",
        "terms": "網路研討會服務需要 Zoom One 專業版授權，並且免費包含在內。您的 Zoom One 專業版授權將於購買日起三個月後到期。",
        "a_to_b_attendees": "{0} 到 {1} 名觀眾"
      },
      "attendees_remark_1": "您的嘉賓和觀眾可以直接加入網路研討會，<strong>不需要</strong>購買或下載 Zoom。",
      "attendees_remark_2": "網路研討會的主持人或聯席主持人可將觀眾提升為嘉賓。",
      "ai_companion_learn_more": {
        "ai_companion_desc": "Zoom AI Companion 是您的智慧 AI 助理，可協助您完成更多工作、與同事協作及改善溝通方法",
        "ai_tips1": "存取會議後摘要，並透過團體聊天或電子郵件輕鬆與他人分享",
        "ai_tips2": "透過可搜尋的逐字稿、主題章節等功能，快速檢閱錄製內容",
        "ai_tips3": "如果您遲到，可以與 AI Companion 聊天以跟上進度，並檢視正在討論的詳細資訊",
        "ai_tips4": "將聊天和電子郵件的訊息語氣、長度和其他內容偏好個人化",
        "ai_footer_text": "AI Companion 包含於 Zoom 使用者帳戶的付費服務，無需額外費用。可能排除特定垂直產業和地理區域。"
      },
      "use_verification": {
        "biz_title": "商業用途驗證",
        "desc": "Zoom Events 和 Zoom Sessions 僅供於商業和教育用途。",
        "edu_title": "教育用途驗證",
        "tan_pan_star": "TAN/PAN *",
        "cin_star": "CIN *",
        "edu_star": "EDU *",
        "tan_pan": "TAN/PAN",
        "cin": "CIN",
        "edu": "EDU",
        "tan_pan_error": "輸入有效的 TAN/PAN ID",
        "cin_error": "輸入有效的 CIN ID",
        "edu_error": "輸入有效的 EDU ID"
      },
      "live_support": "即時聊天支援"
    },
    "country": {
      "AF": "\u963F\u5BCC\u6C57",
      "AX": "\u5967\u862D\u7FA4\u5CF6",
      "AL": "\u963F\u723E\u5DF4\u5C3C\u4E9E",
      "DZ": "\u963F\u723E\u53CA\u5229\u4E9E",
      "AS": "\u7F8E\u5C6C\u85A9\u6469\u4E9E",
      "AD": "\u5B89\u9053\u723E",
      "AO": "\u5B89\u54E5\u62C9",
      "AI": "\u82F1\u5C6C\u5B89\u5409\u62C9",
      "AQ": "\u5357\u6975\u6D32",
      "AG": "\u5B89\u63D0\u74DC\u53CA\u5DF4\u5E03\u9054",
      "AR": "\u963F\u6839\u5EF7",
      "AM": "\u4E9E\u7F8E\u5C3C\u4E9E",
      "AW": "\u963F\u9B6F\u5DF4",
      "AC": "\u4E9E\u68EE\u6B23\u5CF6",
      "AU": "\u6FB3\u5927\u5229\u4E9E",
      "AT": "\u5967\u5730\u5229",
      "AZ": "\u4E9E\u585E\u62DC\u7136",
      "BS": "\u5DF4\u54C8\u99AC",
      "BH": "\u5DF4\u6797",
      "BD": "\u5B5F\u52A0\u62C9",
      "BB": "\u5DF4\u8C9D\u591A",
      "BY": "\u767D\u4FC4\u7F85\u65AF",
      "BE": "\u6BD4\u5229\u6642",
      "BZ": "\u8C9D\u91CC\u65AF",
      "BJ": "\u8C9D\u5357",
      "BM": "\u767E\u6155\u9054",
      "BT": "\u4E0D\u4E39",
      "BO": "\u73BB\u5229\u7DAD\u4E9E",
      "BA": "\u6CE2\u65AF\u5C3C\u4E9E\u53CA\u9ED1\u585E\u54E5\u7DAD\u90A3",
      "BW": "\u6CE2\u672D\u90A3",
      "BV": "\u6CE2\u7DAD\u7279\u5CF6",
      "BR": "\u5DF4\u897F",
      "BQ": "\u6CE2\u5948\u3001\u8056\u4F51\u9054\u4FEE\u65AF\u548C\u6C99\u5DF4",
      "IO": "\u82F1\u5C6C\u5370\u5EA6\u6D0B\u5730\u5340",
      "VG": "\u82F1\u5C6C\u7DAD\u4EAC\u7FA4\u5CF6",
      "BN": "\u6C76\u840A",
      "BG": "\u4FDD\u52A0\u5229\u4E9E",
      "BF": "\u5E03\u5409\u7D0D\u6CD5\u7D22",
      "BI": "\u84B2\u9686\u5730",
      "KH": "\u67EC\u57D4\u5BE8",
      "CM": "\u5580\u9EA5\u9686",
      "CA": "\u52A0\u62FF\u5927",
      "IC": "\u52A0\u7D0D\u5229\u7FA4\u5CF6",
      "CT": "\u582A\u6771\u8207\u5B89\u5FB7\u67CF\u91CC\u5CF6",
      "CV": "\u7DAD\u5FB7\u89D2",
      "KY": "\u958B\u66FC\u7FA4\u5CF6",
      "CF": "\u4E2D\u975E\u5171\u548C\u570B",
      "EA": "\u4F11\u9054\u548C\u6885\u5229\u5229\u4E9E",
      "TD": "\u67E5\u5FB7",
      "CL": "\u667A\u5229",
      "CN": "\u4E2D\u570B",
      "CN-ML": "\u4E2D\u570B\u5927\u9678",
      "CX": "\u8056\u8A95\u5CF6",
      "CP": "\u514B\u5229\u73C0\u9813\u5CF6",
      "CC": "\u53EF\u53EF\u65AF\u7FA4\u5CF6",
      "CO": "\u54E5\u502B\u6BD4\u4E9E",
      "KM": "\u79D1\u6469\u7F85",
      "CD": "\u525B\u679C\u6C11\u4E3B\u5171\u548C\u570B",
      "CK": "\u5EAB\u514B\u7FA4\u5CF6",
      "CR": "\u54E5\u65AF\u5927\u9ECE\u52A0",
      "CI": "\u79D1\u7279\u8FEA\u74E6",
      "HR": "\u514B\u7F85\u57C3\u897F\u4E9E",
      "CU": "\u53E4\u5DF4",
      "CW": "\u53E4\u62C9\u679C",
      "CY": "\u8CFD\u666E\u8DEF\u65AF",
      "CZ": "\u6377\u514B",
      "DK": "\u4E39\u9EA5",
      "DG": "\u8FEA\u4E9E\u54E5\u52A0\u897F\u4E9E\u5CF6",
      "DJ": "\u5409\u5E03\u5730",
      "DM": "\u591A\u7C73\u5C3C\u514B",
      "DO": "\u591A\u7C73\u5C3C\u52A0\u5171\u548C\u570B",
      "NQ": "\u6BDB\u5FB7\u7687\u540E\u5730",
      "EC": "\u5384\u74DC\u591A",
      "EG": "\u57C3\u53CA",
      "SV": "\u85A9\u723E\u74E6\u591A",
      "GQ": "\u8D64\u9053\u5E7E\u5167\u4E9E",
      "ER": "\u5384\u7ACB\u7279\u91CC\u4E9E",
      "EE": "\u611B\u6C99\u5C3C\u4E9E",
      "ET": "\u8863\u7D22\u6BD4\u4E9E",
      "EU": "\u6B50\u6D32\u806F\u76DF",
      "FK": "\u798F\u514B\u862D\u7FA4\u5CF6\uFF08\u99AC\u723E\u7DAD\u7D0D\u65AF\u7FA4\u5CF6\uFF09",
      "FO": "\u6CD5\u7F85\u7FA4\u5CF6",
      "FJ": "\u6590\u6FDF",
      "FI": "\u82AC\u862D",
      "FR": "\u6CD5\u570B",
      "GF": "\u6CD5\u5C6C\u572D\u4E9E\u90A3",
      "PF": "\u6CD5\u5C6C\u73BB\u91CC\u5C3C\u897F\u4E9E",
      "TF": "\u6CD5\u5C6C\u5357\u90E8\u5C6C\u5730",
      "FQ": "\u6CD5\u5C6C\u5357\u90E8\u548C\u5357\u6975\u9818\u5730",
      "GA": "\u52A0\u5F6D",
      "GM": "\u7518\u6BD4\u4E9E",
      "GE": "\u55AC\u6CBB\u4E9E",
      "DE": "\u5FB7\u570B",
      "GH": "\u8FE6\u7D0D",
      "GI": "\u76F4\u5E03\u7F85\u9640",
      "GR": "\u5E0C\u81D8",
      "GL": "\u683C\u9675\u862D",
      "GD": "\u683C\u745E\u7D0D\u9054",
      "GP": "\u74DC\u5730\u6D1B\u666E",
      "GU": "\u95DC\u5CF6",
      "GT": "\u74DC\u5730\u99AC\u62C9",
      "GG": "\u6839\u606F\u5CF6",
      "GN": "\u5E7E\u5167\u4E9E",
      "GW": "\u5E7E\u5167\u4E9E\u6BD4\u7D22",
      "GY": "\u572D\u4E9E\u90A3",
      "HT": "\u6D77\u5730",
      "HM": "\u8D6B\u5FB7\u5CF6\u53CA\u9EA5\u7576\u52DE\u5CF6",
      "HN": "\u5B8F\u90FD\u62C9\u65AF",
      "HK": "\u9999\u6E2F\u7279\u5225\u884C\u653F\u5340",
      "HU": "\u5308\u7259\u5229",
      "IS": "\u51B0\u5CF6",
      "IN": "\u5370\u5EA6",
      "ID": "\u5370\u5C3C",
      "IR": "\u4F0A\u6717\u4F0A\u65AF\u862D\u5171\u548C\u570B",
      "IE": "\u611B\u723E\u862D",
      "IM": "\u82F1\u5C6C\u66FC\u5CF6",
      "IL": "\u4EE5\u8272\u5217",
      "IQ": "\u4F0A\u62C9",
      "IT": "\u7FA9\u5927\u5229",
      "JM": "\u7259\u8CB7\u52A0",
      "JP": "\u65E5\u672C",
      "JE": "\u6FA4\u897F\u5CF6",
      "JT": "\u6FA4\u897F\u5CF6",
      "JO": "\u7D04\u65E6",
      "KZ": "\u54C8\u85A9\u514B\u65AF\u5766",
      "KE": "\u80AF\u4E9E",
      "KI": "\u5409\u91CC\u5DF4\u65AF",
      "KP": "\u671D\u9BAE\u6C11\u4E3B\u4E3B\u7FA9\u4EBA\u6C11\u5171\u548C\u570B",
      "KR": "\u5927\u97D3\u6C11\u570B",
      "XK": "\u79D1\u7D22\u6C83",
      "KW": "\u79D1\u5A01\u7279",
      "KG": "\u5409\u723E\u5409\u65AF\u65AF\u5766",
      "LA": "\u5BEE\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u570B",
      "LV": "\u62C9\u812B\u7DAD\u4E9E",
      "LB": "\u9ECE\u5DF4\u5AE9",
      "LS": "\u8CF4\u7D22\u6258",
      "LR": "\u8CF4\u6BD4\u745E\u4E9E",
      "LY": "\u5229\u6BD4\u4E9E",
      "LI": "\u5217\u652F\u6566\u65AF\u767B",
      "LT": "\u7ACB\u9676\u5B9B",
      "LU": "\u76E7\u68EE\u5821",
      "MO": "\u6FB3\u9580\u7279\u5225\u884C\u653F\u5340",
      "MK": "\u5317\u99AC\u5176\u9813",
      "MG": "\u99AC\u9054\u52A0\u65AF\u52A0",
      "MW": "\u99AC\u62C9\u7DAD",
      "MY": "\u99AC\u4F86\u897F\u4E9E",
      "MV": "\u99AC\u723E\u5730\u592B",
      "ML": "\u99AC\u5229",
      "MT": "\u99AC\u723E\u4ED6",
      "MH": "\u99AC\u7D39\u723E\u7FA4\u5CF6",
      "MQ": "\u6CD5\u5C6C\u99AC\u4E01\u5C3C\u514B",
      "MR": "\u8305\u5229\u5854\u5C3C\u4E9E",
      "MU": "\u6A21\u91CC\u897F\u65AF",
      "YT": "\u99AC\u7D04\u7279",
      "FX": "\u6CD5\u5C6C\u7F8E\u7279\u7F85\u6CE2\u5229\u5766",
      "MX": "\u58A8\u897F\u54E5",
      "FM": "\u5BC6\u514B\u7F85\u5C3C\u897F\u4E9E\u806F\u90A6",
      "MI": "\u4E2D\u9014\u5CF6",
      "MD": "\u6469\u723E\u591A\u74E6\u5171\u548C\u570B",
      "MC": "\u6469\u7D0D\u54E5",
      "MN": "\u8499\u53E4",
      "ME": "\u8499\u7279\u5167\u54E5\u7F85",
      "MS": "\u8499\u54F2\u81D8",
      "MA": "\u6469\u6D1B\u54E5",
      "MZ": "\u83AB\u4E09\u6BD4\u514B",
      "MM": "\u7DEC\u7538",
      "NA": "\u7D0D\u7C73\u6BD4\u4E9E",
      "NR": "\u8AFE\u9B6F",
      "NP": "\u5C3C\u6CCA\u723E",
      "NL": "\u8377\u862D",
      "AN": "\u8377\u5C6C\u5B89\u5730\u5217\u65AF",
      "NT": "\u4E2D\u7ACB\u5340",
      "NC": "\u65B0\u5580\u91CC\u591A\u5C3C\u4E9E",
      "NZ": "\u7D10\u897F\u862D",
      "NI": "\u5C3C\u52A0\u62C9\u74DC",
      "NE": "\u5C3C\u65E5",
      "NG": "\u5948\u53CA\u5229\u4E9E",
      "NU": "\u7D10\u57C3",
      "NF": "\u8AFE\u798F\u514B\u5CF6",
      "VD": "\u8D8A\u5357\u5317\u90E8",
      "MP": "\u5317\u99AC\u91CC\u4E9E\u7D0D\u7FA4\u5CF6",
      "NO": "\u632A\u5A01",
      "OM": "\u963F\u66FC",
      "OM_mobile": "\u5DF4\u57FA\u65AF\u5766",
      "QO": "\u96E2\u5CF6\u5927\u6D0B\u6D32",
      "PC": "\u592A\u5E73\u6D0B\u7FA4\u5CF6\u8A17\u7BA1\u5730",
      "PK": "\u5DF4\u57FA\u65AF\u5766",
      "PW": "\u5E1B\u7409",
      "PS": "\u5DF4\u52D2\u65AF\u5766\u570B",
      "PA": "\u5DF4\u62FF\u99AC",
      "PZ": "\u5DF4\u5E03\u4E9E\u7D10\u5E7E\u5167\u4E9E",
      "PY": "\u5DF4\u62C9\u572D",
      "YD": "\u8449\u9580\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u570B",
      "PE": "\u79D8\u9B6F",
      "PH": "\u83F2\u5F8B\u8CD3",
      "PN": "\u76AE\u7279\u80AF",
      "PL": "\u6CE2\u862D",
      "PT": "\u8461\u8404\u7259",
      "PR": "\u6CE2\u591A\u9ECE\u5404",
      "QA": "\u5361\u9054",
      "RE": "\u7559\u5C3C\u65FA",
      "RO": "\u7F85\u99AC\u5C3C\u4E9E",
      "RU": "\u4FC4\u7F85\u65AF\u806F\u90A6",
      "RW": "\u76E7\u5B89\u9054",
      "BL": "\u8056\u5DF4\u745F\u7C73",
      "SH": "\u8056\u8D6B\u52D2\u62FF\u3001\u4E9E\u68EE\u6B23\u3001\u7279\u91CC\u65AF\u5766\u9054\u5EAB\u5C3C\u4E9E\u7FA4\u5CF6",
      "KN": "\u8056\u57FA\u8328\u53CA\u5C3C\u7DAD\u65AF",
      "LC": "\u8056\u9732\u897F\u4E9E",
      "MF": "\u6CD5\u5C6C\u8056\u99AC\u4E01",
      "PM": "\u8056\u76AE\u57C3\u53CA\u5BC6\u514B\u9686\u7FA4\u5CF6",
      "VC": "\u8056\u6587\u68EE\u53CA\u683C\u745E\u7D0D\u4E01\u65AF",
      "WS": "\u85A9\u6469\u4E9E",
      "SM": "\u8056\u99AC\u5229\u8AFE",
      "ST": "\u8056\u591A\u7F8E\u53CA\u666E\u6797\u897F\u6BD4",
      "SA": "\u6C99\u70CF\u5730\u963F\u62C9\u4F2F",
      "SN": "\u585E\u5167\u52A0\u723E",
      "RS": "\u585E\u723E\u7DAD\u4E9E",
      "CS": "\u585E\u723E\u7DAD\u4E9E\u8207\u8499\u7279\u5167\u54E5\u7F85",
      "SC": "\u585E\u5E2D\u723E",
      "SL": "\u7345\u5B50\u5C71",
      "SG": "\u65B0\u52A0\u5761",
      "SX": "\u8377\u5C6C\u8056\u99AC\u4E01",
      "SK": "\u65AF\u6D1B\u4F10\u514B",
      "SI": "\u65AF\u6D1B\u7DAD\u5C3C\u4E9E",
      "SB": "\u7D22\u7F85\u9580\u7FA4\u5CF6",
      "SO": "\u7D22\u746A\u5229\u4E9E",
      "ZA": "\u5357\u975E",
      "GS": "\u5357\u55AC\u6CBB\u4E9E\u5CF6\u53CA\u5357\u4E09\u660E\u6CBB\u7FA4\u5CF6",
      "ES": "\u897F\u73ED\u7259",
      "LK": "\u65AF\u91CC\u862D\u5361",
      "SR": "\u8607\u5229\u5357",
      "SJ": "\u65AF\u74E6\u723E\u5DF4\u53CA\u63DA\u99AC\u5EF6",
      "SZ": "\u53F2\u74E6\u5E1D\u5C3C",
      "SE": "\u745E\u5178",
      "CH": "\u745E\u58EB",
      "SY": "\u963F\u62C9\u4F2F\u6558\u5229\u4E9E\u5171\u548C\u570B",
      "TW": "\u4E2D\u570B\u53F0\u7063",
      "TW_mobile": "\u53F0\u7063\u5927\u54E5\u5927",
      "TJ": "\u5854\u5409\u514B\u65AF\u5766",
      "TZ": "\u5766\u5C1A\u5C3C\u4E9E\u806F\u5408\u5171\u548C\u570B",
      "TH": "\u6CF0\u570B",
      "TL": "\u6771\u5E1D\u6C76",
      "TG": "\u591A\u54E5",
      "TK": "\u6258\u514B\u52DE",
      "TO": "\u6771\u52A0",
      "TT": "\u7279\u7ACB\u5C3C\u9054\u53CA\u591A\u5DF4\u54E5",
      "TA": "\u5D14\u65AF\u5766\u9054\u5EAB\u5C3C\u4E9E",
      "TN": "\u7A81\u5C3C\u897F\u4E9E",
      "TR": "\u571F\u8033\u5176",
      "TM": "\u571F\u5EAB\u66FC\u65AF\u5766",
      "TC": "\u571F\u514B\u65AF\u53CA\u958B\u79D1\u65AF\u7FA4\u5CF6",
      "TV": "\u5410\u74E6\u9B6F",
      "UM": "\u7F8E\u570B\u672C\u571F\u5916\u5C0F\u5CF6\u5DBC",
      "PU": "\u7F8E\u5C6C\u592A\u5E73\u6D0B\u7FA4\u5CF6",
      "VI": "\u7F8E\u5C6C\u7DAD\u4EAC\u7FA4\u5CF6",
      "UG": "\u70CF\u5E72\u9054",
      "UA": "\u70CF\u514B\u862D",
      "AE": "\u963F\u62C9\u4F2F\u806F\u5408\u914B\u9577\u570B",
      "GB": "\u82F1\u570B",
      "US": "\u7F8E\u5229\u5805\u5408\u773E\u570B",
      "UY": "\u70CF\u62C9\u572D",
      "UZ": "\u70CF\u7386\u5225\u514B\u65AF\u5766",
      "VU": "\u842C\u90A3\u675C",
      "VA": "\u6559\u5EF7",
      "VE": "\u59D4\u5167\u745E\u62C9\u73BB\u5229\u74E6\u5171\u548C\u570B",
      "VN": "\u8D8A\u5357",
      "WK": "\u5A01\u514B\u5CF6",
      "WF": "\u74E6\u5229\u65AF\u7FA4\u5CF6\u53CA\u5BCC\u5716\u90A3\u7FA4\u5CF6",
      "EH": "\u897F\u6492\u54C8\u62C9",
      "YE": "\u8449\u9580",
      "ZM": "\u5C1A\u6BD4\u4E9E",
      "SD": "\u8607\u4E39",
      "SS": "\u5357\u8607\u4E39",
      "ZW": "\u8F9B\u5DF4\u5A01",
      "CG": "\u525B\u679C",
      "PG": "\u5DF4\u5E03\u4E9E\u7D10\u5E7E\u5167\u4E9E",
      "XG": "\u5168\u7403\u884C\u52D5\u885B\u661F\u7CFB\u7D71",
      "XC": "ITPCS\u8A66\u9A57",
      "XT": "\u570B\u969B\u514D\u8CBB\u96FB\u8A71",
      "XV": "\u570B\u969B\u7DB2\u8DEF",
      "XR": "\u570B\u969B\u4ED8\u8CBB\u8A9E\u97F3\u8CC7\u8A0A\u670D\u52D9",
      "XS": "\u5171\u6524\u6210\u672C\u670D\u52D9",
      "XD": "\u9632\u707D\u96FB\u4FE1",
      "XP": "\u901A\u7528\u500B\u4EBA\u96FB\u4FE1",
      "language": {
        "display": "{0}\uFF08{1}\uFF09"
      },
      "en-US": "\u7F8E\u570B",
      "en-GB": "\u82F1\u570B",
      "zh-CN": "\u4E2D\u570B",
      "es-ES": "\u897F\u73ED\u7259",
      "fr-FR": "\u6CD5\u570B",
      "jp-JP": "\u65E5\u672C",
      "de-DE": "\u5FB7\u570B",
      "pt-PT": "\u8461\u8404\u7259\u8A9E",
      "ru-RU": "\u4FC4\u8A9E",
      "TW-TW": "\u53F0\u7063"
    },
    "us": {
      "state_aa": "\u7F8E\u6D32\u8ECD\u4E8B\u57FA\u5730",
      "state_ae": "\u6B50\u6D32\u3001\u4E2D\u6771\u548C\u52A0\u62FF\u5927\u8ECD\u4E8B\u57FA\u5730",
      "state_ap": "\u592A\u5E73\u6D0B\u8ECD\u4E8B\u57FA\u5730",
      "state_al": "\u963F\u62C9\u5DF4\u99AC\u5DDE",
      "state_ak": "\u963F\u62C9\u65AF\u52A0\u5DDE",
      "state_az": "\u4E9E\u5229\u6851\u90A3\u5DDE",
      "state_ar": "\u963F\u80AF\u8272\u5DDE",
      "state_ca": "\u52A0\u5229\u798F\u5C3C\u4E9E\u5DDE",
      "state_co": "\u79D1\u7F85\u62C9\u591A\u5DDE",
      "state_ct": "\u5EB7\u4E43\u72C4\u514B\u5DDE",
      "state_wd": "\u83EF\u76DB\u9813\u54E5\u502B\u6BD4\u4E9E\u7279\u5340",
      "state_de": "\u5FB7\u62C9\u74E6\u5DDE",
      "state_fl": "\u4F5B\u7F85\u91CC\u9054\u5DDE",
      "state_ga": "\u55AC\u6CBB\u4E9E",
      "state_gu": "\u95DC\u5CF6",
      "state_hi": "\u590F\u5A01\u5937\u5DDE",
      "state_id": "\u611B\u9054\u8377\u5DDE",
      "state_il": "\u4F0A\u5229\u8AFE\u5DDE",
      "state_in": "\u5370\u7B2C\u5B89\u7D0D\u5DDE",
      "state_ia": "\u611B\u8377\u83EF\u5DDE",
      "state_ks": "\u582A\u85A9\u65AF\u5DDE",
      "state_ky": "\u80AF\u5854\u57FA\u5DDE",
      "state_la": "\u8DEF\u6613\u65AF\u5B89\u90A3\u5DDE",
      "state_me": "\u7DEC\u56E0\u5DDE",
      "state_md": "\u99AC\u91CC\u862D\u5DDE",
      "state_ma": "\u9EBB\u85A9\u8AF8\u585E\u5DDE",
      "state_mi": "\u5BC6\u897F\u6839\u5DDE",
      "state_mn": "\u660E\u5C3C\u8607\u9054\u5DDE",
      "state_ms": "\u5BC6\u897F\u897F\u6BD4\u5DDE",
      "state_mo": "\u5BC6\u8607\u91CC\u5DDE",
      "state_mt": "\u8499\u5927\u62FF\u5DDE",
      "state_ne": "\u5167\u5E03\u62C9\u65AF\u52A0\u5DDE",
      "state_nv": "\u5167\u83EF\u9054\u5DDE",
      "state_nh": "\u65B0\u7F55\u5E03\u590F\u5DDE",
      "state_nj": "\u7D10\u6FA4\u897F\u5DDE",
      "state_nm": "\u65B0\u58A8\u897F\u54E5\u5DDE",
      "state_ny": "\u7D10\u7D04",
      "state_nc": "\u5317\u5361\u7F85\u4F86\u90A3\u5DDE",
      "state_nd": "\u5317\u9054\u79D1\u4ED6\u5DDE",
      "state_oh": "\u4FC4\u4EA5\u4FC4\u5DDE",
      "state_ok": "\u5967\u514B\u62C9\u8377\u99AC\u5DDE",
      "state_or": "\u5967\u52D2\u5CA1\u5DDE",
      "state_pa": "\u8CD3\u5915\u6CD5\u5C3C\u4E9E\u5DDE",
      "state_pr": "\u6CE2\u591A\u9ECE\u5404",
      "state_ri": "\u7F85\u5FB7\u5CF6",
      "state_sc": "\u5357\u5361\u7F85\u4F86\u7D0D\u5DDE",
      "state_sd": "\u5357\u9054\u79D1\u4ED6\u5DDE",
      "state_tn": "\u7530\u7D0D\u897F\u5DDE",
      "state_tx": "\u5FB7\u514B\u85A9\u65AF\u5DDE",
      "state_ut": "\u7336\u4ED6\u5DDE",
      "state_vt": "\u4F5B\u8499\u7279\u5DDE",
      "state_va": "\u7DAD\u5409\u5C3C\u4E9E\u5DDE",
      "state_vi": "\u7DAD\u723E\u4EAC\u7FA4\u5CF6",
      "state_wa": "\u83EF\u76DB\u9813\u5DDE",
      "state_wv": "\u897F\u7DAD\u5409\u5C3C\u4E9E\u5DDE",
      "state_wi": "\u5A01\u65AF\u5EB7\u8F9B\u5DDE",
      "state_wy": "\u61F7\u4FC4\u660E\u5DDE"
    },
    "ca": {
      "state_aa": "\u4E9E\u4F2F\u9054\u7701",
      "state_ba": "\u5351\u8A69\u7701",
      "state_ma": "\u66FC\u5C3C\u6258\u5DF4\u7701",
      "state_nd": "\u65B0\u4F2F\u502B\u745E\u514B\u7701",
      "state_nr": "\u7D10\u82AC\u862D\u8207\u62C9\u5E03\u62C9\u591A",
      "state_ns": "\u897F\u5317\u9818\u5730",
      "state_na": "\u65B0\u65AF\u79D1\u7D30\u4E9E\u7701",
      "state_nt": "\u52AA\u52D2\u7DAD\u7279",
      "state_oo": "\u5B89\u5927\u7565\u7701",
      "state_pe": "\u611B\u5FB7\u83EF\u738B\u5B50\u5CF6",
      "state_qc": "\u9B41\u5317\u514B\u7701",
      "state_sn": "\u85A9\u514B\u5176\u842C",
      "state_yn": "\u80B2\u7A7A"
    },
    "mx": {
      "state_ags": "\u963F\u74DC\u65AF\u5361\u9023\u7279\u65AF",
      "state_bc": "\u4E0B\u52A0\u5229\u798F\u5C3C\u4E9E\u5DDE",
      "state_bcs": "\u5357\u4E0B\u52A0\u5229\u798F\u5C3C\u4E9E\u5DDE",
      "state_cam": "\u574E\u4F69\u5207\u5DDE",
      "state_chs": "\u6070\u5E15\u65AF\u5DDE",
      "state_chh": "\u9F4A\u9A4A\u83EF",
      "state_co": "\u79D1\u963F\u97CB\u62C9\u5DDE",
      "state_col": "\u79D1\u5229\u99AC\u5DDE",
      "state_dg": "\u675C\u862D\u6208",
      "state_gt": "\u74DC\u7D0D\u83EF\u6258",
      "state_gr": "\u683C\u96F7\u7F85\u5DDE",
      "state_hg": "\u4F0A\u9054\u723E\u6208",
      "state_ja": "\u54C8\u5229\u65AF\u79D1\u5DDE",
      "state_me": "\u58A8\u897F\u54E5",
      "state_mi": "\u7C73\u537B\u80AF\u5DDE",
      "state_mo": "\u83AB\u96F7\u6D1B\u65AF\u5DDE",
      "state_na": "\u7D0D\u4E9E\u91CC\u7279\u5DDE",
      "state_nl": "\u65B0\u840A\u6602\u5DDE",
      "state_oa": "\u74E6\u54C8\u5361\u5DDE",
      "state_pu": "\u666E\u57C3\u5E03\u62C9",
      "state_qr": "\u514B\u96F7\u5854\u7F85\u5DDE",
      "state_qo": "\u91D1\u5854\u7D0D\u7F85\u5967\u5DDE",
      "state_sl": "\u8056\u8DEF\u6613\u65AF\u6CE2\u6258\u897F\u5E02",
      "state_si": "\u932B\u90A3\u7F85\u4E9E\u5DDE",
      "state_so": "\u7D22\u8AFE\u62C9\u5DDE",
      "state_tab": "\u5854\u5DF4\u65AF\u79D1",
      "state_tam": "\u5854\u6BDB\u5229\u5E15\u65AF\u5DDE",
      "state_tl": "\u7279\u62C9\u65AF\u5361\u62C9\u5DDE",
      "state_ve": "\u7DAD\u62C9\u514B\u9B6F\u8332",
      "state_yu": "\u7336\u52A0\u6566\u5DDE",
      "state_za": "\u85A9\u5361\u7279\u5361\u65AF\u5DDE",
      "state_df": "\u806F\u90A6\u5340"
    },
    "au": {
      "state_nsw": "\u65B0\u5357\u5A01\u723E\u65AF\u5DDE",
      "state_qld": "\u6606\u58EB\u862D\u7701",
      "state_sa": "\u5357\u6FB3\u5927\u5229\u4E9E\u5DDE",
      "state_vic": "\u7DAD\u591A\u5229\u4E9E",
      "state_tas": "\u5854\u65AF\u99AC\u5C3C\u4E9E\u5DDE",
      "state_nt": "\u5317\u9818\u5730",
      "state_wa": "\u897F\u6FB3\u5927\u5229\u4E9E\u5DDE",
      "state_act": "\u6FB3\u6D32\u9996\u90FD\u9818\u5730"
    },
    "inr": {
      "state_an": "\u5B89\u9054\u66FC-\u5C3C\u79D1\u5DF4",
      "state_ap": "\u5B89\u5F97\u62C9\u90A6",
      "state_ar": "\u963F\u9B6F\u7D0D\u6070\u723E\u90A6",
      "state_as": "\u963F\u85A9\u59C6",
      "state_br": "\u6BD4\u54C8\u723E",
      "state_ch": "\u660C\u8FEA\u52A0\u723E",
      "state_cg": "\u6070\u8482\u65AF\u52A0\u723E",
      "state_dnh": "\u9054\u5FB7\u62C9\u7D0D\u52A0\u723E\u54C8\u7DAD\u5229",
      "state_dd": "\u9054\u66FC-\u7B2C\u70CF",
      "state_dl": "\u5FB7\u91CC",
      "state_ga": "\u679C\u963F",
      "state_gj": "\u53E4\u5409\u62C9\u7279",
      "state_hr": "\u54C8\u91CC\u4E9E\u7D0D",
      "state_hp": "\u559C\u99AC\u5055\u723E\u90A6",
      "state_jk": "\u67E5\u8B28-\u514B\u4EC0\u7C73\u723E",
      "state_jh": "\u8CC8\u574E\u5FB7",
      "state_ka": "\u5361\u7D0D\u5854\u514B",
      "state_kl": "\u5580\u62C9\u62C9",
      "state_la": "\u62C9\u9054\u514B",
      "state_ld": "\u62C9\u514B\u6C99\u7FA4\u5CF6",
      "state_mp": "\u4E2D\u592E\u90A6",
      "state_mh": "\u99AC\u54C8\u62C9\u65BD\u7279\u62C9",
      "state_mn": "\u66FC\u5C3C\u666E\u723E",
      "state_ml": "\u6885\u52A0\u62C9\u4E9E",
      "state_mz": "\u5BC6\u7D22\u85CD",
      "state_nl": "\u90A3\u52A0\u862D",
      "state_or": "\u5967\u91CC\u85A9",
      "state_ot": "\u5176\u4ED6\u9818\u571F",
      "state_ph": "\u65C1\u8FEA\u5207\u91CC",
      "state_pb": "\u65C1\u906E\u666E",
      "state_rj": "\u62C9\u8CC8\u65AF\u5766",
      "state_sk": "\u932B\u91D1",
      "state_tn": "\u6CF0\u7C73\u723E\u7D0D\u5FB7",
      "state_tg": "\u6CF0\u502B\u8FE6\u7D0D",
      "state_tr": "\u7279\u91CC\u666E\u62C9",
      "state_up": "\u5317\u65B9\u90A6",
      "state_uk": "\u5317\u963F\u574E\u5FB7",
      "state_wb": "\u897F\u5B5F\u52A0\u62C9"
    },
    "language": {
      "en-US": "\u82F1\u8A9E",
      "en-GB": "\u82F1\u8A9E",
      "zh-CN": "\u7C21\u9AD4\u4E2D\u6587",
      "zh-TW": "\u7E41\u9AD4\u4E2D\u6587",
      "es-ES": "\u897F\u73ED\u7259",
      "fr-FR": "\u6CD5\u570B",
      "jp-JP": "\u65E5\u672C",
      "de-DE": "\u5FB7\u8A9E",
      "pt-PT": "\u8461\u8404\u7259\u8A9E",
      "ru-RU": "\u4FC4\u8A9E",
      "ko-KO": "\u97D3\u6587",
      "it-IT": "\u7FA9\u5927\u5229\u6587",
      "vi-VN": "\u8D8A\u5357\u6587",
      "nl-NL": "Dutch"
    },
    "crc": {
      "region": {
        "": "\u5168\u7403",
        "US": "\u7F8E\u570B",
        "SC": "\u7F8E\u570B\u897F\u90E8",
        "NY": "\u7F8E\u570B\u6771\u90E8",
        "DV": "\u7F8E\u570B\u4E2D\u90E8",
        "CN": "\u4E2D\u570B",
        "IN": "\u5370\u5EA6",
        "MB": "\u5370\u5EA6\u5B5F\u8CB7",
        "HY": "\u5370\u5EA6\u6D77\u5F97\u62C9\u5DF4",
        "EU": "\u6B50\u6D32\u3001\u4E2D\u6771\u53CA\u975E\u6D32\u5730\u5340",
        "AU": "\u6FB3\u5927\u5229\u4E9E",
        "HK": "\u9999\u6E2F\u7279\u5225\u884C\u653F\u5340",
        "BR": "\u5DF4\u897F",
        "CA": "\u52A0\u62FF\u5927",
        "TY": "\u65E5\u672C",
        "AM": "\u8377\u862D\u963F\u59C6\u65AF\u7279\u4E39",
        "FR": "\u5FB7\u570B"
      }
    },
    "common": {
      "btn_remove": "\u79FB\u9664",
      "btn_cancel": "\u53D6\u6D88",
      "btn_save": "\u5132\u5B58",
      "btn_yes": "\u662F",
      "btn_no": "\u5426",
      "btn_ok": "\u78BA\u5B9A",
      "btn_back": "\u4E0A\u4E00\u6B65",
      "btn_continue": "\u7E7C\u7E8C",
      "btn_close": "\u95DC\u9589",
      "btn_print": "\u5217\u5370",
      "btn_sign_in": "\u767B\u5165\u3002",
      "month": "\u6708",
      "time_day": "\u65E5",
      "year": "\u5E74",
      "pwd_must": "\u5BC6\u78BC\u5FC5\u9808\uFF1A",
      "months": "\u6708",
      "pwd_has_at_least_characters": "\u81F3\u5C11\u8F38\u5165 {0} \u500B\u5B57\u5143\u3002",
      "pwd_has_one_letter": "\u81F3\u5C11\u8F38\u5165 1 \u500B\u5B57\u6BCD\uFF08a\u3001b\u3001c...\uFF09",
      "pwd_has_one_number": "\u81F3\u5C11\u8F38\u5165 1 \u500B\u6578\u5B57\uFF081\u30012\u30013...\uFF09",
      "pwd_has_one_special_character": "\u81F3\u5C11\u8F38\u5165 1  \u500B\u7279\u6B8A\u5B57\u5143\uFF08!\u3001@\u3001#...\uFF09",
      "pwd_has_both_upper_lower_characters": "\u540C\u6642\u5305\u542B\u5927\u5C0F\u5BEB\u5B57\u5143",
      "pwd_must_not": "\u5BC6\u78BC\u4E0D\u80FD\uFF1A",
      "pwd_contain_consecutive_character_length_rule": "\u5305\u542B{0}\u500B\u9023\u7E8C\u5B57\u5143\uFF08\u4F8B\u5982\u300C11111\u300D\u3001\u300C12345\u300D\u3001\u300Cabcde\u300D\u6216\u300Cqwert\u300D\uFF09",
      "pwd_contain_only_one_character": "\u50C5\u5305\u542B\u55AE\u4E00\u5B57\u5143\uFF0811111111 \u6216 aaaaaaaa\uFF09",
      "pwd_contain_only_one_consecutive_character": "\u50C5\u5305\u542B\u9023\u7E8C\u5B57\u5143\uFF0812345678 \u6216 abcdefgh\uFF09"
    },
    "user": {
      "signup": {
        "already_have_account_signin": "\u5DF2\u6709\u8CEC\u6236\uFF1F\u8ACB<a href=\"/signin\">\u767B\u5165</a>\u3002"
      },
      "age_gating_question": {
        "title": "\u70BA\u9032\u884C\u9A57\u8B49\uFF0C\u8ACB\u78BA\u8A8D\u60A8\u7684\u51FA\u751F\u65E5\u671F\u3002",
        "age_title": "For verification, please confirm your age.",
        "not_stored_data": "\u4E0D\u6703\u5132\u5B58\u6B64\u8CC7\u6599",
        "not_eligible": "\u76EE\u524D\u60A8\u4E0D\u7B26\u5408\u8A3B\u518AZoom\u7684\u8CC7\u683C",
        "not_eligible_for_sign_in": "\u76EE\u524D\u60A8\u4E0D\u7B26\u5408\u767B\u5165Zoom\u7684\u8CC7\u683C"
      },
      "existing_user_sign_in_prompt": "\u91DD\u5C0D\u73FE\u6709\u4F7F\u7528\u8005\uFF0C\u767B\u5165",
      "have_account_sign_in": "\u6709\u5E33\u6236\u4E86\u55CE\uFF1F",
      "resend_invite_email": "Resend invite email to {0} success."
    },
    "error": {
      "billing": {
        "zr_trial_host_validate_tip": "\u60A8\u76EE\u524D\u6709{0}\u500B\u4F7F\u7528\u514D\u8CBB\u8A66\u7528\u7684\u6703\u8B70\u5BA4\u3002\u70BA\u80FD\u65B0\u589E\u984D\u5916\u7684\u6703\u8B70\u5BA4\uFF0C\u60A8\u9700\u8981\u8CFC\u8CB7\u9019\u4E9B\u73FE\u6709\u6703\u8B70\u5BA4\u7684\u6388\u6B0A\u3002",
        "zr_trial_hosts_validate_tip": "\u60A8\u76EE\u524D\u6709{0}\u500B\u4F7F\u7528\u514D\u8CBB\u8A66\u7528\u7684\u6703\u8B70\u5BA4\u3002\u70BA\u80FD\u65B0\u589E\u984D\u5916\u7684\u6703\u8B70\u5BA4\uFF0C\u60A8\u9700\u8981\u8CFC\u8CB7\u9019\u4E9B\u73FE\u6709\u6703\u8B70\u5BA4\u7684\u6388\u6B0A\u3002",
        "adyen": {
          "error_1": "\u7531\u65BC\u4ED8\u6B3E\u65B9\u5F0F\u5B58\u5728\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u8981\u6C42\u3002\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u6216\u5617\u8A66\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "error_2": "\u7531\u65BC\u4FE1\u7528\u5361\u865F\u78BC\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002\u8ACB\u66F4\u65B0\u4FE1\u7528\u5361\u8CC7\u8A0A\u6216\u5617\u8A66\u4F7F\u7528\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002\u82E5\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u5EFA\u8B70\u60A8\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "error_3": "\u7531\u65BC\u5E33\u6236\u8CC7\u91D1\u4E0D\u8DB3\uFF0C\u4ED8\u6B3E\u5DF2\u906D\u62D2\u7D55\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u6216\u5617\u8A66\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "error_4": "\u60A8\u5DF2\u8D85\u51FA\u4F7F\u7528\u7121\u6548\u865F\u78BC\u8655\u7406\u6B64\u5361\u7247\u4ED8\u6B3E\u7684\u5617\u8A66\u6B21\u6578\u3002\u8ACB\u5617\u8A66\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "error_5": "\u7CFB\u7D71\u76EE\u524D\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8981\u6C42\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66\u4E00\u6B21\uFF0C\u6216\u662F\u6539\u7528\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002\u82E5\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u6216\u5617\u8A66\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "error_6": "\u60A8\u5DF2\u8D85\u51FA\u4F7F\u7528\u6B64\u4ED8\u6B3E\u65B9\u5F0F\u8655\u7406\u4ED8\u6B3E\u7684\u5617\u8A66\u6B21\u6578\u3002\u8ACB\u5617\u8A66\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "error_7": "\u7531\u65BC\u5730\u5740\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002\u8ACB\u66F4\u65B0\u4ED8\u6B3E\u8CC7\u8A0A\u6216\u9078\u64C7\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "currency_not_supported": "\u56E0\u70BA\u6B64\u5361\u7247\u4E0D\u652F\u63F4\u4ED8\u6B3E\u8CA8\u5E63\uFF0C\u6B64\u4ED8\u6B3E\u906D\u62D2\u3002 \u8ACB\u5C07\u8CA8\u5E63\u5207\u63DB\u70BA\u7F8E\u5143\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\uFF0C\u6216\u5617\u8A66\u4F7F\u7528\u5176\u4ED6\u4FE1\u7528\u5361\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "invalid_cvc": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "invalid_request": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "merchant_blacklist": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "do_not_try_again": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "incorrect_zip": "\u5730\u5740\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8A02\u55AE\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u5730\u5740\u8207\u9280\u884C\u767B\u8A18\u7684\u5730\u5740\u76F8\u7B26\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "issuer_not_available": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "withdrawal_count_limit_exceeded": "\u6B64\u4ED8\u6B3E\u56E0\u8CC7\u91D1\u76F8\u95DC\u554F\u984C\u906D\u62D2\uFF0C\u53EF\u80FD\u662F\u9280\u884C\u5E33\u6236\u4E2D\u9918\u984D\u4E0D\u8DB3\u6216\u8D85\u904E\u4FE1\u7528\u5361\u984D\u5EA6\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "insufficient_funds": "\u6B64\u4ED8\u6B3E\u56E0\u8CC7\u91D1\u76F8\u95DC\u554F\u984C\u906D\u62D2\uFF0C\u53EF\u80FD\u662F\u9280\u884C\u5E33\u6236\u4E2D\u9918\u984D\u4E0D\u8DB3\u6216\u8D85\u904E\u4FE1\u7528\u5361\u984D\u5EA6\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "generic_decline": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "offline_pin_required": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "not_permitted": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "expired_card": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "online_or_offline_pin_required": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "pickup_card": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "incorrect_pin": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "call_issuer": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "card_velocity_exceeded": "\u6B64\u4ED8\u6B3E\u56E0\u8CC7\u91D1\u76F8\u95DC\u554F\u984C\u906D\u62D2\uFF0C\u53EF\u80FD\u662F\u9280\u884C\u5E33\u6236\u4E2D\u9918\u984D\u4E0D\u8DB3\u6216\u8D85\u904E\u4FE1\u7528\u5361\u984D\u5EA6\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "card_not_supported": "\u6B64\u5361\u4E0D\u80FD\u4F7F\u7528\u6B64\u4EA4\u6613\u985E\u578B\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "lost_card": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "incorrect_number": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "invalid_amount": "\u7531\u65BC\u91D1\u984D\u6216\u8CA8\u5E63\u6709\u554F\u984C\uFF0C\u4ED8\u6B3E\u906D\u62D2\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "incorrect_cvc": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "do_not_honor": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "approve_with_id": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "new_account_information_available": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "no_action_taken": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "invalid_account": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "enter_valid_upi_id": "請輸入有效的 UPI ID。",
          "vpa": "UPI ID"
        },
        "stripe": {
          "approve_with_id": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "authentication_required": "\u7531\u65BC\u4FE1\u7528\u5361\u865F\u78BC\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002\u8ACB\u66F4\u65B0\u4FE1\u7528\u5361\u8CC7\u8A0A\u6216\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002\u82E5\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u5EFA\u8B70\u5411\u60A8\u7684\u9280\u884C\u6D3D\u8A62\u3002",
          "call_issuer": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "card_not_supported": "\u6B64\u5361\u4E0D\u80FD\u4F7F\u7528\u6B64\u4EA4\u6613\u985E\u578B\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "card_not_supported_invoice": "\u6B64\u4FE1\u7528\u5361\u4E0D\u5141\u8A31\u6B64\u4EA4\u6613\u985E\u578B\u3002\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u6216\u700F\u89BD\u81F3<a href=\"/billing/payment\">\u5E33\u55AE\u8CC7\u8A0A</a>\u4E26\u66F4\u65B0\u60A8\u7684\u4ED8\u6B3E\u8CC7\u8A0A\u3002",
          "card_velocity_exceeded": "\u6B64\u4ED8\u6B3E\u56E0\u8CC7\u91D1\u76F8\u95DC\u554F\u984C\u906D\u62D2\uFF0C\u53EF\u80FD\u662F\u9280\u884C\u5E33\u6236\u4E2D\u9918\u984D\u4E0D\u8DB3\u6216\u8D85\u904E\u4FE1\u7528\u5361\u984D\u5EA6\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "card_velocity_exceeded_invoice": "\u7531\u65BC\u5E33\u6236\u8CC7\u91D1\u4E0D\u8DB3\uFF0C\u4ED8\u6B3E\u5DF2\u906D\u62D2\u7D55\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u6216\u700F\u89BD\u81F3<a href=\"/billing/payment\">\u5E33\u55AE\u8CC7\u8A0A</a>\u4E26\u66F4\u65B0\u60A8\u7684\u4ED8\u6B3E\u8CC7\u8A0A\u3002",
          "currency_not_supported": "\u56E0\u70BA\u6B64\u5361\u7247\u4E0D\u652F\u63F4\u4ED8\u6B3E\u8CA8\u5E63\uFF0C\u6B64\u4ED8\u6B3E\u906D\u62D2\u3002 \u8ACB\u5C07\u8CA8\u5E63\u5207\u63DB\u70BA\u7F8E\u5143\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\uFF0C\u6216\u5617\u8A66\u4F7F\u7528\u5176\u4ED6\u4FE1\u7528\u5361\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "currency_not_supported_invoice": "\u7531\u65BC\u6B64\u4FE1\u7528\u5361\u4E0D\u652F\u63F4\u6B64\u7A2E\u8CA8\u5E63\uFF0C\u6B64\u4EA4\u6613\u5DF2\u906D\u62D2\u7D55\u3002\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u6216\u700F\u89BD\u81F3<a href=\"/billing/payment\">\u5E33\u55AE\u8CC7\u8A0A</a>\u4E26\u66F4\u65B0\u60A8\u7684\u4ED8\u6B3E\u8CC7\u8A0A\u3002",
          "do_not_honor": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "do_not_try_again": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "expired_card": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "expired_card_invoice": "\u7531\u65BC\u4FE1\u7528\u5361\u865F\u78BC\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002\u8ACB\u700F\u89BD\u81F3<a href=\"/billing/payment\">\u5E33\u55AE\u8CC7\u8A0A</a>\u4E26\u66F4\u65B0\u60A8\u7684\u4ED8\u6B3E\u8CC7\u8A0A\u3002\u82E5\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u5EFA\u8B70\u5411\u60A8\u7684\u9280\u884C\u6D3D\u8A62\u3002",
          "fraudulent": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "generic_decline": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "generic_error": "\u932F\u8AA4\uFF01\u7CFB\u7D71\u76EE\u524D\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8981\u6C42\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66\uFF0C\u6216\u662F\u6539\u7528\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002\u82E5\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u6216\u6539\u7528\u4E0D\u540C\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002\u82E5\u554F\u984C\u4F9D\u820A\u5B58\u5728\uFF0C\u8ACB<a href=\"https://support.zoom.us/hc/en-us/requests/new?ticket_form_id=360000983032\" target=\"_blank\">\u63D0\u4EA4\u7533\u8ACB</a>\u7D66Zoom\u4EE5\u5C0B\u6C42\u5354\u52A9\u3002",
          "incorrect_cvc": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "incorrect_number": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "incorrect_pin": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "incorrect_zip": "\u5730\u5740\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8A02\u55AE\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u5730\u5740\u8207\u9280\u884C\u767B\u8A18\u7684\u5730\u5740\u76F8\u7B26\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "incorrect_zip_invoice": "\u7531\u65BC\u5730\u5740\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\uFF0C\u8ACB\u700F\u89BD\u81F3<a href=\"/billing/payment\">\u5E33\u55AE\u8CC7\u8A0A</a>\u4E26\u66F4\u65B0\u60A8\u7684\u4ED8\u6B3E\u8CC7\u8A0A\u3002",
          "insufficient_funds": "\u6B64\u4ED8\u6B3E\u56E0\u8CC7\u91D1\u76F8\u95DC\u554F\u984C\u906D\u62D2\uFF0C\u53EF\u80FD\u662F\u9280\u884C\u5E33\u6236\u4E2D\u9918\u984D\u4E0D\u8DB3\u6216\u8D85\u904E\u4FE1\u7528\u5361\u984D\u5EA6\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "insufficient_funds_invoice": "\u7531\u65BC\u5E33\u6236\u8CC7\u91D1\u4E0D\u8DB3\uFF0C\u4ED8\u6B3E\u5DF2\u906D\u62D2\u7D55\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u6216\u700F\u89BD\u81F3<a href=\"/billing/payment\">\u5E33\u55AE\u8CC7\u8A0A</a>\u4E26\u66F4\u65B0\u60A8\u7684\u4ED8\u6B3E\u8CC7\u8A0A\u3002",
          "invalid_account": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "invalid_amount": "\u7531\u65BC\u91D1\u984D\u6216\u8CA8\u5E63\u6709\u554F\u984C\uFF0C\u4ED8\u6B3E\u906D\u62D2\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "invalid_cvc": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "invalid_expiry_month": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "invalid_expiry_year": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "invalid_number": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "invalid_pin": "\u56E0\u5361\u7247\u8A73\u7D30\u8CC7\u8A0A\u7121\u6548\uFF0C\u7121\u6CD5\u8655\u7406\u60A8\u7684\u8CFC\u8CB7\u3002 \u539F\u56E0\u53EF\u80FD\u5305\u62EC\u5361\u865F\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u78BC\u932F\u8AA4\u3002 \u8ACB\u78BA\u8A8D\u60A8\u8F38\u5165\u7684\u4FE1\u7528\u5361\u8A73\u7D30\u8CC7\u6599\u8207\u4FE1\u7528\u5361\u4E0A\u986F\u793A\u7684\u5B8C\u5168\u76F8\u540C\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "issuer_not_available": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "lost_card": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "lost_card_invoice": "\u7531\u65BC\u4FE1\u7528\u5361\u5B58\u5728\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u8981\u6C42\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u6216\u700F\u89BD\u81F3<a href=\"/billing/payment\">\u5E33\u55AE\u8CC7\u8A0A</a>\u4E26\u66F4\u65B0\u60A8\u7684\u4ED8\u6B3E\u8CC7\u8A0A\u3002",
          "merchant_blacklist": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "new_account_information_available": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "no_action_taken": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "not_permitted": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "offline_pin_required": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "online_or_offline_pin_required": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "pickup_card": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "pickup_card_invoice": "\u7531\u65BC\u4FE1\u7528\u5361\u5B58\u5728\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u8981\u6C42\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u6216\u700F\u89BD\u81F3<a href=\"/billing/payment\">\u5E33\u55AE\u8CC7\u8A0A</a>\u4E26\u66F4\u65B0\u60A8\u7684\u4ED8\u6B3E\u8CC7\u8A0A\u3002",
          "pin_try_exceeded": "\u60A8\u5DF2\u8D85\u51FA\u4F7F\u7528\u7121\u6548\u865F\u78BC\u8655\u7406\u6B64\u5361\u7247\u4ED8\u6B3E\u7684\u5617\u8A66\u6B21\u6578\uFF0C\u8ACB\u5617\u8A66\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "processing_error": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "reenter_transaction": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "restricted_card": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "revocation_of_all_authorizations": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "revocation_of_authorization": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "security_violation": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "service_not_allowed": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "stolen_card": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "stolen_card_invoice": "\u7531\u65BC\u4FE1\u7528\u5361\u5B58\u5728\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u8981\u6C42\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u6216\u700F\u89BD\u81F3<a href=\"/billing/payment\">\u5E33\u55AE\u8CC7\u8A0A</a>\u4E26\u66F4\u65B0\u60A8\u7684\u4ED8\u6B3E\u8CC7\u8A0A\u3002",
          "stop_payment_order": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "testmode_decline": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "transaction_not_allowed": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "transaction_not_allowed_inr": "\u60A8\u7684\u5361\u7247\u4E0D\u652F\u63F4\u81EA\u52D5\u8F49\u5E33\u4EA4\u6613\uFF0C\u5F88\u6709\u53EF\u80FD\u662F\u56E0\u70BA\u8A72\u5F35\u5361\u7247\u5C6C\u65BC\u7C3D\u5E33\u91D1\u878D\u5361\uFF0C\u8ACB\u6539\u7528\u4FE1\u7528\u5361\u9032\u884C\u6B64\u9805\u8CFC\u8CB7\u3002",
          "try_again_later": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "withdrawal_count_limit_exceeded": "\u6B64\u4ED8\u6B3E\u56E0\u8CC7\u91D1\u76F8\u95DC\u554F\u984C\u906D\u62D2\uFF0C\u53EF\u80FD\u662F\u9280\u884C\u5E33\u6236\u4E2D\u9918\u984D\u4E0D\u8DB3\u6216\u8D85\u904E\u4FE1\u7528\u5361\u984D\u5EA6\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "card_decline_rate_limit_exceeded": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002",
          "invalid_request": "\u56E0\u5361\u7247\u6709\u4E0D\u660E\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u8655\u7406\u6B64\u4ED8\u6B3E\u3002 \u8ACB\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u5361\u7247\u6216\u4E0D\u540C\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u554F\u984C\u6301\u7E8C\u767C\u751F\uFF0C\u8ACB\u806F\u7D61\u60A8\u7684\u9280\u884C\u3002"
        }
      }
    },
    "country_option": {
      "us": "The United States",
      "other_regions": "Other Countries/Regions"
    },
    "essential_app": {
      "title": "\u5FC5\u8981\u7684\u61C9\u7528\u7A0B\u5F0F",
      "see_more_details": "\u67E5\u770B\u66F4\u591A\u8A73\u60C5",
      "legal_copy": "\u512A\u60E0\u50C5\u9069\u7528\u65BC\u76EE\u524D\u6388\u6B0A\uFF0C\u5373 2023 \u5E74 1 \u6708 4 \u65E5\u7576\u65E5\u6216\u4E4B\u5F8C\uFF0C\u900F\u904E Zoom \u7684\u7DDA\u4E0A\u901A\u8DEF zoom.us/buy \u8CFC\u8CB7 Zoom One Pro\u3001\u5546\u696D\u7248\u6216\u5546\u696D\u52A0\u5F37\u7248\u8A02\u95B1\u8005\u3002 \u8A02\u95B1\u91AB\u7642\u4FDD\u5065\u3001\u6559\u80B2\u6216\u653F\u5E9C\u5E33\u6236\u7684\u4F7F\u7528\u8005\uFF0C\u4E0D\u7B26\u5408\u672C\u6B21\u512A\u60E0\u689D\u4EF6\u3002  \u9664\u4E86 Coda \u4EE5\u5916\uFF0C\u6BCF\u4E00\u6B3E\u61C9\u7528\u7A0B\u5F0F\u81EA\u500B\u5225\u4F7F\u7528\u8005\u555F\u7528\u61C9\u7528\u7A0B\u5F0F\u5F8C 1 \u5E74\u5230\u671F\uFF0C\u4F9D\u6B64\u985E\u63A8\u3002 Coda \u6240\u6709\u4F7F\u7528\u8005\u7686\u4F7F\u7528\u76F8\u540C Zoom \u5E33\u6236\uFF0C\u7531\u76F8\u540C Zoom \u5E33\u6236\u5167\u4EFB\u4F55\u4F7F\u7528\u8005\u7B2C\u4E00\u6B21\u555F\u7528 Coda \u5F8C\u958B\u59CB\u8A08\u7B97\uFF0C\u76F8\u540C Zoom \u5E33\u6236\u5167\u6240\u6709\u4F7F\u7528\u8005\u7686\u65BC\u8A72\u555F\u7528\u5F8C 1 \u5E74\u5230\u671F\uFF0C\u7121\u8AD6\u5F8C\u7E8C\u76F8\u540C Zoom \u5E33\u6236\u5167\u7684\u4F7F\u7528\u8005\u555F\u52D5\u7684\u65E5\u671F\u70BA\u4F55\u3002\u5C0D\u65BC\u6240\u6709\u61C9\u7528\u7A0B\u5F0F\uFF0C\u91CD\u65B0\u5206\u914D\u6216\u53D6\u6D88\u4F7F\u7528\u8005\u7684\u5408\u683C\u6388\u6B0A\u6216\u8A02\u95B1\uFF0C\u7121\u8AD6 1 \u5E74\u4F7F\u7528\u671F\u9650\u662F\u5426\u5C1A\u672A\u5230\u671F\uFF0C\u90FD\u5C07\u7D42\u6B62\u8A72\u4F7F\u7528\u8005\u7684\u4F7F\u7528\u6B0A\u9650\u3002\u555F\u7528\u6BCF\u4E00\u500B\u61C9\u7528\u7A0B\u5F0F\u6642\uFF0C\u90FD\u9069\u7528\u65BC\u81EA\u8EAB\u7684\u4F7F\u7528\u689D\u6B3E\u548C\u96B1\u79C1\u6B0A\u653F\u7B56\u3002\u5305\u542B\u7684\u61C9\u7528\u7A0B\u5F0F\u76EE\u524D\u50C5\u652F\u63F4\u82F1\u8A9E\u3002\u4E26\u975E\u6240\u6709\u61C9\u7528\u7A0B\u5F0F\u90FD\u9069\u7528\u65BC\u884C\u52D5\u88DD\u7F6E\u3002\u512A\u60E0\u7121\u6CD5\u4EE5\u73FE\u91D1\u5F62\u5F0F\u8FD4\u56DE\u6216\u9000\u6B3E\u3002\u512A\u60E0\u50C5\u9069\u7528\u65BC\u5167\u542B\u5728 <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a> \u4E2D\u7684\u5FC5\u8981\u61C9\u7528\u7A0B\u5F0F\u6240\u5217\u7684\u9019\u4E9B\u61C9\u7528\u7A0B\u5F0F\u3002 \u4EFB\u4F55\u61C9\u7528\u7A0B\u5F0F\u7684\u73FE\u6709\u8A02\u95B1\u4F7F\u7528\u8005\uFF0C\u7686\u4E0D\u9069\u7528\u9019\u4E9B\u7279\u5B9A\u61C9\u7528\u7A0B\u5F0F\u7684\u672C\u6B21\u512A\u60E0\u3002Zoom \u6709\u6B0A\u96A8\u6642\u4FEE\u6539\u6216\u53D6\u6D88\u6B64\u512A\u60E0\uFF0C\u4E14\u7121\u9808\u4E8B\u5148\u901A\u77E5\u3002"
    }
  }
}
export default i18n
